import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import { connect } from 'react-redux';
import Article from 'grommet/components/Article';
import Heading from 'grommet/components/Heading';
import RadioButton from 'grommet/components/RadioButton';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Button from 'grommet/components/Button';
import Select from 'grommet/components/Select';
import CircleInformationIcon from 'grommet/components/icons/base/CircleInformation';
import Layer from 'grommet/components/Layer';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import { toggleSizeButton } from '../../State/actions/sessions';
import { fetchTemplateList, onepicequirements, Calbutn, controllerchnaged, oncalbluedataconfigtrue, GetGatewayRecommendations, GetControllerRecommendations, GetMasterRecommendations, oncalbluedataconfigfalse, fetchgatewaydlts, getosdisklistBlueData, errorclose, getTenantStorageDiskList } from '../Redux/actions/epaActions';
import { errorValidataion } from '../../State/actions/sessions';
import Paragraph from 'grommet/components/Paragraph';
import Spinning from 'grommet/components/icons/Spinning';
import ReactTooltip from 'react-tooltip';
import CheckBox from 'grommet/components/CheckBox';
import Label from 'grommet/components/Label';
import WarningIcon from 'grommet/components/icons/base/Alert';
import TableRow from 'grommet/components/TableRow';
import TrashIcon from 'grommet/components/icons/base/Trash';
import DataDrive from './DataDrive.js';
import DisplayTabs from './DisplayTabs.js';
import * as Constants from '../Redux/action_types/EPAConstants.js';
import { validateApollo4200SFFDrives, nodeStorageDriveQuantityOnBlurValidation, validateDriveChange, getGatewayandControllerHost, updateEzemeralGrowthItems, updateControllerHostCount, updateMasterHostCount, filterOptions, updateServiceLicenses, filterDriveList } from '../commonLogic.js';
import Warning from './Warning';
import * as commonConstants from '../../State/constants/CommonConstants';
let HostChanged = false;
var DatadriveChanged = false;
let totalgpus = 0;
let ComptNodeType, ComptNodeList, NonGPUProcType, NonGPUProcFamilyType, NonGPUMemory, NonGPUNodeCount, NonGPUOSDrive, NonGPUStrDrivetype;
let NonGPUProcList = [];
let NonGPUProcFamilyList = [];
let NonGPUMemoryList = [];
let NonGPUOSDriveList = [];
let NonGPUStrDrivetypeList = [];
let NonGPUTenantStoragedrivelist = [];
var EPICProclist = [];
var EPICGPUlist = [];
var List = [];
var GPUDisplay = 'none';
var NonGPUDisplay = "none";
var storageDisplay = "none";
var displayStorageTotals = "none";
let HAIncluded;
let GPUNodeType, GPUNodeList, GPUProcType, GPUProcFamilyType, GPUProcList, GPUProcFamilyList, GPUMemory, GPUMemoryList, GPUNodeCoount, GPUOSDrive, GPUStrDrivetype, GPUOSDriveList, GPUStrDrivetypeList, GPUTenantStoragedrivelist, GPUNodeStorageDriveQuantity, GPUTenantStoragedrive, GPUTenantStorageDriveQuantity;
let NonGPUNodeStorageDriveQuantity, NonGPUTenantStoragedrive, NonGPUTenantStorageDriveQuantity;
let HDFSTenatStr, HDFSrepFac, Allocationratio, KubClusters, GPUType;
let Globalvalue = "";
let selectchange = "";
var Templatedata = '';
var GPUList = '';
var NonGPUList = '';
let GPUcountList = [];
let GPUCount = '';
let HoustcountExceded = false;
let Minhostcount = '';
let Maxhostcount = '';
var nonGPUNoteText = "";
var GPUNoteText = "";
var StorageNoteText = "";
var nonGPUChanges = "";
var GPUChanges = "";
var StorageChanges = "";
let deleteTemplateConfirmation = "";
let nonGPUCost = "";
let GPUCost = "";
let proLiantDL360Gen10 = "ProLiant DL360 Gen10";
let proLiantDL380Gen10 = "ProLiant DL380 Gen10";
const PROLIANTXL190RGEN10 = "ProLiant XL190r Gen10";
const PROLIANTXL270DGEN10 = "ProLiant XL270d Gen10";
const HPE_APOLLO_4200_GEN10 = "HPE Apollo 4200 Gen10 Server";
const PROLIANT_XL170R_GEN10 = "ProLiant XL170r Gen10";
const HPE_MOONSHOT_SYSTEM = "HP Moonshot System";
const E920 = "e920";
const VIRTUALCLUSTERS = "Virtualclusters";
const VIRTUALNODESPERCLUSTER = "Virtualnodespercluster";
const CPUCORES = "CPUCores";
const MEMORY = "Memory";
const NODESTORAGE = "NodeStorage";
const PERSISTENT_STORAGE = "PersistentStorage";
const GPUS = "GPUs";
let maxGPUCount = 0;
let nvmeString = 'NVME';
let GPUTypeinComputeNode = false;
let computeGPUType = "";
let computeGPUTypeOptions = [];
const T4_GPU = "T4-PCIE-16GB";
const V100_32GB_GPU = "V100-PCIE-32GB";
const A100_40GB_GPU = "A100-PCIE-40GB";
const A100_PCIE_80GB_GPU = "A100-PCIE-80GB";
const A40_PCIE_48GB_GPU = "A40-PCIE-48GB";
const NON_GPU = "NonGPU";
const GPU = "GPU";
let Houstcountdata = '';
let storageHostsCheckBoxDisabled = true;
let storageHostChecked = false;
let storageMixedTenantStorage = "";
let saveWorkload = true;
let isValueChanged = false;
let updatePersistentStorage = true;
let makeNetworkCall = false;
let storageNodeType, STORAGE_HOST_OPTIONS, storageProcFamilyType, STORAGE_PROCESSORFAMILY_OPTIONS, storageProcType, STORAGE_PROCESSOR_OPTIONS, storageMemory, STORAGE_MEMORY_OPTIONS, storageNodeDrive, STORAGE_NODE_DRIVE_OPTIONS, storageNodeDriveQty, storageOSDrive, STORAGE_OSDRIVE_OPTIONS, storageTenantStorageDrive, STORAGE_TENANT_DRIVE_OPTIONS, storageTenantDriveQuantity, storageNodeCount, storageApproxCost, storageCost;
const INFERENCE_POPUP_TEXT = "Since \"Inference\" is added, Server platform can be either ProLiant DL360 Gen10 or ProLiant DL380 Gen10. Please remove the same and re-calculate the recommendations."
const NVMEMAX_POPUP_TEXT = "Maximum number of NVMe drives are already added.";
const OLDWL_TEXT = "The workload inputs are for older version of templates, please review and update the solution templates to new versions for new solution sizing";
const EOL_WORKLOAD_MESSAGE = "This workload/solution had contained EOL servers. Please recalculate to generate updated solution.";
const WARNING_TEXT = "Warning";
const ERROR_TEXT = "Error";
const COMPUTENODETYPE = "ComptNodeType"
const VISIBLE = "flex";
const NONE = "none";
const TRUE = "true";
const FALSE = "false";
let noteTextforLoadingOldSolutions = "";
let currentTabObject = "";
let configureInAllServicesText = false;
let overallConfigType = "";
let updateInitialConfigurations = true;
let defaultTemplate;
let trainingGPUvalue;
let isGPUvalueChanged = false;
// let hideGatewayHostChecked = false;

class DesignRequirements extends Component {
    constructor() {
        super();
        this.state = {
            maxKubernetesMemory: 930,
            maxEpicMemory: 963,
            nvmeMaxedOut: false,
            storageTenantDriveType: "",
            storageTenantDriveConsolidatedOptions: [],
            changeStorageTenantDriveTypeOptions: false,
            enableADDButton: true,
            MLOpsTemplatesCheckBox: false,
            MLOpsImageProcessingCheckBox: false
        };
        this.resetChangesToEmpty = this.resetChangesToEmpty.bind(this);
        this.textOnChangeofConfiguration = this.textOnChangeofConfiguration.bind(this);
        this.noteContent = this.noteContent.bind(this);
    }

    componentWillMount() {
        if (this.props.workload) {
            if (this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions === undefined) {
                this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions = FALSE;
            }
            if (this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange === undefined) {
                this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange = FALSE;
            }
            if (this.props.workload.UserInputs.Environments.Environment.filter(environment => environment["@isSelected"] === Constants.yES_).length > 0) {
                if (this.props.activeSession.treeView && this.props.workload.UserInputs.Environments.Environment.filter(environment => environment["@isSelected"] === Constants.yES_)[0].NonGPUValue === undefined) {
                    this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions = TRUE;
                }
            }
            if (this.props.workload.UserInputs.Environments.configureInAllServicesText === undefined) {
                this.props.workload.UserInputs.Environments.configureInAllServicesText = Constants.fALSE_;
            }
            if (this.props.workload.UserInputs.Environments.VMWareUserChoice === undefined) {
                this.props.workload.UserInputs.Environments.VMWareUserChoice = Constants.fALSE_;
            }
            if (this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice === undefined) {
                this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice = Constants.fALSE_;
            }
            if (this.props.workload.UserInputs.Environments.NimbleUserChoice === undefined) {
                this.props.workload.UserInputs.Environments.NimbleUserChoice = Constants.fALSE_;
            }
            let roleDetailsObject = {
                TotalVMemory: '',
                TotalCore: '',
                TotalStorage: '',
                Server: '',
                Proc: '',
                Memory: '',
                Drive: '',
                DriveQty: '',
                ServerQty: '',
                isCalculated: Constants.fALSE_,
            }
            this.props.workload.UserInputs.Environments.Environment.map(solution => {
                if (!solution.NonGPUValue) {
                    solution.NonGPUValue = { ...roleDetailsObject };
                }
                if (!solution.GPUValue) {
                    solution.GPUValue = { ...roleDetailsObject };
                }
                if (!solution.StorageValue) {
                    solution.StorageValue = { ...roleDetailsObject };
                }
                if (!Array.isArray(solution.Templates.ServerDetails.Server)) {
                    let singleRole = solution.Templates.ServerDetails.Server;
                    solution.Templates.ServerDetails.Server = [];
                    solution.Templates.ServerDetails.Server.push(singleRole);
                }
                if (!Array.isArray(solution.Templates.Template)) {
                    let singleTemplate = solution.Templates.Template;
                    solution.Templates.Template = [];
                    solution.Templates.Template.push(singleTemplate);
                }
                solution.Templates.ServerDetails.Server.map(role => {
                    if (role["@Type"] === Constants.STORAGE_) {
                        if (role["@mixedTenantStorage"] === undefined) {
                            role["@mixedTenantStorage"] = Constants.FALSE_;
                        }
                        if (role["@TenantDriveType"] === undefined) {
                            role["@TenantDriveType"] = "";
                        }
                        if (role.PersistentDisks === undefined || !Array.isArray(role.PersistentDisks)) {
                            let persistentDriveSize = '';
                            if (role.PersistentDisks) {
                                persistentDriveSize = role.PersistentDisks.Item[Constants.SIZE_ATTRIBUTE];
                            }
                            let TenantDiskArray = [
                                {
                                    Item: {
                                        "@size": persistentDriveSize,
                                        '@disk': role['@TStorageDrive'],
                                        '@qty': role['@TStorageDriveQty'],
                                        "@volumeName": Constants.PERSISTENT_
                                    }
                                }
                            ]
                            role.PersistentDisks = TenantDiskArray;
                        }
                    }
                })
            });
            currentTabObject = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_);
            HAIncluded = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@HAIncluded"] === Constants.fALSE_ ? false : true;
            if (HAIncluded) {
                this.ChkboxChange(false, false);
            }
        }
    }

    componentWillUnmount() {
        if (this.props.workload) {
            this.props.ServiceError.guiState.displayWarning = false;
            this.props.workload.UserInputs.Environments.Environment.filter(service => service["@isSelected"] === Constants.yES_).map(selectedService => {
                if (selectedService.NonGPUValue.isCalculated === Constants.fALSE_ && selectedService.GPUValue.isCalculated === Constants.fALSE_ && selectedService.StorageValue.isCalculated === Constants.fALSE_) {
                    this.props.ServiceError.guiState.displayWarning = true;
                }
            })
        }
    }

    updateMixedDrivesArray = () => {
        var storageObject = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0];
        if (storageObject["@mixedTenantStorage"] === Constants.FALSE_) {
            let persistentDriveSize = '';
            let persistentDrivesArray = '';
            if (currentTabObject.Templates.ServerDetails.Server.find(x => x["@Type"] === Constants.STORAGE_)) {
                persistentDrivesArray = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks;
            }
            if (!Array.isArray(persistentDrivesArray)) {
                persistentDriveSize = persistentDrivesArray.Item[Constants.SIZE_ATTRIBUTE];
            } else if (persistentDrivesArray.length > 0) {
                persistentDriveSize = persistentDrivesArray[0].Item[Constants.SIZE_ATTRIBUTE];
            }
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks = [];
            var newDrive = {
                Item: {
                    "@size": persistentDriveSize,
                    '@disk': storageObject["@TStorageDrive"],
                    '@qty': storageObject["@TStorageDriveQty"],
                    "@volumeName": Constants.PERSISTENT_,
                }
            }
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.push(newDrive);
        }
    }
    makeisCalculatedFalse = () => {
        currentTabObject.NonGPUValue.isCalculated = Constants.fALSE_;
        currentTabObject.GPUValue.isCalculated = Constants.fALSE_;
        currentTabObject.StorageValue.isCalculated = Constants.fALSE_;
        if (currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_).length > 0) {
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@mixedTenantStorage"] = Constants.FALSE_;
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks = [];
        }
    }

    onConfigurationChange = (event) => {
        currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"] = event.value;
        this.calculateRecommendationButtonValidation();
        this.setState({});
    }

    onKeyPressed(e) {
        if (e.keyCode == 13) {
            e.stopPropagation();
        }
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (this.props.ServiceError.guiState.updateManagementDetails) {
            const gatewayServer = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@Name"]
            const configMode = currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"];
            const gatewayPayload = {
                "strServer": gatewayServer,
                "strHostType": Constants.GATEWAY_HOST,
                "strConfigMode": configMode,
                "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.VMWareUserChoice
            }
            this.props.GatewayRecommendations(gatewayPayload);

            const controllerServer = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@Name"]
            const controllerPayload = {
                "strServer": controllerServer,
                "strHostType": Constants.CONTROLLER_HOST,
                "strConfigMode": configMode,
                "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.VMWareUserChoice
            }
            this.props.ControllerRecommendations(controllerPayload);

            const masterServer = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@Name"]
            const masterPayload = {
                "strServer": masterServer,
                "strHostType": Constants.MASTER_HOST,
                "strConfigMode": configMode,
                "isControllerHostVMWareChecked": this.props.workload.UserInputs.Environments.MasterVMWareUserChoice
            }
            this.props.MasterRecommendations(masterPayload);

            this.props.ServiceError.guiState.GandCAPICount = 3;
            this.props.ServiceError.guiState.updateManagementDetails = false;
        }
        if (this.props.calculateBlueDataAPIcount !== nextProps.calculateBlueDataAPIcount && nextProps.calculateBlueDataAPIcount !== undefined && nextProps.calculateBlueDataAPIcount === 0) {
            this.props.CalculateBlueDataConfigurationtrue(this.props.sizerWorkloadforCalculation.value);
        }
        if (this.props.calculateWithUpdatedTenantDrive) {
            var roleType = this.props.currentRoleName;
            var value = {
                "input": {
                    "Workload": null,
                },
                "Inputsnotchanged": false,
                "RoleType": roleType
            }
            value.input.Workload = this.props.workload;
            this.props.calculateWithUpdatedTenantDriveAction(false);
            this.props.currentRoleNameAction("");
            this.props.CalculateBlueDataConfigurationfalse(value);
        }
        if (NonGPUOSDriveList != nextProps.NonGPUList) {
            this.setState({});
        }
    }
    textOnChangeofConfiguration(requirementType, changedValue) {
        var changes = ""
        switch (changedValue) {
            case "HostType":
                changes = ",Host Type";
                break;
            case "ProcessorFamily":
                changes = ",Processor Family";
                break;
            case "Processor":
                changes = ",Processor Type";
                break;
            case "Memory":
                changes = ",Memory";
                break;
            case Constants.NODE_STORAGE_DRIVE:
                changes = "," + Constants.EPHEMERAL_STORAGE_DRIVE;
                break;
            case Constants.NODE_STORAGE_DRIVE_QTY:
                changes = "," + Constants.EPHEMERAL_STORAGE_DTIVE_QUANTITY;
                break;
            case "OSDrive":
                changes = ",OS Drive"
                break;
            case "DriveType":
                changes = ",Persistent Drive Type";
                break;
            case "LocalTenantDrive":
                changes = ",Persistent Drive"
                break;
            case "LocalTenantDriveQty":
                changes = "Persistent Drive Quantity";
                break;
            case "GPUType":
                changes = ",GPU Type";
                break;
            case "HostCount":
                changes = ",Host Count";
                break;
            case "GPUCountPerServer":
                changes = ",GPU Count Per server";
                break;
        }
        switch (requirementType) {
            case "GPU":
                GPUChanges += changes;
                break;
            case "nonGPU":
                nonGPUChanges += changes;
                break;
            case Constants.STORAGE_:
                StorageChanges += changes;
        }
    }

    resetChangesToEmpty() {
        GPUChanges = ""
        nonGPUChanges = ""
        StorageChanges = ""
    }

    noteContent(Final_Note, requirementType) {
        var final_note = Final_Note
        var final_text = " "
        if (final_note === "")
            return "";
        var text1 = final_note.split(",");
        if (text1.length === 1) {
            final_text = text1[0] + " is changed";
        }
        else if (text1.length > 1) {
            for (let i = 0; i < text1.length; i++) {
                if (i == text1.length - 2) {
                    final_text = final_text + text1[i] + " and ";
                }
                else if (i == text1.length - 1) {
                    final_text = final_text + text1[i] + " are changed";
                }
                else {
                    final_text = final_text + text1[i] + ", ";
                }
            }
        }
        var noteTextOnChangeOfConfiguration =
            <Box direction="row">
                <Label style={{ color: '#01a982' }}></Label>
                <Paragraph style={{ maxWidth: '100%', marginLeft: '1%', marginTop: '27px', color: '#01a982' }}><b>Note :</b>{final_text}</Paragraph>
            </Box>
        if (requirementType === "GPU") {
            GPUNoteText = noteTextOnChangeOfConfiguration;
        }
        else if (requirementType === "nonGPU") {
            nonGPUNoteText = noteTextOnChangeOfConfiguration;
        }
        else if (requirementType === Constants.STORAGE_) {
            StorageNoteText = noteTextOnChangeOfConfiguration;
        }
    }

    checkValues = () => {
        let NoValues = true;
        let MlopsImageProcessingCheck = false;
        let InferenceImagePerSec = true;
        let TrainingImagePerSec = true;
        currentTabObject.Templates.Template.filter((x, id) => {
            if (x[Constants.ATTRIBUTE_TYPE] !== Constants.CUSTOM_TEMPLATE && x[Constants.ATTRIBUTE_TYPE] !== Constants.CUSTOM_WGPUS) {
                if (parseInt(x.Nodes[Constants.ATTRIBUTE_VCLUSTERS], 10) !== 0 && parseInt(x.Nodes[Constants.ATTRIBUTE_NODESPERCLUSTER], 10) !== 0) {
                    NoValues = false
                }
            } else {
                if (parseInt(x.Nodes[Constants.ATTRIBUTE_VCLUSTERS], 10) !== 0 && parseInt(x.Nodes[Constants.ATTRIBUTE_NODESPERCLUSTER], 10) !== 0 && parseInt(x.Nodes[Constants.ATTRIBUTE_VCPUPERNODE], 10) !== 0 &&
                    parseInt(x.Nodes[Constants.ATTRIBUTE_VMEMORYPERNODE], 10) !== 0 && parseInt(x.Nodes[Constants.ATTRIBUTE_VSTORAGEPERNODE], 10) !== 0) {
                    NoValues = false
                }
            }
            if (x[Constants.ATTRIBUTE_TYPE] === Constants.TRAINING || x[Constants.ATTRIBUTE_TYPE] === Constants.INFERENCE_) {
                MlopsImageProcessingCheck = true
                if (x[Constants.ATTRIBUTE_TYPE] === Constants.INFERENCE_ && parseInt(x.Nodes[Constants.IMAGE_PER_SEC], 10) !== 0) {
                    InferenceImagePerSec = false
                }
                if (x[Constants.ATTRIBUTE_TYPE] === Constants.TRAINING && parseInt(x.Nodes[Constants.IMAGE_PER_SEC], 10) !== 0) {
                    TrainingImagePerSec = false
                }
            }

        })

        if (MlopsImageProcessingCheck && InferenceImagePerSec && TrainingImagePerSec) {
            NoValues = true
        }
        return NoValues;
    }
    componentDidMount() {
        if (this.props.workload.ServicesInput === undefined && this.props.sessionsDefaults.inputs !== "") {
            this.props.onUpdateDefaultSession(this.props.sessionsDefaults.inputs);
        }

        this.resetChangesToEmpty();
        document.addEventListener("keydown", this.onKeyPressed.bind(this));
        this.onCalcTempClick();
        var value = {
            "strHostType": "GPU",
            "strHDFSRawSize": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],
            "strHDFSRepFactor": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
        }
        if (this.props.GPUdetails === null) {
            this.props.OnGatewaydltsfetch(value);
        }

        var input = {
            "strHostType": "NonGPU",
            "strHDFSRawSize": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],
            "strHDFSRepFactor": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
        }
        if (this.props.NonGPUdetails === null) {
            this.props.OnGatewaydltsfetch(input);
        }
        var value1 = {
            "strHostType": "Gateway",
            "strHDFSRawSize": null,
            "strHDFSRepFactor": null
        }

        if (this.props.gatewaydetails === null)
            this.props.OnGatewaydltsfetch(value1);

        var inputs1 = {
            "strHostType": "Controller",
            "strHDFSRawSize": null,
            "strHDFSRepFactor": null
        }
        if (this.props.controllerdetails === null)
            this.props.OnGatewaydltsfetch(inputs1);

        var masterInputs = {
            "strHostType": "Master",
            "strHDFSRawSize": null,
            "strHDFSRepFactor": null
        }
        if (this.props.masterdetails === null)
            this.props.OnGatewaydltsfetch(masterInputs);

        var storageInputs = {
            "strHostType": Constants.STORAGE_HOST_ROLE_NAME,
            "strHDFSRawSize": null,
            "strHDFSRepFactor": null
        }
        if (this.props.Storagedetails === null)
            this.props.OnGatewaydltsfetch(storageInputs);

        if (this.props.Templates === null)
            this.props.OnFetchTemplateList();

        var inputs = {
            "dHDFSStorage": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],
            "dHDFSRepFactor": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
        }
        if (this.props.Epicreq === null) {
            this.props.EPICRequirements(inputs)
        }

        if (currentTabObject["@isSelected"] === Constants.yES_) {
            let NoValues = this.checkValues();
            if (NoValues || this.props.ConfigButton) {
                this.props.Calcbutton(true)
            }
            if (NoValues || !this.props.ConfigButton) {
                if (this.props.activeSession.isSizeEnabled) {
                    this.props.OnToggleSizeButton(false);
                }
            }

            if (this.props.activeSession.isSizeEnabled) {
                this.updateFinishButton();
            } else {
                if (currentTabObject.NonGPUValue.isCalculated === Constants.tRUE_ || currentTabObject.GPUValue.isCalculated === Constants.tRUE_ || currentTabObject.StorageValue.isCalculated === Constants.tRUE_) {
                    this.updateFinishButton();
                }
            }
        }

        if (updateInitialConfigurations) {
            if (currentTabObject["@SolutionType"] === Constants.CAAS_) {
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@VMWare"] = Constants.tRUE_;
            }
            updateInitialConfigurations = false;
        }

        if (!Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License) || this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.length === 2 || this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License === undefined) {

            let License = [
                {
                    "@Description": 'None',
                    "@IsSelected": "true",
                    "@Type": "BlueData"
                },
                {
                    "@Description": "None",
                    "@IsSelected": "false",
                    "@Type": "BlueDataAI"
                },
                {
                    "@Description": "24x7 1y",
                    "@IsSelected": "true",
                    "@Type": "HPE Container Platform"
                },
            ]

            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License = License
        }
        if (this.props.sessionsDefaults.inputs) {
            updateServiceLicenses(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses, this.props.sessionsDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License);
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration = {
                '@Type': 'EPIC',
            }
        }

        if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)['@Name'].indexOf(Constants.MOONSHOT_510) !== -1) {
            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)['@OSDiskQty'] = "1"
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.Deployment === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.Deployment = 'false';
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.AppStore === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.AppStore = 'false';
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.Installation === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.Installation = 'false';
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.SingleImage === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.SingleImage = {
                "@Qty": "1",
                "#text": "false"
            }
        }
        if (this.props.workload.UserInputs.Environments.HadoopServices.CustomImage === undefined) {
            this.props.workload.UserInputs.Environments.HadoopServices.CustomImage = {
                "@Qty": "1",
                "#text": "false"
            }
        }
        if (this.props.country !== undefined) {
            this.props.workload.UserInputs.Country = this.props.country;
        }
    }

    saveOldWorkloads = () => {
        const index1 = currentTabObject.Templates.ServerDetails.Server.findIndex(x => x['@Type'] === Constants.NONGPU_);
        if (index1 >= 0) {
            this.props.ServiceError.nonGPUOldWorkload = JSON.parse(JSON.stringify(currentTabObject.Templates.ServerDetails.Server[index1]));
        }
        const index2 = currentTabObject.Templates.ServerDetails.Server.findIndex(x => x['@Type'] === Constants.GPU_);
        if (index2 >= 0) {
            this.props.ServiceError.GPUOldWorkload = JSON.parse(JSON.stringify(currentTabObject.Templates.ServerDetails.Server[index2]));
        }
        const index3 = currentTabObject.Templates.ServerDetails.Server.findIndex(x => x['@Type'] === Constants.STORAGE_);
        if (index3 >= 0) {
            this.props.ServiceError.StorageOldWorkload = JSON.parse(JSON.stringify(currentTabObject.Templates.ServerDetails.Server[index3]));
        }
    }

    setPersistentStorageMinValue = () => {
        var persistentStorageMinimumValue = 0;
        currentTabObject.Templates.Template.map(x => {
            if (x["@Type"] !== Constants.NONE_ && !(this.props.SSETid && currentTabObject["@SolutionType"] === Constants.MLOPS && x["@Type"] === Constants.DATA_FABRIC)) {
                persistentStorageMinimumValue += parseInt(x.Nodes["@PersistentStorage"], 10) * parseInt(x.Nodes["@vClusters"], 10);
            }
        })
        persistentStorageMinimumValue = persistentStorageMinimumValue / 1024;
        if (persistentStorageMinimumValue % 1 != 0) {
            persistentStorageMinimumValue = parseInt(persistentStorageMinimumValue, 10) + 1;
        }
        if (this.props.SSETid && currentTabObject["@SolutionType"] === Constants.MLOPS) {
            let MLOpsStorageTemplate = currentTabObject.Templates.Template.find(template => template["@Type"] === Constants.DATA_FABRIC);
            if (MLOpsStorageTemplate) {
                persistentStorageMinimumValue += parseInt(MLOpsStorageTemplate.Nodes["@PersistentStorage"], 10);
            }
        }
        return persistentStorageMinimumValue.toString()
    }

    noOfNonStorageTemplates = () => {
        var nonStoragetemplates = currentTabObject.Templates.Template.filter(template => (template["@Type"].indexOf(Constants.STORAGE_) === -1 && template["@Type"] !== Constants.NONE_));
        return nonStoragetemplates.length
    }

    storageHostCheckBoxchange = () => {
        storageHostChecked = storageHostChecked ? false : true;
        if (storageHostChecked) {
            currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"] = "yes";
        } else {
            currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"] = "no";
            if (Array.isArray(currentTabObject.Templates.ServerDetails.Server)) {
                let host = currentTabObject.Templates.ServerDetails.Server.filter((item) => item['@RoleName'] === 'Storage Host')[0];
                if (host) {
                    let count = 0;
                    host['@NodesCount'] = count;
                }
            }

        }
        this.calculateRecommendationButtonValidation();
        this.setState({})
    }

    // hideGatewayHostCheckBoxchange = () => {
    //     hideGatewayHostChecked = hideGatewayHostChecked ? false : true;
    //     this.setState({})
    // }

    storageHostAllOptions = (fromRender) => {
        STORAGE_HOST_OPTIONS = [];
        STORAGE_PROCESSORFAMILY_OPTIONS = [];
        STORAGE_PROCESSOR_OPTIONS = [];
        STORAGE_MEMORY_OPTIONS = [];
        STORAGE_NODE_DRIVE_OPTIONS = [];
        STORAGE_OSDRIVE_OPTIONS = [];
        STORAGE_TENANT_DRIVE_OPTIONS = [];
        var storageHostSupportedList = this.props.Storagedetails;
        for (let key in storageHostSupportedList) {
            STORAGE_HOST_OPTIONS.push(key);
        }
        if (STORAGE_HOST_OPTIONS.indexOf(storageNodeType) === -1) {
            storageNodeType = STORAGE_HOST_OPTIONS[0];
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@Name"] = storageNodeType;
            this.textOnChangeofConfiguration(Constants.STORAGE_, "HostType");
        }
        for (let key in storageHostSupportedList[storageNodeType].ProcessorList) {
            STORAGE_PROCESSORFAMILY_OPTIONS.push(key);
        }
        if (STORAGE_PROCESSORFAMILY_OPTIONS.indexOf(storageProcFamilyType) === -1) {
            storageProcFamilyType = STORAGE_PROCESSORFAMILY_OPTIONS[0];
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@ProcFamily"] = storageProcFamilyType;
            this.textOnChangeofConfiguration(Constants.STORAGE_, "ProcessorFamily");
        }
        for (let key in storageHostSupportedList[storageNodeType].ProcessorList[storageProcFamilyType]) {
            STORAGE_PROCESSOR_OPTIONS.push(key);
        }
        STORAGE_PROCESSOR_OPTIONS = filterOptions(STORAGE_PROCESSOR_OPTIONS, currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"], Constants.STORAGE_, Constants.PROCESSOR_);
        if (STORAGE_PROCESSOR_OPTIONS.filter(processor => processor.indexOf(storageProcType) > -1).length == 0) {
            storageProcType = STORAGE_PROCESSOR_OPTIONS[0];
            this.textOnChangeofConfiguration(Constants.STORAGE_, "Processor");
        }
        else {
            storageProcType = STORAGE_PROCESSOR_OPTIONS.filter(processor => processor.indexOf(storageProcType) > -1)[0];
        }
        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@Proc"] = storageProcType;
        STORAGE_MEMORY_OPTIONS = storageHostSupportedList[storageNodeType].ProcessorList[storageProcFamilyType][storageProcType];
        STORAGE_MEMORY_OPTIONS = filterOptions(STORAGE_MEMORY_OPTIONS, currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"], Constants.STORAGE_, Constants.MEMORY_);
        if (STORAGE_MEMORY_OPTIONS.indexOf(storageMemory) === -1) {
            storageMemory = STORAGE_MEMORY_OPTIONS[0];
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@Memory"] = storageMemory;
            this.textOnChangeofConfiguration(Constants.STORAGE_, "Memory");
        }
        STORAGE_NODE_DRIVE_OPTIONS = storageHostSupportedList[storageNodeType].DataDriveList;
        STORAGE_NODE_DRIVE_OPTIONS = filterOptions(STORAGE_NODE_DRIVE_OPTIONS, currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"], Constants.STORAGE_, Constants.DISK_);
        if (STORAGE_NODE_DRIVE_OPTIONS.indexOf(storageNodeDrive) === -1) {
            storageNodeDrive = STORAGE_NODE_DRIVE_OPTIONS[0];
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@NodeDisk"] = storageNodeDrive;
            this.textOnChangeofConfiguration(Constants.STORAGE_, "NodeStorageDrive");
        }
        STORAGE_OSDRIVE_OPTIONS = storageHostSupportedList[storageNodeType].OSDriveList;
        if (STORAGE_OSDRIVE_OPTIONS.indexOf(storageOSDrive) === -1) {
            storageOSDrive = STORAGE_OSDRIVE_OPTIONS[0];
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@OSDisk"] = storageOSDrive;
            this.textOnChangeofConfiguration(Constants.STORAGE_, "OSDrive");
        }
        if (fromRender === true) {
            this.populateDrivesandResetIfRequired();
        }
        this.updateMixedDrivesArray();
    }

    populateDrivesandResetIfRequired = () => {
        this.populateDriveOptions(Constants.STORAGE_);
        STORAGE_TENANT_DRIVE_OPTIONS = filterOptions(STORAGE_TENANT_DRIVE_OPTIONS, currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"], Constants.STORAGE_, Constants.PERSISTENT_ + Constants.DISK_);
        if (STORAGE_TENANT_DRIVE_OPTIONS.indexOf(storageTenantStorageDrive) === -1) {
            storageTenantStorageDrive = STORAGE_TENANT_DRIVE_OPTIONS[0];
            makeNetworkCall = true;
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDrive"] = storageTenantStorageDrive;
            this.textOnChangeofConfiguration(Constants.STORAGE_, "LocalTenantDrive")
        }
    }

    populateDriveOptions = (roleName) => {
        let drivesArray = [];
        this.state.storageTenantDriveType = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === roleName)[0]["@TenantDriveType"];
        storageMixedTenantStorage = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === roleName)[0]["@mixedTenantStorage"];
        let serverName = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === roleName)[0]["@Name"];
        drivesArray = this.props.Storagedetails[serverName].StorageTenantDrives;
        if (storageMixedTenantStorage === "True") {
            var existingDrives = [];
            var existingDriveTypes = [];
            var temp = [];
            const resetTemp = () => {
                drivesArray = [];
                drivesArray = temp;
                temp = [];
            }
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === roleName)[0].PersistentDisks.map(x => {
                existingDrives.push(x.Item["@disk"]);
            });
            this.props.Storagedetails[serverName].StorageTenantDrives.map(x => {
                if (existingDrives.indexOf(x.StrDrive) !== -1) {
                    x.Types.map(y => {
                        if (existingDriveTypes.indexOf(y) === -1) {
                            existingDriveTypes.push(y);
                        }
                    })
                }
            });

            if (serverName !== HPE_APOLLO_4200_GEN10) {
                if (existingDriveTypes.indexOf('LFF HDD') !== -1 || existingDriveTypes.indexOf('LFF SSD') !== -1) {
                    drivesArray.map(x => {
                        if (x.Types.indexOf('SFF HDD') === -1 && x.Types.indexOf('SFF SSD') === -1) {
                            temp.push(x)
                        }
                    })
                } else if (existingDriveTypes.indexOf('SFF HDD') !== -1 || existingDriveTypes.indexOf('SFF SSD') !== -1) {
                    drivesArray.map(x => {
                        if (x.Types.indexOf('LFF HDD') === -1 && x.Types.indexOf('LFF HDD') === -1) {
                            temp.push(x)
                        }
                    })
                }
                else {
                    drivesArray.map(x => {
                        temp.push(x)
                    })
                }
                resetTemp();
            }

            if (existingDriveTypes.indexOf('SFF SAS SSD') !== -1 || existingDriveTypes.indexOf('SFF SAS HDD') !== -1 || existingDriveTypes.indexOf('LFF SAS SSD') !== -1 || existingDriveTypes.indexOf('LFF SAS HDD') !== -1 || existingDriveTypes.indexOf('NVMe') !== -1) {
                drivesArray.map(x => {
                    if (x.Types.indexOf('LFF SATA HDD') === -1 && x.Types.indexOf('SFF SATA HDD') === -1) {
                        temp.push(x);
                    }
                    else if (existingDriveTypes.indexOf('SFF SAS SSD') === -1 && existingDriveTypes.indexOf('SFF SAS HDD') === -1 && existingDriveTypes.indexOf('LFF SAS SSD') === -1 && existingDriveTypes.indexOf('LFF SAS HDD') === -1 && existingDriveTypes.indexOf('NVMe') !== -1 && serverName === HPE_APOLLO_4200_GEN10) {
                        temp.push(x);
                    }
                })
            }
            else {
                drivesArray.map(x => {
                    temp.push(x)
                })
            }
            resetTemp();

            if (existingDriveTypes.indexOf('SFF SATA HDD') !== -1 || existingDriveTypes.indexOf('LFF SATA HDD') !== -1) {
                drivesArray.map(x => {
                    if (x.Types.indexOf('SFF SAS SSD') === -1 && x.Types.indexOf('SFF SAS HDD') === -1 && x.Types.indexOf('LFF SAS SSD') === -1 && x.Types.indexOf('LFF SAS HDD') === -1 && x.Types.indexOf('NVMe') === -1) {
                        temp.push(x);
                    }
                    else if (x.Types.indexOf('SFF SAS SSD') === -1 && x.Types.indexOf('SFF SAS HDD') === -1 && x.Types.indexOf('LFF SAS SSD') === -1 && x.Types.indexOf('LFF SAS HDD') === -1 && x.Types.indexOf('NVMe') !== -1 && serverName === HPE_APOLLO_4200_GEN10) {
                        temp.push(x);
                    }
                })
            }
            else {
                drivesArray.map(x => {
                    temp.push(x)
                })
            }
            resetTemp();
        }
        else {

        }
        if (roleName === Constants.STORAGE_) {
            if (this.state.storageTenantDriveConsolidatedOptions.length === 0 || this.state.changeStorageTenantDriveTypeOptions) {
                this.state.changeStorageTenantDriveTypeOptions = false;
                this.state.storageTenantDriveConsolidatedOptions = [];
                drivesArray.map(drive => {
                    drive.Types.map(type => {
                        if (this.state.storageTenantDriveConsolidatedOptions.indexOf(type) === -1) {
                            this.state.storageTenantDriveConsolidatedOptions.push(type);
                        }
                    })
                })
            }
            if (this.state.storageTenantDriveType === "" || this.state.storageTenantDriveConsolidatedOptions.indexOf(this.state.storageTenantDriveType) === -1) {
                this.state.storageTenantDriveType = this.state.storageTenantDriveConsolidatedOptions[0];
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === roleName)[0]["@TenantDriveType"] = this.state.storageTenantDriveType;
                this.textOnChangeofConfiguration(Constants.STORAGE_, "DriveType");
            }
            STORAGE_TENANT_DRIVE_OPTIONS = [];
            drivesArray.map(x => {
                if (x.Types.indexOf(this.state.storageTenantDriveType) !== -1)
                    STORAGE_TENANT_DRIVE_OPTIONS.push(x.StrDrive);
            });
        }
    }
    onStorageTenantDriveTypeChange = (e) => {
        if (this.state.storageTenantDriveType !== e.option) {
            let isValid = true;
            var oldDriveType = this.state.storageTenantDriveType;
            var oldPersitentDrive = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDrive"];
            this.state.storageTenantDriveType = e.option;
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TenantDriveType"] = this.state.storageTenantDriveType;
            this.populateDrivesandResetIfRequired();
            let storageObject = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0];
            isValid = this.isCompatibleDrive(Constants.STORAGE_);
            if (isValid) {
                isValid = validateDriveChange(storageObject["@NodeDisk"], storageObject["@OSDisk"], storageObject["@TStorageDrive"], storageObject["@Name"])
            }
            let array = this.noOfStorageTenantDrivesLeft(Constants.TENANT, false, false, "", true);
            if (!isValid || array[2]) {
                this.state.storageTenantDriveType = oldDriveType;
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TenantDriveType"] = this.state.storageTenantDriveType;
                this.populateDrivesandResetIfRequired();
                makeNetworkCall = false;
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDrive"] = oldPersitentDrive;
                if (array[2]) {
                    if (currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@OSDisk"].indexOf("M.2") > -1) {
                        array[1] = 26;
                    } else {
                        array[1] = 24;
                    }
                    Houstcountdata = this.renderErrorPopup(Constants.MAXDRIVEQTY_EXCEEDED[0] + array[1] + Constants.MAXDRIVEQTY_EXCEEDED[1], ERROR_TEXT);
                } else {
                    var text = "The selected drive type has no drives that are compatible with existing drives."
                    Houstcountdata = this.renderErrorPopup(text, Constants.WARNING_TEXT);
                }
            } else {
                storageTenantDriveQuantity = array[0];
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
            }
            if (makeNetworkCall) {
                currentTabObject.displayNotePersistentDriveChange = TRUE;
                makeNetworkCall = false;
                this.updateMixedDrivesArray();
                this.makeStorageHostCustomisationNetworkCall();
            }

            this.setState({});
        }
    }

    addStorageTenanatDrive = () => {
        if (storageTenantStorageDrive !== undefined && storageTenantDriveQuantity != "0") {
            let existingDrivesArray = [];
            var validCombination = true;
            if (storageNodeType === HPE_APOLLO_4200_GEN10 && (storageTenantStorageDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) !== -1 || storageTenantStorageDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1)) {
                storageMixedTenantStorage = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@mixedTenantStorage"];
                existingDrivesArray = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks;
                if (storageMixedTenantStorage === "True") {
                    let nonNVMeDrives = 0
                    let NVMeDrives = 0
                    let SFFDrives = 0
                    existingDrivesArray.map(x => {
                        if (x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) === -1 && x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) === -1) {
                            nonNVMeDrives += parseInt(x.Item["@qty"], 10)
                        } else if (x.Item["@disk"].indexOf('NVMe') !== -1) {
                            NVMeDrives += parseInt(x.Item["@qty"], 10)
                        } else {
                            SFFDrives += parseInt(x.Item["@qty"], 10)
                        }
                    })
                    if (storageTenantStorageDrive.indexOf("NVMe") !== -1 && SFFDrives > 0) {
                        validCombination = false
                    } else if (storageTenantStorageDrive.indexOf("NVMe") === -1 && NVMeDrives > 0) {
                        validCombination = false
                    }
                    if (storageOSDrive.indexOf("M.2") !== -1) {
                        if (nonNVMeDrives > 24) {
                            validCombination = false
                        }
                    } else {
                        if (nonNVMeDrives > 22) {
                            validCombination = false
                        }
                    }
                    if (!validCombination) {
                        let text = "Drive cannot be added as the maximum drives exceeded."
                        Houstcountdata = this.renderErrorPopup(text, ERROR_TEXT);
                    }
                }
            }

            if (validCombination) {
                let drivesLeftArray = this.noOfStorageTenantDrivesLeft(Constants.TENANT, true, false, "", false);
                if (parseInt(storageTenantDriveQuantity, 10) <= drivesLeftArray[0]) {
                    let numberOfDisks = "";
                    storageMixedTenantStorage = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@mixedTenantStorage"];
                    if (storageMixedTenantStorage === "False") {
                        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks = [];
                    }
                    storageMixedTenantStorage = "True";
                    currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@mixedTenantStorage"] = storageMixedTenantStorage;
                    existingDrivesArray = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks;
                    numberOfDisks = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.length;
                    let pushDrive = true;
                    if (numberOfDisks > 0) {
                        existingDrivesArray.map(x => {
                            if (x.Item["@disk"] === storageTenantStorageDrive) {
                                x.Item["@qty"] = (parseInt(x.Item["@qty"], 10) + parseInt(storageTenantDriveQuantity, 10)).toString()
                                pushDrive = false
                            }
                        })
                    }
                    if (pushDrive) {
                        var newDrive = {
                            Item: {
                                '@disk': storageTenantStorageDrive,
                                '@qty': storageTenantDriveQuantity,
                                "@volumeName": Constants.PERSISTENT_,
                            }
                        }
                        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.push(newDrive);
                        this.state.changeStorageTenantDriveTypeOptions = true;
                    }
                    this.updateStorageTenantDriveQuantity();
                    this.makeStorageHostCustomisationNetworkCall();
                    //this.textOnChangeofConfiguration(Constants.STORAGE_,"LocalTenantDriveQty");
                } else {
                    Houstcountdata = this.renderErrorPopup(Constants.MAXDRIVEQTY_EXCEEDED[0] + drivesLeftArray[1] + Constants.MAXDRIVEQTY_EXCEEDED[1], ERROR_TEXT);
                }
            }
            this.setState({});
        }
    }

    renderStorageTenantDriveTable = () => {
        let tableData = [];
        let tableDataArray = ""
        if (currentTabObject.Templates.ServerDetails.Server.find(x => x["@Type"] === Constants.STORAGE_)) {
            tableDataArray = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks;
            if (Array.isArray(tableDataArray)) {
                tableDataArray.map((storageTenantDrive, id) => {
                    tableData.push(
                        <TableRow>
                            <td>{storageTenantDrive.Item["@disk"]}</td>
                            <td><TextInput value={storageTenantDrive.Item["@qty"]} onDOMChange={(e) => this.storageTextChange(e, Constants.STORAGE_TENANT_DRIVE_QUANTITY, Constants.CHANGE, true, id)} onBlur={(e) => this.storageTextChange(e, Constants.STORAGE_TENANT_DRIVE_QUANTITY, Constants.BLUR, true, id)} /></td>
                            <td><TrashIcon primary={true} onClick={() => { this.deleteStorageTenantDrive(id) }} /></td>
                        </TableRow>
                    )
                })
            }
        }
        return tableData;
    }

    deleteStorageTenantDrive = (id) => {
        if (currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.length === 1) {
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@mixedTenantStorage"] = "False";
            this.updateMixedDrivesArray();
        }
        storageTenantDriveQuantity = this.noOfStorageTenantDrivesLeft(Constants.TENANT, false, true, id, false)[0];
        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.splice(id, 1);
        if (currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.length === 0) {
            storageMixedTenantStorage = "False";
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@mixedTenantStorage"] = storageMixedTenantStorage;
        }
        this.updateMixedDrivesArray();
        this.state.changeStorageTenantDriveTypeOptions = true;
        //this.updateStorageTenantDriveQuantity();
        this.makeStorageHostCustomisationNetworkCall();
        this.setState({});
    }

    updateStorageTenantDriveQuantity = () => {
        storageTenantDriveQuantity = this.noOfStorageTenantDrivesLeft(Constants.TENANT, false, false, "", false)[0];
        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
    }

    noOfStorageTenantDrivesLeft = (Drive, changingDriveQty, editExisting, driveID, driveTypeChanged) => {
        var storageObject = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0];
        var maxDrives = 0;
        var noOfDrivesLeft = 0;
        var noOfNVMEDrives = 0;
        var noOfNonNVMEDrives = 0;
        var mainDrive = '';
        var maxDrivesAdded = false;

        if (Drive !== Constants.NODE) {
            if ((storageObject["@NodeDisk"].toUpperCase().indexOf(nvmeString) > -1) || (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (storageObject["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || storageObject["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                noOfNVMEDrives += parseInt(storageObject["@StorageDiskQty"], 10);
            } else {
                noOfNonNVMEDrives += parseInt(storageObject["@StorageDiskQty"], 10);
            }
        }

        if (storageObject["@OSDisk"].toUpperCase().indexOf(nvmeString) > -1) {
            noOfNVMEDrives += parseInt(storageObject["@OSDiskQty"], 10);
        } else {
            noOfNonNVMEDrives += parseInt(storageObject["@OSDiskQty"], 10);
        }

        if (storageObject["@mixedTenantStorage"] === "True") {
            storageObject.PersistentDisks.map((drive, id) => {
                if (!(editExisting && driveID == id)) {
                    if ((drive.Item["@disk"].toUpperCase().indexOf(nvmeString) > -1) || (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (drive.Item["@disk"].toUpperCase().indexOf(Constants.INCHES_) > -1 || drive.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                        noOfNVMEDrives += parseInt(drive.Item["@qty"], 10);
                    } else {
                        noOfNonNVMEDrives += parseInt(drive.Item["@qty"], 10);
                    }
                }
            })
        } else {
            if ((Drive === Constants.NODE) || (!changingDriveQty && Drive === Constants.TENANT && !editExisting && !driveTypeChanged)) {
                if ((storageObject["@TStorageDrive"].toUpperCase().indexOf(nvmeString) > -1) || (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (storageObject["@TStorageDrive"].toUpperCase().indexOf(Constants.INCHES_) > -1 || storageObject["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                    noOfNVMEDrives += parseInt(storageObject["@TStorageDriveQty"], 10);
                } else {
                    noOfNonNVMEDrives += parseInt(storageObject["@TStorageDriveQty"], 10);
                }
            }
        }

        if (Drive === Constants.TENANT) {
            mainDrive = storageObject["@TStorageDrive"];
            if (editExisting) {
                mainDrive = storageObject.PersistentDisks[driveID].Item["@disk"];
            }
        } else {
            mainDrive = storageObject["@NodeDisk"];
        }

        if (mainDrive.toUpperCase().indexOf(nvmeString) > -1 || (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (mainDrive.toUpperCase().indexOf(Constants.INCHES_) > -1 || mainDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
            if (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10) {
                if (storageObject["@OSDisk"].indexOf("M.2") > -1) {
                    if (noOfNonNVMEDrives > 26) {
                        maxDrivesAdded = true;
                    }
                } else {
                    if (noOfNonNVMEDrives > 24) {
                        maxDrivesAdded = true;
                    }
                }
            }
            maxDrives = this.props.Storagedetails[storageObject["@Name"]].MaxNVMeDrives;
            noOfDrivesLeft = maxDrives - noOfNVMEDrives;
        } else {
            maxDrives = this.props.Storagedetails[storageObject["@Name"]].MaxDrives;
            if (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && noOfNVMEDrives > 0) {
                maxDrives = storageObject["@OSDisk"].indexOf("M.2") > -1 ? 26 : 24;
            }
            if (storageObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10) {
                noOfDrivesLeft = maxDrives - noOfNonNVMEDrives;
            } else {
                if (storageObject["@Name"] === Constants.PROLIANT_DL385_GEN10_PLUS && (storageObject["@NodeDisk"].toUpperCase().indexOf(Constants.LFF_) > -1 || storageObject["@NodeDisk"].toUpperCase().indexOf(Constants.INCHES_THREE) > -1) && (storageObject["@OSDisk"].toUpperCase().indexOf(Constants.LFF_) > -1 || storageObject["@OSDisk"].toUpperCase().indexOf(Constants.INCHES_THREE) > -1) && (storageObject["@TStorageDrive"].toUpperCase().indexOf(Constants.LFF_) > -1 || storageObject["@TStorageDrive"].toUpperCase().indexOf(Constants.INCHES_THREE) > -1)) {
                    //this.props.Storagedetails[storageObject["@Name"]].MaxDrives = 16;
                    maxDrives = 16;
                }
                noOfDrivesLeft = maxDrives - noOfNonNVMEDrives - noOfNVMEDrives;
            }
        }
        var array = [noOfDrivesLeft, maxDrives, maxDrivesAdded];
        return array;
    }
    makeStorageHostCustomisationNetworkCall = () => {
        var value = {
            "input": {
                "Workload": null,
            },
            "Inputsnotchanged": false,
            "RoleType": Constants.STORAGE_
        }
        value.input.Workload = this.props.workload;
        this.props.CalculateBlueDataConfigurationfalse(value);
    }

    isCompatibleDrive = (role) => {
        var isCompatible = true;
        var roleObject = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === role)[0];
        if (roleObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10) {
            if (roleObject["@NodeDisk"].toUpperCase().indexOf(Constants.INCHES_) > -1 || roleObject["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString) > -1) {
                if (roleObject["@mixedTenantStorage"] === Constants.TRUE_) {
                    roleObject.PersistentDisks.map(drive => {
                        if (roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString) > -1) {
                            if ((drive.Item["@disk"].toUpperCase().indexOf(Constants.INCHES_) > -1 || drive.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1) && roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString) === -1) {
                                isCompatible = false;
                            }
                        }
                        else {
                            if (drive.Item["@disk"].toUpperCase().indexOf(nvmeString) > -1) {
                                isCompatible = false;
                            }
                        }
                    })
                }
                if (roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString) > -1) {
                    if ((roleObject["@TStorageDrive"].toUpperCase().indexOf(Constants.INCHES_) > -1 || roleObject["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1) && roleObject["@TStorageDrive"].toUpperCase().indexOf(nvmeString) === -1) {
                        isCompatible = false;
                    }
                } else {
                    if (roleObject["@TStorageDrive"].toUpperCase().indexOf(nvmeString) > -1) {
                        isCompatible = false;
                    }
                }
            }
        }
        return isCompatible
    }

    GPUChange = (e, textinput, requirementType) => {

        if (textinput === Constants.STORAGE_NODE_TYPE && storageMixedTenantStorage === "True") {
            Houstcountdata = this.renderErrorPopup(Constants.MIXED_STORAGE_SERVER_CHANGE_WARNING, WARNING_TEXT);
            this.setState({});
        }
        else {
            this.saveOldWorkloads();
            if (requirementType === "GPU") {
                GPUChanges = ""
            }
            else if (requirementType === "nonGPU") {
                nonGPUChanges = ""
            }
            else if (requirementType === Constants.STORAGE_) {
                StorageChanges = "";
            }
            let valueChanged = false
            selectchange = e.value
            if (textinput === "GPUNodeType" || textinput === "ComptNodeType") {
                if (textinput === "GPUNodeType") {
                    if (GPUNodeType !== selectchange) {
                        HostChanged = true
                    }
                }
                else {
                    if (ComptNodeType !== selectchange) {
                        HostChanged = true;
                        this.props.ServiceError.guiState.computeHostChanged = true;
                    }
                }
            }
            if (textinput === 'NonGPUStrDrivetype' || textinput === 'GPUStrDrivetype') {
                if (textinput === 'GPUStrDrivetype') {
                    if (GPUStrDrivetype !== selectchange) {
                        DatadriveChanged = true;
                    }
                } else {
                    if (NonGPUStrDrivetype !== selectchange) {
                        DatadriveChanged = true;
                    }
                }
            }

            if (this.props.controllerconfigChanged === true) {
                this.props.ContrlChanged(false)
            }
            if (textinput === "ComptNodeType") {
                if (ComptNodeType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "NonGPUProcFamilyType") {
                if (NonGPUProcFamilyType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "NonGPUProcType") {
                if (NonGPUProcType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "NonGPUStrDrivetype") {
                if (NonGPUStrDrivetype !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "NonGPUOSDrive") {
                if (NonGPUOSDrive !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "NonGPUMemory") {
                if (NonGPUMemory !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "NonGPUTenantStoragedrive") {
                if (NonGPUTenantStoragedrive !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUNodeType") {
                if (GPUNodeType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUProcFamilyType") {
                if (GPUProcFamilyType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUProcType") {
                if (GPUProcType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUStrDrivetype") {
                if (GPUStrDrivetype !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUOSDrive") {
                if (GPUOSDrive !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUMemory") {
                if (GPUMemory !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUTenantStoragedrive") {
                if (GPUTenantStoragedrive !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUType") {
                isGPUvalueChanged = true;
                if (GPUType !== selectchange) {
                    valueChanged = true
                }
            }
            else if (textinput === "GPUCount") {
                if (GPUCount !== selectchange) {
                    valueChanged = true
                }
            }
            if (textinput === Constants.STORAGE_NODE_TYPE) {
                if (storageNodeType !== selectchange) {
                    HostChanged = true;
                    valueChanged = true;
                    this.state.changeStorageTenantDriveTypeOptions = true;
                }
                // this.storageTextChangeForHostChange();
                // this.storageTextChange(e,'storageTenantDriveQuantity', 'Blur','', '');
            }
            else if ((textinput === Constants.STORAGE_PROCESSOR_FAMILY && storageProcFamilyType !== selectchange) || (textinput === Constants.STORAGE_PROCESSOR_TYPE && storageProcType !== selectchange) || (textinput === Constants.STORAGE_MEMORY && storageMemory !== selectchange) || (textinput === Constants.STORAGE_OSDRIVE && storageOSDrive !== selectchange) || (textinput === Constants.STORAGE_TENANT_DRIVE && storageTenantStorageDrive !== selectchange)) {
                valueChanged = true;
            }
            else if (textinput === Constants.STORAGE_NODE_DRIVE && storageNodeDrive !== selectchange) {
                valueChanged = true;
                DatadriveChanged = true;
            }

            this.onWrkUpdateselect(selectchange, textinput, valueChanged)
        }
    }
    layerclose() {
        Houstcountdata = "";
        HostChanged = false
        HoustcountExceded = false
        this.setState({ nvmeMaxedOut: false });
    }
    Errorclose() {
        this.props.Errorclose();
    }
    GPUtextchange(e, textinput, chorBlr) {
        var number = /^[0-9]+$/
        let maxval = 999999
        let minval = 1
        let val = false;
        if (textinput === "NonGPUNodeCount") {
            maxval = currentTabObject.NonGPUValue.ServerQty + 99;
            minval = currentTabObject.NonGPUValue.ServerQty;
        }
        if (textinput === "GPUNodeCoount") {
            // maxval = currentTabObject.GPUValue.ServerQty + 99;
            // minval = currentTabObject.GPUValue.ServerQty;
            maxval = this.props.GPUHostCount.GPUHostCount + 99;
            minval = this.props.GPUHostCount.GPUHostCount;
        }
        if (textinput === Constants.STORAGE_NODE_COUNT) {
            maxval = currentTabObject.StorageValue.ServerQty + 99;
            minval = currentTabObject.StorageValue.ServerQty;
        }
        if (textinput === Constants.NONGPU_NODE_STORAGE_DRIVE_QUANTITY || textinput === Constants.GPU_NODE_STORAGE_DRIVE_QUANTITY) {
            minval = 2;
        }
        var value = parseInt(e.target.value, 10);
        if (chorBlr === "Change") {
            if (saveWorkload) {
                this.saveOldWorkloads();
                saveWorkload = false;
            }
            if (e.target.value.length < 5) {
                if (isNaN(value)) {
                    selectchange = "";
                }
                else if ((number.test(value)) && (value <= 999999) && (value >= 1) || isNaN(value)) {
                    selectchange = value.toString();
                }
                else {
                    if (textinput === "NonGPUNodeCount" || textinput === "GPUNodeCoount") {
                        selectchange = "";
                    }
                    if (textinput === Constants.STORAGE_NODE_COUNT) {
                        selectchange = "";
                    }
                }
            }
        } else {
            saveWorkload = true;
            if (e.target.value === "") {
                if (textinput === "NonGPUNodeCount" || textinput === "GPUNodeCoount") {
                    if (textinput === "NonGPUNodeCount") {
                        selectchange = currentTabObject.NonGPUValue.ServerQty.toString();
                    }
                    if (textinput === "GPUNodeCoount") {
                        selectchange = currentTabObject.GPUValue.ServerQty.toString();
                    }
                } else if (textinput === Constants.STORAGE_NODE_COUNT) {
                    selectchange = currentTabObject.StorageValue.ServerQty.toString();
                }
                else {
                    selectchange = "1"
                }
            } else {
                if ((number.test(value)) && (value <= maxval) && (value >= minval) || isNaN(value) && (textinput === "NonGPUNodeCount" || textinput === "GPUNodeCoount" || textinput === Constants.STORAGE_NODE_COUNT)) {
                    selectchange = e.target.value.toString();
                } else {

                    if (textinput === "GPUNodeCoount") {
                        //selectchange = currentTabObject.GPUValue.ServerQty.toString();
                        selectchange = this.props.GPUHostCount.GPUHostCount.toString();
                        HoustcountExceded = true
                        Minhostcount = minval
                        Maxhostcount = maxval
                    }
                    else if (textinput === "NonGPUNodeCount") {
                        selectchange = currentTabObject.NonGPUValue.ServerQty.toString();
                        HoustcountExceded = true
                        Minhostcount = minval
                        Maxhostcount = maxval
                    }
                    else if (textinput === Constants.STORAGE_NODE_COUNT) {
                        selectchange = currentTabObject.StorageValue.ServerQty.toString();
                        HoustcountExceded = true
                        Minhostcount = minval
                        Maxhostcount = maxval
                    } else if (textinput === Constants.GPU_NODE_STORAGE_DRIVE_QUANTITY || textinput === Constants.NONGPU_NODE_STORAGE_DRIVE_QUANTITY) {
                        if (value < minval) {
                            selectchange = minval.toString();
                        }
                    }
                    else {
                        selectchange = e.target.value
                    }

                }

            }
            if (textinput === Constants.NONGPU_NODE_STORAGE_DRIVE_QUANTITY || textinput === Constants.GPU_NODE_STORAGE_DRIVE_QUANTITY) {
                val = true;
            }
        }

        this.onWrkUpdateselect(selectchange, textinput, val, chorBlr)
    }

    storageTextChangeForHostChange = () => {
        storageTenantDriveQuantity = this.noOfStorageTenantDrivesLeft(Constants.TENANT, false, false, "", false)[0];
        currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;

        this.setState({});
    }

    storageTextChange = (e, textinput, ChorBlr, editExisting, driveID) => {
        var minVal;
        var maxVal;
        if (textinput === Constants.STORAGE_NODE_DRIVE_QTY) {
            minVal = 2;
            maxVal = this.noOfStorageTenantDrivesLeft(Constants.NODE, true, editExisting, driveID, false)[0];
        } else {
            minVal = 0;
            maxVal = this.noOfStorageTenantDrivesLeft(Constants.TENANT, true, editExisting, driveID, false)[0];
        }
        var selectedChange = "";
        if (ChorBlr === Constants.CHANGE) {
            this.state.enableADDButton = false;
            if (saveWorkload) {
                this.saveOldWorkloads();
                saveWorkload = false;
            }
            if (isNaN(e.target.value) || e.target.value == "0" || e.target.value === "") {
                selectedChange = "";
            } else {
                if (parseInt(e.target.value, 10) >= 0 && parseInt(e.target.value, 10) <= maxVal) {
                    selectedChange = e.target.value;
                } else if (parseInt(e.target.value, 10) > maxVal) {
                    selectedChange = maxVal;
                } else {
                    selectedChange = minVal;
                }
            }
        } else {
            this.state.enableADDButton = true;
            if (e.target.value === "" || parseInt(e.target.value, 10) < minVal) {
                e.target.value = minVal.toString();
            }
            if (editExisting && (e.target.value === "" || e.target.value === "0")) {
                e.target.value = "1";
            }
            if (textinput === Constants.STORAGE_TENANT_DRIVE_QUANTITY && e.target.value === "0" && maxVal > 0) {
                e.target.value = "1";
            }
            selectedChange = e.target.value;
        }
        selectedChange = selectedChange.toString();
        if (textinput === Constants.STORAGE_NODE_DRIVE_QTY) {
            storageNodeDriveQty = selectedChange;
            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@StorageDiskQty"] = storageNodeDriveQty;
            if (ChorBlr === Constants.BLUR) {
                storageTenantDriveQuantity = this.noOfStorageTenantDrivesLeft(Constants.TENANT, true, false, "", false)[0];
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
            }
        } else if (textinput === Constants.STORAGE_TENANT_DRIVE_QUANTITY) {
            if (editExisting) {
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0].PersistentDisks.map((drive, id) => {
                    if (driveID === id) {
                        drive.Item["@qty"] = selectedChange;
                    }
                })
                if (ChorBlr === Constants.BLUR) {
                    storageTenantDriveQuantity = this.noOfStorageTenantDrivesLeft(Constants.TENANT, false, false, "", false)[0];
                    currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
                }
            } else {
                storageTenantDriveQuantity = selectedChange;
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
            }
        }
        if (ChorBlr === Constants.BLUR && !saveWorkload) {
            this.updateMixedDrivesArray();
            saveWorkload = true;
            if (!(textinput === Constants.STORAGE_TENANT_DRIVE_QUANTITY && !editExisting && storageMixedTenantStorage === "True")) {
                this.makeStorageHostCustomisationNetworkCall();
            }
        }
        this.setState({});
    }
    onWrkUpdateselect(value, textinput, valueChanged, chorBlr) {
        let GPUServer = GPUNodeType
        let GPUDataDisk = value
        let NonGPUServer = ComptNodeType
        let NonGPUDataDisk = value
        let roleType = '';
        if (textinput === 'ComptNodeType' || textinput.toUpperCase().indexOf('NONGPU') > -1) {
            roleType = 'NonGPU'
        } else if (textinput.indexOf(Constants.STORAGE_.toLowerCase()) > -1) {
            roleType = Constants.STORAGE_;
        }
        else {
            roleType = 'GPU'
        }
        currentTabObject.Templates.ServerDetails.Server.filter((x) => {
            let selectedDriveValidation = (drive1, drive2, maxDrives, serverName, type = '') => {
                if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (value.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || value.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1)) {
                    valueChanged = validateApollo4200SFFDrives(drive1, drive2, value);
                }
                if (valueChanged) {
                    valueChanged = validateDriveChange(drive1, drive2, value, serverName, NonGPUTenantStorageDriveQuantity, type);
                }
                if (!valueChanged) {
                    Houstcountdata = this.renderErrorPopup(Constants.DRIVE_CANNOTBE_MIXED, ERROR_TEXT);
                }

            }
            switch (x["@Type"]) {
                case "GPU":
                    if (textinput === "GPUNodeType") {
                        if (GPUNodeType !== value) {
                            x["@Name"] = value;
                            if (value.indexOf('m510') === -1 && value.indexOf('e910') === -1 && value.indexOf(E920) === -1) {
                                x["@ServerName"] = value
                            }
                            else {
                                x["@ServerName"] = "HP Moonshot System"
                            }
                            GPUServer = x["@Name"]
                            GPUProcList = []
                            GPUOSDriveList = []
                            GPUStrDrivetypeList = []
                            GPUTenantStoragedrivelist = [];
                            GPUProcFamilyList = []
                            GPUMemoryList = []
                            GPUList = this.props.GPUdetails
                            for (let key in GPUList) {
                                if (key === x["@Name"]) {
                                    EPICGPUlist = GPUList[key].GPUList;
                                    if (EPICGPUlist.indexOf(x["@GPUType"]) === -1) {
                                        x["@GPUType"] = EPICGPUlist[0]
                                        this.textOnChangeofConfiguration("GPU", "GPUType")
                                    }
                                    GPUStrDrivetypeList = GPUList[key].DataDriveList
                                    GPUTenantStoragedrivelist = GPUList[key].TenantDriveList
                                    if (GPUStrDrivetypeList.indexOf(x["@NodeDisk"]) === -1) {
                                        x["@NodeDisk"] = GPUStrDrivetypeList[0]
                                        this.textOnChangeofConfiguration("GPU", "NodeStorageDriveQty")
                                    }
                                    if (GPUTenantStoragedrivelist.indexOf(x["@TStorageDrive"]) === -1) {
                                        x["@TStorageDrive"] = GPUTenantStoragedrivelist[0]
                                        this.textOnChangeofConfiguration("GPU", "LocalTenantDrive");
                                    }
                                    GPUOSDriveList = GPUList[key].OSDriveList
                                    if (GPUOSDriveList.indexOf(x["@OSDisk"]) === -1) {
                                        x["@OSDisk"] = GPUOSDriveList[0]
                                        this.textOnChangeofConfiguration("GPU", "OSDrive")
                                    }
                                    for (let proctype in GPUList[x["@Name"]].ProcessorList) {
                                        GPUProcFamilyList.push(proctype)
                                    }
                                    if (GPUProcFamilyList.indexOf(x["@ProcFamily"]) === -1) {
                                        x["@ProcFamily"] = GPUProcFamilyList[0]
                                        this.textOnChangeofConfiguration("GPU", "ProcessorFamily")
                                    }
                                    for (let proctype in GPUList[x["@Name"]].ProcessorList) {
                                        if (proctype === x["@ProcFamily"]) {
                                            for (let proc in GPUList[x["@Name"]].ProcessorList[proctype]) {
                                                GPUProcList.push(proc)
                                            }
                                        }
                                    }
                                    if (GPUProcList.indexOf(x["@Proc"]) === -1) {
                                        x["@Proc"] = GPUProcList[0]
                                        this.textOnChangeofConfiguration("GPU", "Processor")
                                    }
                                    GPUMemoryList = GPUList[x["@Name"]].ProcessorList[x["@ProcFamily"]][x["@Proc"]]
                                    if (GPUMemoryList.indexOf(x["@Memory"]) === -1) {
                                        x["@Memory"] = GPUMemoryList[0]
                                        this.textOnChangeofConfiguration("GPU", "Memory")
                                    }

                                }

                            }
                        }
                    }
                    if (textinput === "GPUProcType") {
                        x["@Proc"] = value;
                        GPUMemoryList = []
                        GPUList = this.props.GPUdetails
                        for (let key in GPUList) {
                            if (key === GPUNodeType) {
                                for (let procfamily in GPUList[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in GPUList[key].ProcessorList[procfamily]) {
                                            if (proc === x["@Proc"]) {
                                                GPUMemoryList = GPUList[key].ProcessorList[procfamily][proc]

                                                if (GPUMemoryList.indexOf(x["@Memory"]) === -1) {
                                                    x["@Memory"] = GPUMemoryList[0]
                                                    this.textOnChangeofConfiguration("GPU", "Memory")
                                                }
                                            }

                                        }
                                    }
                                }
                            }

                        }
                    }

                    if (textinput === "GPUProcFamilyType") {
                        x["@ProcFamily"] = value;
                        GPUMemoryList = []
                        GPUProcList = []
                        GPUList = this.props.GPUdetails
                        for (let key in GPUList) {
                            if (key === GPUNodeType) {
                                for (let procfamily in GPUList[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in GPUList[key].ProcessorList[procfamily]) {
                                            GPUProcList.push(proc)
                                        }
                                        x["@Proc"] = GPUProcList[0]
                                        this.textOnChangeofConfiguration("GPU", "Processor")
                                        GPUMemoryList = GPUList[x["@Name"]].ProcessorList[procfamily][x["@Proc"]]
                                        if (GPUMemoryList.indexOf(x["@Memory"]) === -1) {
                                            x["@Memory"] = GPUMemoryList[0]
                                            this.textOnChangeofConfiguration("GPU", "Memory")
                                        }
                                    }
                                }

                            }

                        }
                    }

                    if (textinput === Constants.GPU_NODE_STORAGE_DRIVE) {
                        if (GPUStrDrivetype !== value) {
                            let oldDrive = GPUStrDrivetype;
                            x["@NodeDisk"] = value;
                            selectedDriveValidation(x["@TStorageDrive"], x["@OSDisk"], this.props.GPUdetails[x["@Name"]].MaxNVMeDrives, x["@Name"], 'ephemeral');
                            if (!valueChanged) {
                                x["@NodeDisk"] = oldDrive;
                                DatadriveChanged = false;
                            }
                            GPUStrDrivetype = x["@NodeDisk"];
                        }
                    }
                    if (textinput === Constants.GPU_TENANT_DRIVE) {
                        if (GPUTenantStoragedrive !== value) {
                            let oldDrive = GPUTenantStoragedrive;
                            x["@TStorageDrive"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@OSDisk"], this.props.GPUdetails[x["@Name"]].MaxNVMeDrives, x["@Name"], 'persistent');
                            if (!valueChanged) {
                                x["@TStorageDrive"] = oldDrive;
                            }
                            GPUTenantStoragedrive = x["@TStorageDrive"];
                        }
                    }

                    if (textinput === Constants.GPU_OSDRIVE) {
                        if (GPUOSDrive !== value) {
                            let oldDrive = GPUOSDrive;
                            x["@OSDisk"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@TStorageDrive"], this.props.GPUdetails[x["@Name"]].MaxNVMeDrives, x["@Name"], 'osdrive');
                            if (!valueChanged) {
                                x["@OSDisk"] = oldDrive;
                            }
                            GPUOSDrive = x["@OSDisk"];
                        }
                    }

                    if (textinput === "GPUNodeCoount")
                        x["@NodesCount"] = value;

                    if (textinput === "GPUMemory")
                        x["@Memory"] = value;

                    if (textinput === "GPUType") {
                        x["@GPUType"] = value;
                        if (GPUNodeType === "ProLiant XL190r Gen10") {
                            x["@GPUcount"] = 2;
                        }
                        else if (GPUNodeType === "ProLiant XL270d Gen10") {
                            x["@GPUcount"] = 8;
                            if (x["@GPUType"] === T4_GPU || x["@GPUType"] === A100_PCIE_80GB_GPU) {
                                x["@GPUcount"] = 8;
                            }
                        } else if (GPUNodeType === proLiantDL360Gen10) {
                            x["@GPUcount"] = 2;
                        } else if (GPUNodeType === proLiantDL380Gen10) {
                            x["@GPUcount"] = 3;
                            if (x["@GPUType"] === T4_GPU) {
                                x["@GPUcount"] = 7;
                            } else if (x["@GPUType"] === A100_40GB_GPU || x["@GPUType"] === A40_PCIE_48GB_GPU) {
                                x["@GPUcount"] = 2;
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_XL675D_GEN10_PLUS) {
                            x["@GPUcount"] = 10;
                        } else if (GPUNodeType === Constants.PROLIANT_XL645D_GEN10_PLUS) {
                            x["@GPUcount"] = 4;
                        } else if (GPUNodeType === Constants.PROLIANT_DL385_GEN10_PLUS) {
                            if (x["@GPUType"] === T4_GPU) {
                                x["@GPUcount"] = 8;
                            } else {
                                x["@GPUcount"] = 3;
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_E910T_2U_SERVER) {
                            x["@GPUcount"] = (x["@GPUType"] === T4_GPU || x["@GPUType"] === Constants.T4_TESLA_GPU) ? 3 : 1;
                        } else if (GPUNodeType === Constants.PROLIANT_E910_2U_SERVER) {
                            x["@GPUcount"] = (x["@GPUType"] === T4_GPU || x["@GPUType"] === Constants.T4_TESLA_GPU) ? 3 : 1;
                        }
                        else if (GPUNodeType === Constants.PROLIANT_XL290N_GEN10_PLUS) {
                            if (x["@GPUType"] === T4_GPU) {
                                x["@GPUcount"] = 4;
                            } else {
                                x["@GPUcount"] = 2;
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_DL325_GEN10_PLUS) {
                            x["@GPUcount"] = 3;
                        } else if (GPUNodeType === Constants.PROLIANT_DL360_GEN10_PLUS) {
                            x["@GPUcount"] = 2;
                        } else if (GPUNodeType === Constants.PROLIANT_DL380_GEN10_PLUS) {
                            x["@GPUcount"] = 3;
                            if (GPUType === T4_GPU) {
                                x["@GPUcount"] = 8;
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_DL365_GEN10_PLUS) {
                            x["@GPUcount"] = 2;
                        } else if (GPUNodeType === Constants.PROLIANT_DL325_GEN10_PLUS_V2) {
                            x["@GPUcount"] = 2;
                        }
                        else {
                            x["@GPUcount"] = 1;
                        }

                    }

                    if (textinput === "GPUCount")
                        x["@GPUcount"] = value;
                    if (textinput === "GPUNodeStorageDriveQuantity") {
                        if (chorBlr !== "Change") {
                            if (value !== "") {
                                nodeStorageDriveQuantityOnBlurValidation(x, value, this.props.GPUdetails);
                            } else {
                                x["@StorageDiskQty"] = " ";
                            }
                        } else {
                            x["@StorageDiskQty"] = value;
                        }
                    }

                    break;
                case "NonGPU":
                    if (textinput === "ComptNodeType") {
                        if (ComptNodeType !== value) {
                            x["@Name"] = value;
                            if (value.indexOf('m510') === -1 && value.indexOf('e910') === -1 && value.indexOf(E920) === -1) {
                                x["@ServerName"] = value
                            }
                            else {
                                x["@ServerName"] = "HP Moonshot System"
                            }
                            NonGPUServer = x["@Name"]
                            NonGPUProcList = []
                            NonGPUProcFamilyList = []
                            NonGPUOSDriveList = []
                            NonGPUStrDrivetypeList = []
                            NonGPUTenantStoragedrivelist = []
                            NonGPUMemoryList = []
                            NonGPUList = this.props.NonGPUdetails
                            for (let key in NonGPUList) {
                                ComptNodeList.push(key);
                                if (key === x["@Name"]) {
                                    computeGPUTypeOptions = NonGPUList[key].GPUList;
                                    NonGPUStrDrivetypeList = NonGPUList[key].DataDriveList
                                    NonGPUTenantStoragedrivelist = NonGPUList[key].TenantDriveList
                                    if (NonGPUStrDrivetypeList.indexOf(x["@NodeDisk"]) === -1) {
                                        x["@NodeDisk"] = NonGPUStrDrivetypeList[0]
                                        this.textOnChangeofConfiguration("nonGPU", "NodeStorageDrive")
                                    }
                                    if (NonGPUTenantStoragedrivelist.indexOf(x["@TStorageDrive"]) === -1) {
                                        x["@TStorageDrive"] = NonGPUTenantStoragedrivelist[0]
                                        this.textOnChangeofConfiguration("nonGPU", "LocalTenantDrive")
                                    }
                                    NonGPUOSDriveList = NonGPUList[key].OSDriveList
                                    if (NonGPUOSDriveList.indexOf(x["@OSDisk"]) === -1) {
                                        x["@OSDisk"] = NonGPUOSDriveList[0]
                                        this.textOnChangeofConfiguration("nonGPU", "OSDrive")
                                    }
                                    x["@StorageDiskQty"] = (this.props.GPUdetailsforcore.NonGPUValue.DriveQty).toString()
                                    for (let proctype in NonGPUList[x["@Name"]].ProcessorList) {
                                        NonGPUProcFamilyList.push(proctype)
                                    }
                                    if (NonGPUProcFamilyList.indexOf(x["@ProcFamily"]) === -1) {
                                        x["@ProcFamily"] = NonGPUProcFamilyList[0]
                                        this.textOnChangeofConfiguration("nonGPU", "ProcessorFamily")
                                    }
                                    for (let proctype in NonGPUList[x["@Name"]].ProcessorList) {
                                        if (proctype === x["@ProcFamily"]) {
                                            for (let proc in NonGPUList[x["@Name"]].ProcessorList[proctype]) {
                                                NonGPUProcList.push(proc)
                                            }
                                            if (NonGPUProcList.indexOf(x["@Proc"]) === -1) {
                                                x["@Proc"] = NonGPUProcList[0]
                                                this.textOnChangeofConfiguration("nonGPU", "Processor")
                                            }
                                            NonGPUMemoryList = NonGPUList[x["@Name"]].ProcessorList[proctype][x["@Proc"]]
                                            if (NonGPUMemoryList.indexOf(x["@Memory"]) === -1) {
                                                x["@Memory"] = NonGPUMemoryList[0]
                                                this.textOnChangeofConfiguration("nonGPU", "Memory")
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (textinput === "NonGPUProcType") {
                        x["@Proc"] = value;
                        NonGPUMemoryList = []
                        NonGPUList = this.props.NonGPUdetails
                        for (let key in NonGPUList) {
                            if (key === ComptNodeType) {
                                for (let procfamily in NonGPUList[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in NonGPUList[key].ProcessorList[procfamily]) {
                                            if (proc === x["@Proc"]) {
                                                NonGPUMemoryList = NonGPUList[key].ProcessorList[procfamily][proc]
                                                if (NonGPUMemoryList.indexOf(x["@Memory"]) === -1) {
                                                    x["@Memory"] = NonGPUMemoryList[0]
                                                    this.textOnChangeofConfiguration("nonGPU", "Memory")
                                                }
                                            }

                                        }


                                    }
                                }

                            }

                        }
                    }

                    if (textinput === "NonGPUProcFamilyType") {
                        x["@ProcFamily"] = value;
                        NonGPUMemoryList = []
                        NonGPUProcList = []
                        NonGPUList = this.props.NonGPUdetails
                        for (let key in NonGPUList) {
                            if (key === ComptNodeType) {
                                for (let procfamily in NonGPUList[key].ProcessorList) {
                                    if (procfamily === x["@ProcFamily"]) {
                                        for (let proc in NonGPUList[key].ProcessorList[procfamily]) {
                                            NonGPUProcList.push(proc)
                                        }
                                        x["@Proc"] = NonGPUProcList[0]
                                        this.textOnChangeofConfiguration("nonGPU", "Processor")
                                        NonGPUMemoryList = NonGPUList[x["@Name"]].ProcessorList[procfamily][x["@Proc"]]
                                        if (NonGPUMemoryList.indexOf(x["@Memory"]) === -1) {
                                            x["@Memory"] = NonGPUMemoryList[0]
                                            this.textOnChangeofConfiguration("nonGPU", "Memory")
                                        }
                                    }
                                }

                            }

                        }
                    }

                    if (textinput === Constants.NONGPU_NODE_STORAGE_DRIVE) {
                        if (NonGPUStrDrivetype !== value) {
                            let oldDrive = NonGPUStrDrivetype;
                            x["@NodeDisk"] = value;
                            selectedDriveValidation(x["@TStorageDrive"], x["@OSDisk"], this.props.NonGPUdetails[x["@Name"]].MaxNVMeDrives, x["@Name"], 'ephemeral');
                            if (!valueChanged) {
                                x["@NodeDisk"] = oldDrive;
                                DatadriveChanged = false;
                            }
                            NonGPUStrDrivetype = x["@NodeDisk"];
                        }
                    }

                    if (textinput === Constants.NONGPU_TENANT_DRIVE) {
                        if (NonGPUTenantStoragedrive !== value) {
                            let oldDrive = NonGPUStrDrivetype;
                            x["@TStorageDrive"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@OSDisk"], this.props.NonGPUdetails[x["@Name"]].MaxNVMeDrives, x["@Name"], 'persistent');
                            if (!valueChanged) {
                                x["@TStorageDrive"] = oldDrive;
                            }
                            NonGPUTenantStoragedrive = x["@TStorageDrive"];
                        }
                    }

                    if (textinput === Constants.NONGPU_OSDRIVE) {
                        if (NonGPUOSDrive !== value) {
                            let oldDrive = NonGPUOSDrive;
                            x["@OSDisk"] = value;
                            selectedDriveValidation(x["@NodeDisk"], x["@TStorageDrive"], this.props.NonGPUdetails[x["@Name"]].MaxNVMeDrives, x["@Name"], 'osdrive');
                            if (!valueChanged) {
                                x["@OSDisk"] = oldDrive;
                            }
                            NonGPUTenantStoragedrive = x["@OSDisk"];
                        }
                    }

                    if (textinput === "NonGPUNodeCount")
                        x["@NodesCount"] = value;

                    if (textinput === "NonGPUMemory")
                        x["@Memory"] = value;

                    if (textinput === "NonGPUNodeStorageDriveQuantity") {
                        if (chorBlr !== "Change") {
                            if (value !== "") {
                                nodeStorageDriveQuantityOnBlurValidation(x, value, this.props.NonGPUdetails);
                            } else {
                                x["@StorageDiskQty"] = " ";
                            }
                        }
                        else {
                            x["@StorageDiskQty"] = value;
                        }
                    }

                    break;
                case Constants.STORAGE_:
                    if (textinput === Constants.STORAGE_NODE_TYPE) {
                        if (storageNodeType !== value) {
                            x["@Name"] = value;
                            storageNodeType = x["@Name"];
                            this.storageHostAllOptions(true);
                            var MaxDrives = 0;
                            if (x["@TStorageDrive"].indexOf(nvmeString) > -1) {
                                MaxDrives = this.props.Storagedetails[x["@Name"]].MaxNVMeDrives;
                            } else {
                                MaxDrives = this.props.Storagedetails[x["@Name"]].MaxDrives;
                            }
                            if (parseInt(x["@StorageDiskQty"], 10) + parseInt(x["@TStorageDriveQty"], 10) + parseInt(x["@OSDiskQty"], 10) > MaxDrives) {
                                x["@StorageDiskQty"] = "3";
                                if (parseInt(x["@StorageDiskQty"], 10) + parseInt(x["@TStorageDriveQty"], 10) + parseInt(x["@OSDiskQty"], 10) > MaxDrives) {
                                    x["@TStorageDriveQty"] = MaxDrives - parseInt(x["@StorageDiskQty"], 10) - parseInt(x["@OSDiskQty"], 10);
                                    x["@TStorageDriveQty"] = x["@TStorageDriveQty"].toString();
                                }
                            }
                            this.updateMixedDrivesArray();
                        }
                        this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange = FALSE;
                    }
                    if (textinput === Constants.STORAGE_PROCESSOR_FAMILY) {
                        if (storageProcFamilyType !== value) {
                            x["@ProcFamily"] = value;
                            storageProcFamilyType = x["@ProcFamily"];
                            this.storageHostAllOptions();
                        }
                    }
                    if (textinput === Constants.STORAGE_PROCESSOR_TYPE) {
                        if (storageProcType !== value) {
                            x["@Proc"] = value;
                            storageProcType = x["@Proc"];
                            this.storageHostAllOptions();
                        }
                    }
                    if (textinput === Constants.STORAGE_MEMORY) {
                        if (storageMemory !== value) {
                            x["@Memory"] = value;
                            storageMemory = x["@Memory"];
                        }
                    }
                    if (textinput === Constants.STORAGE_NODE_DRIVE) {
                        if (storageNodeDrive !== value) {
                            var oldNodeStorageDrive = x["@NodeDisk"];
                            x["@NodeDisk"] = value;
                            valueChanged = this.isCompatibleDrive(Constants.STORAGE_);
                            if (valueChanged) {
                                valueChanged = validateDriveChange(x["@TStorageDrive"], x["@OSDisk"], value, x["@Name"]);
                            }
                            if (!valueChanged) {
                                x["@NodeDisk"] = oldNodeStorageDrive;
                                Houstcountdata = this.renderErrorPopup(Constants.DRIVE_CANNOTBE_MIXED, ERROR_TEXT);
                                DatadriveChanged = false;
                            } else {
                                var array = this.noOfStorageTenantDrivesLeft(Constants.NODE, false, false, "", false);
                                if (array[0] < parseInt(x["@StorageDiskQty"], 10) || array[2]) {
                                    if (array[2] && x["@Name"] === Constants.HPE_APOLLO_4200_GEN10) {
                                        if (x["@OSDisk"].indexOf("M.2") > -1) {
                                            array[1] = 26;
                                        } else {
                                            array[1] = 24;
                                        }
                                    }
                                    Houstcountdata = this.renderErrorPopup(Constants.MAXDRIVEQTY_EXCEEDED[0] + array[1] + Constants.MAXDRIVEQTY_EXCEEDED[1], ERROR_TEXT);
                                    DatadriveChanged = false;
                                    valueChanged = false;
                                    x["@NodeDisk"] = oldNodeStorageDrive;
                                }
                            }
                            storageNodeDrive = x["@NodeDisk"];
                        }
                    }
                    if (textinput === Constants.STORAGE_TENANT_DRIVE) {
                        if (storageTenantStorageDrive !== value) {
                            var oldPersistentStorageDrive = x["@TStorageDrive"];
                            x["@TStorageDrive"] = value;
                            valueChanged = this.isCompatibleDrive(Constants.STORAGE_);
                            if (valueChanged) {
                                valueChanged = validateDriveChange(x["@NodeDisk"], x["@OSDisk"], value, x["@Name"]);
                            }
                            if (!valueChanged) {
                                x["@TStorageDrive"] = oldPersistentStorageDrive;
                                Houstcountdata = this.renderErrorPopup(Constants.DRIVE_CANNOTBE_MIXED, ERROR_TEXT);
                            }
                            if (valueChanged) {
                                this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange = TRUE;
                            }
                            storageTenantStorageDrive = x["@TStorageDrive"];
                            this.updateMixedDrivesArray();
                        }
                    }
                    if (textinput === Constants.STORAGE_OSDRIVE) {
                        if (storageOSDrive !== value) {
                            let oldPersistentOSDrive = x["@OSDisk"];
                            x["@OSDisk"] = value;
                            valueChanged = this.isCompatibleDrive(Constants.STORAGE_);
                            if (valueChanged) {
                                valueChanged = validateDriveChange(x["@NodeDisk"], x["@TStorageDrive"], value, x["@Name"]);
                            }
                            if (!valueChanged) {
                                x["@OSDisk"] = oldPersistentOSDrive;
                                Houstcountdata = this.renderErrorPopup(Constants.DRIVE_CANNOTBE_MIXED, ERROR_TEXT);
                            }
                            storageOSDrive = x["@OSDisk"];
                        }
                    }
                    if (textinput === Constants.STORAGE_NODE_COUNT) {
                        x["@NodesCount"] = value;
                        storageNodeCount = x["@NodesCount"];
                    }
            }
        })
        if (DatadriveChanged) {
            DatadriveChanged = false
            let server = ''
            let datadisk = ''
            let rolename = ''
            if (textinput === "NonGPUStrDrivetype") {
                server = NonGPUServer
                datadisk = NonGPUDataDisk
                rolename = "NONGPU"
            } else if (textinput === "GPUStrDrivetype") {
                server = GPUServer
                datadisk = GPUDataDisk
                rolename = "GPU"
            } else if (textinput === Constants.STORAGE_NODE_DRIVE) {
                server = storageNodeType;
                datadisk = storageNodeDrive;
                rolename = Constants.STORAGE_;
            }
            var data = {
                "strServer": server,
                "strDataDisk": datadisk,
                "strConfigType": "BlueData",
                "rolename": rolename
            }
            this.props.GetOSDiskList(data);
            var tenantInputs = {
                "strServer": server,
                "strDataDisk": datadisk,
                "strConfigType": "BlueData",
                "rolename": rolename,
                "localStorage": "Local Tenant"
            }
            if (textinput !== Constants.STORAGE_NODE_DRIVE) {
                this.props.getTenantStorageDriveList(tenantInputs);
            }
        }
        if (valueChanged) {
            let value = {
                "input": {
                    "Workload": null,
                },
                "Inputsnotchanged": false,
                "RoleType": roleType,
                "HostChanged": HostChanged
            }
            value.input.Workload = this.props.workload;
            this.props.CalculateBlueDataConfigurationfalse(value)
        }
        let NoValues = this.checkValues();
        if (!NoValues) {
            if (!this.props.activeSession.isSizeEnabled) {
                let disableFinishButton = false;
                let selectedServices = this.props.workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_)
                selectedServices.map(solution => {
                    if (solution.NonGPUValue.isCalculated === Constants.fALSE_ && solution.GPUValue.isCalculated === Constants.fALSE_ && solution.StorageValue.isCalculated === Constants.fALSE_) {
                        disableFinishButton = true;
                    }
                })
                if (!disableFinishButton) {
                    this.props.OnToggleSizeButton(true);
                }
            }

        } else if (this.props.activeSession.isSizeEnabled) {
            this.props.OnToggleSizeButton(false);
        }

        this.setState({})
    }
    OnvalueChange(e, textinput, ChorBlr, templateNumber) {
        let minval = currentTabObject.Templates.Template[templateNumber]["@Type"] === "Custom" ? 0 : 1;
        let noOfGPUsMaxValue = 8;
        if (currentTabObject.Templates.Template[templateNumber]["@Type"].indexOf(Constants.INFERENCE_) > -1) {
            noOfGPUsMaxValue = 2;
        }
        if (isNaN(parseInt(e.target.value, 10))) {
            e.target.value = ""
        }
        var n = 4;
        if (textinput === NODESTORAGE || textinput === PERSISTENT_STORAGE) {
            if (textinput === PERSISTENT_STORAGE) {
                minval = 0;
                if (currentTabObject.Templates.Template[templateNumber]["@Type"].indexOf(Constants.STORAGE_) !== -1) {
                    minval = 1;
                }
            }
            n = 6;
        } else if (textinput === MEMORY) {
            n = 5;
        } else if (textinput === GPUS) {
            minval = 0;
        }
        Globalvalue = e.target.value
        if (ChorBlr === "Change") {
            var number = /^[0-9]+$/
            if (e.target.value.length < n) {
                if (number.test(parseInt(e.target.value, 10)) && parseInt(e.target.value, 10) >= minval) {
                    if (textinput === GPUS && parseInt(e.target.value, 10) > noOfGPUsMaxValue) {
                        e.target.value = minval.toString()
                    }
                    else if (textinput === NODESTORAGE && parseInt(e.target.value, 10) > 20000) {
                        e.target.value = "1";
                    }
                    Globalvalue = parseInt(e.target.value, 10).toString();
                }
                else {
                    Globalvalue = "";
                }
            }
            else {
                Globalvalue = "";
            }
        } else {
            isValueChanged = true;
            if (Globalvalue === "") {
                Globalvalue = "1";
            }
            if (textinput === MEMORY) {
                let maximumMemory = this.state.maxKubernetesMemory
                if (currentTabObject.Templates.Template[templateNumber]["@ConfigType"] === Constants.EPIC_) {
                    maximumMemory = this.state.maxEpicMemory;
                }
                if (parseInt(e.target.value, 10) > maximumMemory) {
                    Globalvalue = maximumMemory.toString();
                }
            }



            // if((textinput === VIRTUALCLUSTERS && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_ClusterQty"], 10)) || 
            //     (textinput === VIRTUALNODESPERCLUSTER && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_MinvNodes"], 10)) ||
            //     (textinput === CPUCORES && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_vCPUs"], 10)) ||
            //     (textinput === MEMORY && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["d_vMemory"], 10)) ||
            //     (textinput === NODESTORAGE && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["d_NodeStorage"], 10)) ||
            //     (textinput === PERSISTENT_STORAGE && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["d_PersistentStorage"], 10)) ||
            //     (textinput === GPUS && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_GPUs"], 10))) {
            // }
        }
        let assignGlobalValue = () => {
            if (textinput === VIRTUALCLUSTERS) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"] = Globalvalue
                currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"] = (parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"], 10)).toString()
            }
            else if (textinput === VIRTUALNODESPERCLUSTER) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"] = Globalvalue
                currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"] = (parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"], 10)).toString()
            }
            else if (textinput === CPUCORES) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@vCPUPerNode"] = Globalvalue
            }
            else if (textinput === MEMORY) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@vMemoryPerNode"] = Globalvalue
            }
            else if (textinput === NODESTORAGE) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@StoragePervNode"] = Globalvalue
            }
            else if (textinput === PERSISTENT_STORAGE) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@PersistentStorage"] = Globalvalue
            }
            else if (textinput === GPUS) {
                currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"] = Globalvalue
                currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"] = (parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"], 10)).toString()
            }
            currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"] = this.setPersistentStorageMinValue();
        }
        let updateCalculateButton = () => {
            let NoValues = this.checkValues();
            if (NoValues) {
                this.props.Calcbutton(true)
            } else {
                this.props.Calcbutton(false)
            }
            this.makeisCalculatedFalse();
        }
        assignGlobalValue();
        if (ChorBlr === Constants.BLUR) {
            updateCalculateButton();
        }
        this.setState({});

    }
    onCalcTempClick = () => {
        totalgpus = 0
        var inferenceAndOtherGPUsPresent = false;
        if ((currentTabObject.GPUValue.isCalculated === Constants.tRUE_ || currentTabObject.Templates.Template.filter(x => (x["@Type"].indexOf(Constants.GPU_) !== -1 && x["@Type"].indexOf(Constants.INFERENCE_) === -1)).length > 0) && currentTabObject.Templates.Template.filter(x => x["@Type"].indexOf(Constants.INFERENCE_) > -1).length > 0) {
            inferenceAndOtherGPUsPresent = true;
        }
        currentTabObject.Templates.Template.map((x, id) => {
            let clustersQty = KubClusters;
            if (x["@InputMode"] === Constants.IMAGE_PROCESSING || x["@ConfigType"] === Constants.EPIC_) {
                clustersQty = 1;
            }
            if (inferenceAndOtherGPUsPresent) {
                if (x["@Type"].indexOf(Constants.INFERENCE_) === -1) {
                    totalgpus += parseInt(x.Nodes["@GPUs"], 10) * clustersQty;
                }
            } else {
                totalgpus += parseInt(x.Nodes["@GPUs"], 10) * clustersQty;
            }
        });
        //totalgpus = totalgpus*KubClusters;
    }

    calculateRecommendationButtonValidation() {
        let NoValues = this.checkValues();
        if (NoValues) {
            this.props.Calcbutton(true)
            this.props.OnToggleSizeButton(false);
        } else {
            this.props.Calcbutton(false)
        }
        this.makeisCalculatedFalse();
    }

    onConfigTypeChange = (e, templateNumber) => {
        if (currentTabObject.Templates.Template[templateNumber]["@ConfigType"] !== e.option) {
            currentTabObject.Templates.Template[templateNumber]["@ConfigType"] = e.option;
            if (currentTabObject.Templates.Template[templateNumber]["@Type"] !== Constants.NONE_) {
                this.calculateRecommendationButtonValidation();
            }
            updateControllerHostCount(this.props.workload, HAIncluded);
            updateMasterHostCount(this.props.workload, HAIncluded);
            this.setState({});
        }
    }
    onNodeTemplateChange(e, templateNumber) {
        if (currentTabObject.Templates.Template[templateNumber]["@Type"] !== e.option) {
            if (currentTabObject.Templates.Template[templateNumber]["@Type"] !== Constants.NONE_ && e.option === Constants.NONE_) {
                let deleteTemplate = () => {
                    isValueChanged = true;
                    currentTabObject.Templates.Template.splice(templateNumber, 1);
                    deleteTemplateConfirmation = "";
                    this.calculateRecommendationButtonValidation();
                    currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"] = this.setPersistentStorageMinValue();
                    updateControllerHostCount(this.props.workload, HAIncluded);
                    updateMasterHostCount(this.props.workload, HAIncluded);
                    this.setState({})
                }
                let doNotdeleteTemplate = () => {
                    deleteTemplateConfirmation = "";
                    this.setState({})
                }
                deleteTemplateConfirmation = <Layer>
                    <Box margin='none' pad='none'>
                        <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom" >
                            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                                <WarningIcon size='small' colorIndex='warning' />
                                <Heading tag="h4" strong={false} >Please Confirm</Heading>
                            </Box>
                            <Box direction="row" margin="none" pad="none" align='start' alignContent="start"  >
                                <CloseIcon size='small' colorIndex="light-2" className="CloseIconStyle" onClick={() => doNotdeleteTemplate()} />
                            </Box>
                        </Box>
                        <Box margin="none" pad="small">
                            <Heading tag='h6' strong={false}>Selecting <b>None</b> will remove the current template from the workload.</Heading>
                            <Heading tag='h6' strong={false}>Do you want to proceed?</Heading>
                            <Box direction='row' justify='end' margin='none' >
                                <Button label='Yes' className="SessionOutBtns" onClick={() => deleteTemplate()} />
                                <Button label='No' className="SessionOutBtns" onClick={() => doNotdeleteTemplate()} />
                            </Box>
                        </Box>
                    </Box>
                </Layer>
            }
            else {
                isValueChanged = true;
                currentTabObject.Templates.Template[templateNumber]["@Type"] = e.option
                currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"] = Templatedata[e.option]["i_ClusterQty"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"] = Templatedata[e.option]["i_NodesPerCluster"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@vCPUPerNode"] = Templatedata[e.option]["i_vCPUs"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@vMemoryPerNode"] = Templatedata[e.option]["d_vMemory"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@StoragePervNode"] = Templatedata[e.option]["d_NodeStorage"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@PersistentStorage"] = Templatedata[e.option]["d_PersistentStorage"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"] = Templatedata[e.option]["i_GPUs"]
                currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"] = (parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"], 10)
                    * parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"], 10)).toString()
                this.calculateRecommendationButtonValidation();
                currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"] = this.setPersistentStorageMinValue();
                updateControllerHostCount(this.props.workload, HAIncluded);
                updateMasterHostCount(this.props.workload, HAIncluded);
            }
            this.setState({});
        }
    }
    ChkboxChange(change, shouldUpdate) {
        let selectchange = " "
        if (change) {
            if (HAIncluded) {
                HAIncluded = false
                selectchange = "false"
            } else {
                HAIncluded = true
                selectchange = "true"
            }
        }
        else {
            selectchange = "true"
        }

        let textinput = "HAIncluded"
        if (textinput === "HAIncluded") {
            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@HAIncluded"] = selectchange;
            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@HAIncluded"] = selectchange;
            let nodecountgateway = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@NodesCount"]
            let nodecountcontroller = this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@NodesCount"]
            if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@HAIncluded"] === "true") {
                if ((parseInt(nodecountcontroller, 10)) < 3) {
                    nodecountcontroller = (parseInt(nodecountcontroller, 10) + 2).toString()
                }
                if ((parseInt(nodecountgateway, 10)) < 3) {
                    if (!(HAIncluded && nodecountgateway === "2")) {
                        nodecountgateway = (parseInt(nodecountgateway, 10) + 1).toString()
                    }
                }

            } else {
                if ((parseInt(nodecountcontroller, 10)) <= 4) {
                    if ((parseInt(nodecountcontroller, 10) - 2) < 1) {
                        nodecountcontroller = '1'
                    } else {
                        nodecountcontroller = (parseInt(nodecountcontroller, 10) - 2).toString()
                    }
                }
                if ((parseInt(nodecountgateway, 10)) <= 3) {
                    if ((parseInt(nodecountgateway, 10) - 1) < 1) {
                        nodecountgateway = '1'
                    } else {
                        nodecountgateway = (parseInt(nodecountgateway, 10) - 1).toString()
                    }
                }

            }
            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@NodesCount"] = nodecountgateway
            this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@NodesCount"] = nodecountcontroller
            updateControllerHostCount(this.props.workload, HAIncluded);
            updateMasterHostCount(this.props.workload, HAIncluded);
        }
        let NoValues = this.checkValues();
        if (NoValues) {
            this.props.Calcbutton(true)
            this.makeisCalculatedFalse();
        } else {
            this.props.Calcbutton(false)
            if (shouldUpdate) {
                this.makeisCalculatedFalse();
            }
        }
    }
    Requirementstextchange(e, textinput, chorBlr) {
        var minLimit = 0
        var maxLimit = 0
        if (textinput === "HDFSTenatStr") {
            minLimit = 0
            maxLimit = 99999
        }
        else if (textinput === "HDFSrepFac") {
            minLimit = 1
            maxLimit = 10
        }
        else if (textinput === "Allocationratio") {
            minLimit = 1
            maxLimit = 6
        } else if (textinput === "KubClusters") {
            minLimit = 1
            maxLimit = 20
        }
        var number = /^[0-9]+$/
        var netwrkcal = false
        if (chorBlr === "Change") {
            if (e.target.value.length <= 5) {
                var value = parseInt(e.target.value, 10);
                if (isNaN(value)) {
                    Globalvalue = "";
                }
                else if ((number.test(value)) && (value <= maxLimit) && (value >= minLimit) || isNaN(value)) {
                    Globalvalue = value.toString();
                }
                else {
                    Globalvalue = minLimit.toString();
                }
            }
        } else {
            isValueChanged = true;
            var persistentStorageMinimumValue = this.setPersistentStorageMinValue();
            if (e.target.value === "") {
                Globalvalue = textinput === "HDFSTenatStr" ? persistentStorageMinimumValue : "1";
            } else {
                if (textinput === "HDFSTenatStr") {
                    if (parseInt(e.target.value, 10) < parseInt(persistentStorageMinimumValue, 10)) {
                        e.target.value = persistentStorageMinimumValue;
                    }
                }
                Globalvalue = e.target.value
            }
            netwrkcal = true

            this.calculateRecommendationButtonValidation();
        }

        if (textinput === "HDFSTenatStr") {
            currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"] = Globalvalue
        }


        if (textinput === "HDFSrepFac") {
            currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"] = Globalvalue
        }


        if (textinput === "Allocationratio")
            currentTabObject.Templates.ServerDetails.Requirements["@AllocationRatio"] = Globalvalue

        if (textinput === "KubClusters") {
            currentTabObject.Templates.ServerDetails.Requirements["@KubernetesClustersQty"] = Globalvalue
        }
        this.setState({})
    }
    onEpicClick() {
        if (this.props.workload && this.props.workload.UserInputs.EOLServer && this.props.workload.UserInputs.EOLServer === 'yes') {
            this.props.workload.UserInputs.EOLServer = 'no';
        }
        this.props.sizerWorkloadforCalculation.value = {
            "input": {
                "Workload": null,
            },
            "Inputsnotchanged": true
        }
        if (this.props.workload.UserInputs.Environments.isOldWorkload) {
            if (currentTabObject["@SolutionType"] === Constants.GENERAL_PURPOSE) {
                if (!currentTabObject.Templates.Template.find(template => template["@Type"] === Constants.CUSTOM_TEMPLATE)) {
                    this.props.workload.UserInputs.Environments.isOldWorkload = false;
                }
            }
        }
        this.props.sizerWorkloadforCalculation.value.input.Workload = JSON.parse(JSON.stringify(this.props.workload))
        this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions = FALSE;
        this.props.workload.UserInputs.Environments.isWLorSLLoaded = FALSE;
        this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange = FALSE;
        this.props.sizerWorkloadforCalculation.value = { ...this.props.sizerWorkloadforCalculation.value }
        this.saveOldWorkloads();
        this.props.Calcbutton(true)
        this.onCalcTempClick()
        this.props.changeCalculateBlueDataAPIcount(3)
        var inputs = {
            "dHDFSStorage": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],
            "dHDFSRepFactor": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
        }
        this.props.EPICRequirements(inputs)

        var value = {
            "strHostType": "GPU",
            "strHDFSRawSize": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],
            "strHDFSRepFactor": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
        }
        this.props.OnGatewaydltsfetch(value);

        var input = {
            "strHostType": "NonGPU",
            "strHDFSRawSize": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],
            "strHDFSRepFactor": currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
        }
        this.props.OnGatewaydltsfetch(input);

        if (this.props.controllerconfigChanged === true) {
            this.props.ContrlChanged(false)
        }
        this.props.OnToggleSizeButton(true)
        this.setState({})
    }
    renderTemplates = () => {
        if (this.props.Templates) {
            if (currentTabObject.Templates.Template.filter(item => item['@Type'] !== Constants.NONE_).length > 0) {
                currentTabObject.Templates.Template.map(template => {
                    let SolutionType = currentTabObject["@SolutionType"];
                    let templatesList = this.props.Templates[SolutionType];
                    if (template["@Type"] !== Constants.NONE_) {
                        if (templatesList && Object.keys(templatesList).indexOf(template["@Type"]) === -1) {
                            switch (template["@Type"]) {
                                case Constants.SPARK_JUPYTER_CONTAINER_GPU_LARGE:
                                    template["@Type"] = Constants.TRAINING_ + Constants.SPARK_JUPYTER_CONTAINER_GPU_LARGE;
                                    break;
                                case Constants.SPARK_JUPYTER_CONTAINER_GPU_MEDIUM:
                                    template["@Type"] = Constants.TRAINING_ + Constants.SPARK_JUPYTER_CONTAINER_GPU_MEDIUM;
                                    break;
                                case Constants.TENSORFLOW_JUPYPETER_CONTAINER_GPU_MEDIUM:
                                    template["@Type"] = Constants.INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_MEDIUM;
                                    break;
                                case Constants.TENSORFLOW_JUPYPETER_CONTAINER_GPU_LARGE:
                                    template["@Type"] = Constants.INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_LARGE;
                                    break;
                            }
                        }
                    }
                    if (template && templatesList && Object.keys(templatesList).find(item => item === template['@Type']) === undefined) {
                        if (template['@Type'] !== Constants.NONE_ && currentTabObject["@SolutionType"] === Constants.GENERAL_PURPOSE) {
                            if (this.props.SSETid) {
                                let itemToRename = template['@Type'];
                                itemToRename = itemToRename.replace('CDH ', '');
                                if (itemToRename.toUpperCase().indexOf("CONTAINER") === -1) {
                                    template['@Type'] = itemToRename.replace(itemToRename.split(' ')[0], itemToRename.split(' ')[0] + '-Container');
                                }
                            } else {
                                let customType = "Custom";
                                template['@Type'] = customType;
                            }
                        }
                    };
                    if (template.Nodes["@PersistentStorage"] === undefined) {
                        if (template["@Type"] === Constants.CUSTOM_TEMPLATE) {
                            template.Nodes["@PersistentStorage"] = Constants.CUSTOMTEMPLATE_DEFAULTVALUE;
                        } else {
                            template.Nodes["@PersistentStorage"] = Constants.PERSISTENT_STORAGE_DEFAULTVALUE;
                        }
                    }
                })
            }
        }

        let loadTemplates = [];
        let noOfTemplates = 1
        if (Array.isArray(currentTabObject.Templates.Template)) {
            if (currentTabObject.Templates.Template.filter(x => x["@Type"] === Constants.NONE_).length > 1) {
                currentTabObject.Templates.Template = currentTabObject.Templates.Template.filter(x => x["@Type"] !== Constants.NONE_);
            }
            this.setDefaultTemplate();
            if (currentTabObject.Templates.Template.length === 0) {
                currentTabObject.Templates.Template.push(defaultTemplate);
            }
            noOfTemplates = currentTabObject.Templates.Template.length;
            if (currentTabObject.Templates.Template[noOfTemplates - 1]["@Type"] !== "None") {
                const index = currentTabObject.Templates.Template.findIndex(template => template["@Type"] === Constants.NONE_);
                if (index > -1) {
                    currentTabObject.Templates.Template.splice(index, 1)
                }
                currentTabObject.Templates.Template.push(defaultTemplate);
            }
            noOfTemplates = currentTabObject.Templates.Template.length;
        }

        for (let templateNumber = 0; templateNumber < noOfTemplates; templateNumber++) {
            let displayTemplate = true;
            if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                displayTemplate = false;
                if (currentTabObject.Templates.Template[templateNumber]["@InputMode"] === Constants.MLOPS && currentTabObject.Templates.Template[templateNumber]["@Type"] !== Constants.DATA_FABRIC) {
                    displayTemplate = true;
                }
            }
            if (displayTemplate) {
                let textBoxes12345disabled = currentTabObject.Templates.Template[templateNumber]["@Type"] === "None" ? true : false;
                let textBoxes12345bgclr = textBoxes12345disabled ? '1px solid rgba(0,0,0,.15)' : '1px solid #01a982';
                let gpuTextBoxdisabled = (currentTabObject.Templates.Template[templateNumber]["@Type"].indexOf("GPU") === -1 && currentTabObject.Templates.Template[templateNumber]["@Type"] !== "Custom" && (currentTabObject["@SolutionType"] != Constants.MLOPS || textBoxes12345disabled)) ? true : false
                let gpuTextBoxbgclr = gpuTextBoxdisabled ? '1px solid rgba(0,0,0,.15)' : '1px solid #01a982';
                let selectedTemplate = currentTabObject.Templates.Template[templateNumber]["@Type"];
                let configurationType = currentTabObject.Templates.Template[templateNumber]["@ConfigType"];

                loadTemplates.push(
                    <Box direction="row" pad={{ between: 'small' }} >
                        <ReactTooltip place="right" />
                        <Box style={{ width: Constants.configurationWidth }}>
                            <Select placeHolder='Kuberenetes' style={{ marginBottom: '1px' }} value={configurationType} options={["EPIC", "Kubernetes"]} onChange={(e) => this.onConfigTypeChange(e, templateNumber)} />
                        </Box>
                        <Box style={{ width: Constants.templateWidth }} data-tip={selectedTemplate}>
                            <Select placeHolder='None' style={{ marginBottom: '1px' }} value={selectedTemplate} options={List} onChange={(e) => this.onNodeTemplateChange(e, templateNumber)} />
                        </Box>
                        <TextInput style={{ border: textBoxes12345bgclr, width: Constants.clustersWidth }} disabled={textBoxes12345disabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"]} onDOMChange={(e) => this.OnvalueChange(e, VIRTUALCLUSTERS, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, VIRTUALCLUSTERS, "Blur", templateNumber)} />
                        <TextInput style={{ border: textBoxes12345bgclr, width: Constants.nodesPerClusterWidth }} disabled={textBoxes12345disabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"]} onDOMChange={(e) => this.OnvalueChange(e, VIRTUALNODESPERCLUSTER, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, VIRTUALNODESPERCLUSTER, "Blur", templateNumber)} />
                        <TextInput style={{ border: textBoxes12345bgclr, width: Constants.coresWidth }} disabled={textBoxes12345disabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@vCPUPerNode"]} onDOMChange={(e) => this.OnvalueChange(e, CPUCORES, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, CPUCORES, "Blur", templateNumber)} />
                        <TextInput style={{ border: textBoxes12345bgclr, width: Constants.memoryWidth }} disabled={textBoxes12345disabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@vMemoryPerNode"]} onDOMChange={(e) => this.OnvalueChange(e, MEMORY, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, MEMORY, "Blur", templateNumber)} />
                        <TextInput style={{ border: textBoxes12345bgclr, width: Constants.EphemeralStorageWidth }} disabled={textBoxes12345disabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@StoragePervNode"]} onDOMChange={(e) => this.OnvalueChange(e, NODESTORAGE, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, NODESTORAGE, "Blur", templateNumber)} />
                        <TextInput style={{ border: textBoxes12345bgclr, width: Constants.persistentStorageWidth }} disabled={textBoxes12345disabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@PersistentStorage"]} onDOMChange={(e) => this.OnvalueChange(e, PERSISTENT_STORAGE, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, PERSISTENT_STORAGE, "Blur", templateNumber)} />
                        <TextInput style={{ border: gpuTextBoxbgclr, width: Constants.GPUsWidth }} disabled={gpuTextBoxdisabled} value={currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"]} onDOMChange={(e) => this.OnvalueChange(e, GPUS, "Change", templateNumber)} onBlur={(e) => this.OnvalueChange(e, GPUS, "Blur", templateNumber)} />
                    </Box>
                )
            }
        }
        return loadTemplates;
    }
    renderErrorPopup = (msg, heading) => {
        return <Layer style={{ zIndex: '500 !important' }}>
            <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                    <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>{heading}</Heading>
                </Box>
                <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.layerclose.bind(this)} >
                    <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                </Box>
            </Box>
            <Box style={{ padding: "10px" }}>
                <Paragraph>{msg}</Paragraph>
            </Box>
        </Layer>
    }

    updateFinishButton = () => {
        let disableFinishButton = false;
        let displayText = true;
        let selectedServices = this.props.workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_)
        if (selectedServices.length === 0) {
            disableFinishButton = true;
        }
        selectedServices.map(solution => {
            if (solution.Templates.Template.filter(template => template["@Type"] !== "None").length === 0) {
                if (selectedServices.length < 2) {
                    displayText = false;
                }
                disableFinishButton = true;
            } else {
                if (solution.NonGPUValue.isCalculated === 'false' && solution.GPUValue.isCalculated === 'false' && solution.StorageValue.isCalculated === 'false') {
                    disableFinishButton = true;
                }
            }
        })
        if (disableFinishButton) {
            if (displayText) {
                this.props.workload.UserInputs.Environments.configureInAllServicesText = Constants.tRUE_;
                configureInAllServicesText = true;
            }
            if (this.props.activeSession.isSizeEnabled) {
                this.props.OnToggleSizeButton(false);
            }
        } else {
            if (!this.props.activeSession.isSizeEnabled) {
                this.props.OnToggleSizeButton(true);
            }
            this.props.workload.UserInputs.Environments.configureInAllServicesText = Constants.fALSE_;
            configureInAllServicesText = false;
        }
    }

    updateGrowthObject = () => {
        if (this.props.workload.UserInputs.Environments.Growth) {
            if (!Array.isArray(this.props.workload.UserInputs.Environments.Growth.Host)) {
                let growthObject = this.props.workload.UserInputs.Environments.Growth.Host;
                this.props.workload.UserInputs.Environments.Growth.Host = [];
                this.props.workload.UserInputs.Environments.Growth.Host.push(growthObject);
            }
        }
    }

    onCheckBoxChange = (correspondingTabName) => {
        let actionTab = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === correspondingTabName);
        if (actionTab["@isSelected"] === Constants.yES_) {
            actionTab["@isSelected"] = Constants.nO_;
        } else {
            actionTab["@isSelected"] = Constants.yES_;
            updatePersistentStorage = true;
        }
        if (actionTab["@SolutionType"] === Constants.CAAS_) {
            let VMWare = this.props.workload.UserInputs.Environments.HadoopServices.VMWare;
            if (actionTab["@isSelected"] === Constants.yES_) {
                let VMWareLicenses = this.props.ServiceError.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License
                VMWare["@vCenter"] = VMWareLicenses.find(license => license["@Type"] === Constants.VMWARE_VCENTER).Item.find(license => license !== Constants.NONE_ && license !== Constants.VMWARE_VCENTER_3YRS);
                VMWare["@vSphere"] = VMWareLicenses.find(license => license["@Type"] === Constants.VMWARE_VSPHERE).Item.find(license => license !== Constants.NONE_ && license !== Constants.VMWARE_VSPHERE_3YRS);
                //   VMWare["@vRealize"] = VMWareLicenses.find(license => license["@Type"] === Constants.VMWARE_VREALIZE).Item.find(license => license !== Constants.NONE_);
                //   VMWare["@vSAN"] = VMWareLicenses.find(license => license["@Type"] === Constants.VMWARE_VSAN).Item.find(license => license !== Constants.NONE_);
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@VMWare"] = Constants.tRUE_;
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@VMWare"] = Constants.tRUE_;
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@VMWare"] = Constants.tRUE_;
                this.props.workload.UserInputs.Environments.Licenses.Nimble = Constants.tRUE_;
            } else {
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@VMWare"] = this.props.workload.UserInputs.Environments.VMWareUserChoice;
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@VMWare"] = this.props.workload.UserInputs.Environments.MasterVMWareUserChoice;
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@VMWare"] = this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice
                this.props.workload.UserInputs.Environments.Licenses.Nimble = this.props.workload.UserInputs.Environments.NimbleUserChoice;
                for (const key in VMWare) {
                    VMWare[key] = Constants.NONE_;
                }
            }
        }
        if (actionTab["@SolutionType"] === Constants.GENERAL_PURPOSE || actionTab["@SolutionType"] === Constants.MLOPS) {
            if (actionTab["@isSelected"] === Constants.yES_) {
                if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@VMWare"] === Constants.tRUE_) {
                    this.props.workload.UserInputs.Environments.Licenses.Nimble = Constants.tRUE_;
                }

            }
        }
        // if (actionTab["@SolutionType"] === Constants.MLOPS && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined && this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
        //     if (actionTab["@isSelected"] === Constants.yES_) {
        //         this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
        //             if (Services['@Type'] === "Data Apps w/ML Ops") {
        //                 Services['@IsSelected'] = Constants.tRUE_.toString();
        //                 Services['@Description'] = this.props.sessionsDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(item => item['@Type'] === 'Data Apps w/ML Ops').Item.filter(option => option !== 'None')[0];
        //             }
        //         })
        //     } else {
        //         this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
        //             if (Services['@Type'] === "Data Apps w/ML Ops") {
        //                 Services['@IsSelected'] = Constants.fALSE_.toString();
        //             }
        //         })
        //     }
        // }
        updateControllerHostCount(this.props.workload, HAIncluded);
        updateMasterHostCount(this.props.workload, HAIncluded);
        this.props.workload.UserInputs.Environments.ManagementHosts.Server.map(host => {
            let serverName = getGatewayandControllerHost(this.props.workload, host["@Type"]);
            if (serverName !== host["@Name"]) {
                host["@Name"] = serverName
                this.props.ServiceError.guiState.updateManagementDetails = true;
            }
        })
        this.updateFinishButton();
        if (this.props.currentTab) {
            this.props.changeCurrentTab(false);
        } else {
            this.props.changeCurrentTab(true);
        }
        this.setState({});
    }


    MLOpsCheckBoxChange = (event) => {
        this.setDefaultTemplate();
        if (event.target.id === Constants.MLOPS_TEMPLATES) {
            if (this.state.MLOpsTemplatesCheckBox) {
                this.state.MLOpsTemplatesCheckBox = false;
                currentTabObject.Templates.Template = currentTabObject.Templates.Template.filter(template => template["@InputMode"] !== Constants.MLOPS);
            } else {
                this.state.MLOpsTemplatesCheckBox = true;
                for (const key of Object.keys(this.props.Templates[Constants.MLOPS])) {
                    if (this.props.Templates[Constants.MLOPS][key]["isDefault"]) {
                        let newTemplate = JSON.parse(JSON.stringify(defaultTemplate));
                        newTemplate["@InputMode"] = Constants.MLOPS;
                        newTemplate["@Type"] = key;
                        newTemplate.Nodes["@vClusters"] = this.props.Templates[Constants.MLOPS][key]["i_ClusterQty"].toString();
                        newTemplate.Nodes["@vNodesPerCluster"] = this.props.Templates[Constants.MLOPS][key]["i_NodesPerCluster"].toString();
                        newTemplate.Nodes["@MinvNodes"] = this.props.Templates[Constants.MLOPS][key]["i_MinvNodes"].toString();
                        newTemplate.Nodes["@vCPUPerNode"] = this.props.Templates[Constants.MLOPS][key]["i_vCPUs"].toString();
                        newTemplate.Nodes["@vMemoryPerNode"] = this.props.Templates[Constants.MLOPS][key]["d_vMemory"].toString();
                        newTemplate.Nodes["@StoragePervNode"] = this.props.Templates[Constants.MLOPS][key]["d_NodeStorage"].toString();
                        newTemplate.Nodes["@PersistentStorage"] = this.props.Templates[Constants.MLOPS][key]["d_PersistentStorage"].toString();
                        newTemplate.Nodes["@userGPUs"] = this.props.Templates[Constants.MLOPS][key]["i_GPUs"].toString();
                        newTemplate.Nodes["@GPUs"] = (parseInt(newTemplate.Nodes["@vClusters"], 10) * parseInt(newTemplate.Nodes["@vNodesPerCluster"], 10) * parseInt(newTemplate.Nodes["@userGPUs"], 10)).toString();
                        currentTabObject.Templates.Template.push(newTemplate);
                    }
                }
            }
        } else if (event.target.id === Constants.MLOPS_IMAGE_PROCESSING) {
            if (this.state.MLOpsImageProcessingCheckBox) {
                this.state.MLOpsImageProcessingCheckBox = false;
                currentTabObject.Templates.Template = currentTabObject.Templates.Template.filter(template => template["@InputMode"] !== Constants.IMAGE_PROCESSING);
            } else {
                this.state.MLOpsImageProcessingCheckBox = true;
                let inferenceTemplate = { ...defaultTemplate }
                inferenceTemplate["@InputMode"] = Constants.IMAGE_PROCESSING;
                inferenceTemplate["@ConfigType"] = Constants.EPIC_;
                inferenceTemplate.Nodes["@ImagesPerSec"] = "0";
                inferenceTemplate["@Type"] = Constants.INFERENCE_;
                inferenceTemplate.Nodes["@GPUType"] = T4_GPU;
                inferenceTemplate.Nodes["@vClusters"] = "1";
                inferenceTemplate.Nodes["@vNodesPerCluster"] = "1";
                currentTabObject.Templates.Template.push(inferenceTemplate);
                let trainingTemplate = JSON.parse(JSON.stringify(inferenceTemplate));
                trainingTemplate["@Type"] = Constants.TRAINING;
                trainingTemplate.Nodes["@GPUType"] = A100_PCIE_80GB_GPU;
                trainingGPUvalue = A100_PCIE_80GB_GPU;
                currentTabObject.Templates.Template.push(trainingTemplate);
            }
        }
        updateControllerHostCount(this.props.workload, HAIncluded);
        updateMasterHostCount(this.props.workload, HAIncluded);
        this.calculateRecommendationButtonValidation();
        this.setState({});
    }

    onImageProcChange = (e, templateType, DOMevent) => {
        if (DOMevent === Constants.CHANGE) {
            let value = parseInt(e.target.value, 10);
            let maxValue = 999999;
            if (isNaN(value)) {
                e.target.value = "";
            }
            else if (value >= 0 && value <= maxValue) {
                e.target.value = value.toString();
            } else if (value > maxValue) {
                e.target.value = e.target.value.slice(0, -1);
            }
        }
        if (DOMevent === Constants.BLUR) {
            if (e.target.value === "") {
                e.target.value = "0";
            }
        }
        currentTabObject.Templates.Template.find(template => template["@Type"] === templateType).Nodes["@ImagesPerSec"] = e.target.value;
        this.calculateRecommendationButtonValidation();
        this.setState({});
    }

    onMLOPsGPUChange = (e, templateType) => {
        let template = currentTabObject.Templates.Template.find(template => template["@Type"] === templateType);
        if (template.Nodes["@GPUType"] !== e.option) {
            if (templateType === "Training") {
                trainingGPUvalue = e.option;
                isGPUvalueChanged = false;
            }
            template.Nodes["@GPUType"] = e.option;
            this.calculateRecommendationButtonValidation();
            this.setState({});
        }
    }

    setDefaultTemplate = () => {
        defaultTemplate = {
            "@Type": Constants.NONE_,
            "@ConfigType": Constants.KUBERNETES_,
            "Nodes": {
                "@vClusters": "0",
                "@vNodesPerCluster": "0",
                "@MinvNodes": "0",
                "@vCPUPerNode": "0",
                "@vMemoryPerNode": "0",
                "@StoragePervNode": "0",
                "@PersistentStorage": "0",
                "@GPUs": "0",
                "@userGPUs": "0"
            }
        }
        if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
            defaultTemplate["@InputMode"] = Constants.MLOPS;
            defaultTemplate.Nodes["@GPUType"] = "";
            defaultTemplate.Nodes["@ImagesPerSec"] = "";
        }
    }

    renderImageProcessingUI = (templateType, GPUOptions) => {
        let template = currentTabObject.Templates.Template.find(template => template["@Type"] === templateType);
        if (!template) {
            this.setDefaultTemplate();
            let Template = JSON.parse(JSON.stringify(defaultTemplate));
            Template["@InputMode"] = Constants.IMAGE_PROCESSING;
            Template["@ConfigType"] = Constants.EPIC_;
            Template.Nodes["@ImagesPerSec"] = "0";
            Template["@Type"] = templateType;
            if (templateType === Constants.INFERENCE_) {
                Template.Nodes["@GPUType"] = T4_GPU;
            } else {
                Template.Nodes["@GPUType"] = A100_PCIE_80GB_GPU;
            }
            Template.Nodes["@vClusters"] = "1";
            Template.Nodes["@vNodesPerCluster"] = "1";
            currentTabObject.Templates.Template.push(Template);
        }
        let imageProcessingValue = template.Nodes["@ImagesPerSec"];
        let GPUValue = template.Nodes["@GPUType"];
        return (<Box direction="row" pad={{ between: 'small' }} style={{ width: '100%' }}>
            <Heading tag="h5" strong={true} style={{ width: '15%', marginTop: '26px' }}>{templateType} Workload</Heading>
            <FormField className="DiskCapacityDetails" style={{ height: '75px', width: '31%' }} error='(0-999999)' label={
                <Box direction='row' style={{ height: '25px' }}>
                    <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px" }}>Processing Images per sec</Paragraph>
                    <CircleInformationIcon data-tip="Number of images to be processed per sec. The sizer will recommend the number of GPUs required using ResNet50 Inference and Training benchmark results publised in HPE Deep Learning Performance Guide." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                </Box>}>
                <TextInput value={imageProcessingValue} onDOMChange={(e) => { this.onImageProcChange(e, templateType, Constants.CHANGE) }} onBlur={(e) => { this.onImageProcChange(e, templateType, Constants.BLUR) }} />
            </FormField>
            <FormField className="DiskCapacityDetails" style={{ height: '75px', width: '31%' }} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px" }}>GPUs</Paragraph></Box>}>
                <Select value={GPUValue} options={GPUOptions} onChange={(e) => { this.onMLOPsGPUChange(e, templateType) }} />
            </FormField>
        </Box>);
    }

    render() {
        EPICProclist = [];
        EPICGPUlist = [];
        ComptNodeList = []
        NonGPUProcList = []
        NonGPUProcFamilyList = []
        NonGPUMemoryList = []
        NonGPUOSDriveList = []
        NonGPUStrDrivetypeList = []
        NonGPUTenantStoragedrivelist = []
        GPUNodeList = []
        GPUProcList = []
        GPUProcFamilyList = []
        GPUMemoryList = []
        GPUOSDriveList = []
        GPUStrDrivetypeList = []
        GPUTenantStoragedrivelist = []
        List = [];
        let NonGPUApproxCost = ''
        let GPUApproxCost = ''
        let configurationType;
        let displayNonGPUCost = Constants.BLOCK_;
        let displayGPUCost = Constants.BLOCK_;
        let displayStorageCost = Constants.BLOCK_;
        GPUcountList = [];
        const virtualClustersLabel = "Number of clusters (or Applications)";
        const virtualClusterstoolTip = "Enter the number of clusters (or applications) per workload template. Default is 1.";
        const virtualNodesLabel = "Nodes/Containers (or pods) per cluster";
        const virtualNodestoolTip = "Enter the number of nodes/containers (or pods) per cluster. This value is configured depending on the workload template.";
        const cpuCoresLabel = "Cores per container (or pod)";
        const cpuCorestoolTip = "Number of cores required per container (or pod)";
        const memoryLabel = "Memory GB per container (or pod)";
        const memorytoolTip = "Memory configured per container (or pod) in GB";
        const nodeStorageLabel = "Ephemeral Storage GB per container (or pod)";
        const nodeStoragetoolTip = "Enter the amount of Ephemeral storage in GB per container (or pod). Ephemeral storage is built from the local storage in each host. It is used for the disk volumes that back the local storage for each virtual node.";
        const persistentStorageLabel = "Persistent Storage GB per cluster (or pod)";
        const persistentStoragetoolTip = "Enter the total persistent storage required for the container in TB on the HPE Ezmeral " + Constants.RE + " platform (Calculating 1TB = 1024GB, value rounded up).";
        const gpusLabel = "GPU per container (or pod)";
        const gpustoolTip = "Number of GPUs required per container (or pod).";
        let NonGPURoleName = "Compute Hosts";
        let GPURoleName = "Compute Hosts with GPU";
        let nonGPUTotalsLabel = "Compute Hosts without GPUs totals :";
        let GPUTotalsLabel = "Compute Hosts with GPUs totals :";
        let displayTabs = true;
        let displayContent = Constants.NONE_;
        let isCurrentTabChecked = false;
        let MLOpsContent = Constants.NONE_;
        //let StorageRoleName = "Storage";
        let CalcButtonToolTip = "This button will determine the best solution based on price and performance for the workload entered.";
        let ConfigTypeToolTip = "Select EPIC or Kubernetes Ezmeral " + Constants.RE + " configuration";
        let persistentStorageText = '';
        let configurationMargin = Constants.ZERO_PERCENT;
        let inferenceGPUOptions = [];
        let trainingGPUOptions = [];
        let HPECPWorkloadRequirementsHeading = commonConstants.HPECPWorkloadRequirements.CP
        let HPECPRequirementsHeading = commonConstants.HPECPWorkloadRequirements.CP.replace(commonConstants.Workload, "");
        let inferenceGPUCount = 0;
        let trainingGPUcount = 0;

        if (this.props.workload !== undefined && this.props.workload !== null && this.props.workload !== "") {
            currentTabObject = this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_)
            if (currentTabObject["@isSelected"] === Constants.yES_) {
                displayContent = Constants.BLOCK_;
                isCurrentTabChecked = true;
                if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                    MLOpsContent = Constants.BLOCK_;
                }
            }
            if (this.props.ServiceError.isError) {
                const index1 = currentTabObject.Templates.ServerDetails.Server.findIndex(x => x['@Type'] === "NonGPU");
                if (index1 >= 0) {
                    currentTabObject.Templates.ServerDetails.Server[index1] = JSON.parse(JSON.stringify(this.props.ServiceError.nonGPUOldWorkload));
                }
                const index2 = currentTabObject.Templates.ServerDetails.Server.findIndex(x => x['@Type'] === "GPU");
                if (index2 >= 0) {
                    currentTabObject.Templates.ServerDetails.Server[index2] = JSON.parse(JSON.stringify(this.props.ServiceError.GPUOldWorkload));
                }
                const index3 = currentTabObject.Templates.ServerDetails.Server.findIndex(x => x['@Type'] === Constants.STORAGE_);
                if (index3 >= 0) {
                    currentTabObject.Templates.ServerDetails.Server[index3] = JSON.parse(JSON.stringify(this.props.ServiceError.StorageOldWorkload));
                }
            }

            if (this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions === TRUE) {
                noteTextforLoadingOldSolutions = <Box direction="row">
                    <Paragraph style={{ maxWidth: '100%', fontSize: '18px', marginTop: '15px', color: 'red' }}><b>Note : This Solution is loaded from a older version. Some of the inputs might not populate correctly in the sizer input screen. Please verify.</b></Paragraph>
                </Box>
            } else {
                noteTextforLoadingOldSolutions = "";
            }
        }

        if (nonGPUChanges[0] === ",")
            nonGPUChanges = nonGPUChanges.substr(1);
        if (nonGPUChanges === "") {
            nonGPUNoteText = ""
        }
        else {
            this.noteContent(nonGPUChanges, "nonGPU");
        }

        if (GPUChanges[0] === ",")
            GPUChanges = GPUChanges.substr(1);
        if (GPUChanges === "") {
            GPUNoteText = ""
        }
        else {
            this.noteContent(GPUChanges, "GPU");
        }

        if (StorageChanges[0] === ",") {
            StorageChanges = StorageChanges.substr(1);
        }
        if (StorageChanges === "") {
            StorageNoteText = "";
        } else {
            this.noteContent(StorageChanges, Constants.STORAGE_);
        }

        if (this.props.Templates !== null && this.props.Templates !== '') {
            let SolutionType = currentTabObject["@SolutionType"];
            Templatedata = this.props.Templates[SolutionType];
            for (let key in Templatedata) {
                List.push(key);
            }

        }
        if (this.props.workload !== undefined && this.props.workload !== null && this.props.workload !== "") {
            if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_) === undefined) {
                var controllerhost = {
                    "@RoleName": "Controller Host",
                    "@Name": "ProLiant XL170r Gen10",
                    "@ProcFamily": "Cascade Lake",
                    "@Proc": "4210 / 2.2GHz / 10 Cores",
                    "@NodeDisk": "HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD",
                    "@OSDisk": "HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD",
                    "@TStorageDrive": "HPE 3.84TB SATA MU SFF SC DS SSD",
                    "@TStorageDriveQty": "1",
                    "@Memory": "64 GB",
                    "@OSDiskQty": "2",
                    "@HDFSDiskQty": "",
                    "@NonOSDiskQty": "2",
                    "@StorageDiskQty": "0",
                    "@NodesCount": "1",
                    "@HAIncluded": "false"
                };
                this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)[0] = controllerhost
            }
            currentTabObject.Templates.Template.map((x, id) => {
                var UGPUs = "0"
                if (x.Nodes["@userGPUs"] === undefined) {
                    x.Nodes["@userGPUs"] = UGPUs
                }
                if (x["@Type"].indexOf(Constants.INFERENCE_) > -1) {
                    if (parseInt(x.Nodes["@userGPUs"]) > 2) {
                        x.Nodes["@userGPUs"] = "1";
                    }
                }
            })

            if (this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@HAIncluded"] === "false") {
                HAIncluded = false
            } else {
                HAIncluded = true
            }
            currentTabObject.Templates.ServerDetails.Server.filter((x) => {
                switch (x["@Type"]) {
                    case "GPU":
                        if (x["@Name"] === "HP Apollo 4200 Gen10 Server") {
                            x["@Name"] = "HPE Apollo 4200 Gen10 Server"
                        }
                        if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                            GPURoleName = x["@RoleName"];
                            GPUTotalsLabel = GPURoleName + Constants.TOTALS_TEXT;
                        }
                        GPUNodeType = x["@Name"];
                        if (x['@Name'].indexOf('m510') === -1 && x['@Name'].indexOf('e910') === -1 && x['@Name'].indexOf(E920) === -1) {
                            x['@ServerName'] = x['@Name']
                        }
                        else { x['@ServerName'] = "HP Moonshot System" }
                        GPUProcType = x["@Proc"];
                        GPUStrDrivetype = x["@NodeDisk"];
                        GPUOSDrive = x["@OSDisk"];
                        GPUNodeCoount = x["@NodesCount"];
                        GPUMemory = x["@Memory"];
                        GPUProcFamilyType = x["@ProcFamily"];
                        GPUTenantStoragedrive = x["@TStorageDrive"];
                        GPUTenantStorageDriveQuantity = x["@TStorageDriveQty"]
                        if (x["@Name"].indexOf('m510') !== -1) {
                            if (x["@TStorageDriveQty"] !== "0") {
                                x["@StorageDiskQty"] = "1";
                            }
                            else {
                                x["@StorageDiskQty"] = "2";
                            }
                        }
                        GPUNodeStorageDriveQuantity = x["@StorageDiskQty"]
                        GPUApproxCost = x["@ApproxCost"]
                        GPUCount = x["@GPUcount"]
                        if (GPUNodeType === "ProLiant XL190r Gen10") {
                            GPUcountList = ["2"]
                        }
                        else if (GPUNodeType === "ProLiant XL270d Gen10") {
                            GPUcountList = ["8", "4"]
                            if (GPUType === T4_GPU || GPUType === A100_PCIE_80GB_GPU) {
                                GPUcountList = ["8"];
                            }
                        } else if (GPUNodeType === proLiantDL360Gen10) {
                            GPUcountList = ["2"]
                        } else if (GPUNodeType === proLiantDL380Gen10) {
                            GPUcountList = ["3"]
                            if (GPUType === T4_GPU) {
                                GPUcountList = ["7"];
                            } else if (GPUType === A100_40GB_GPU || GPUType === A40_PCIE_48GB_GPU) {
                                GPUcountList = ["2"];
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_XL675D_GEN10_PLUS) {
                            GPUcountList = ["10"];
                        } else if (GPUNodeType === Constants.PROLIANT_XL645D_GEN10_PLUS) {
                            GPUcountList = ["4"];
                        } else if (GPUNodeType === Constants.PROLIANT_DL385_GEN10_PLUS) {
                            if (GPUType === T4_GPU) {
                                GPUcountList = ["8"];
                            } else {
                                GPUcountList = ["3"];
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_E910T_2U_SERVER) {
                            GPUcountList = (GPUType === T4_GPU || GPUType === Constants.T4_TESLA_GPU) ? ["3"] : ["1"];
                        } else if (GPUNodeType === Constants.PROLIANT_E910_2U_SERVER) {
                            GPUcountList = (GPUType === T4_GPU || GPUType === Constants.T4_TESLA_GPU) ? ["3"] : ["1"];
                        }
                        else if (GPUNodeType === Constants.PROLIANT_XL290N_GEN10_PLUS) {
                            if (GPUType === T4_GPU) {
                                GPUcountList = ["4"];
                            } else {
                                GPUcountList = ["2"];
                            }
                        } else if (GPUNodeType === Constants.PROLIANT_DL325_GEN10_PLUS) {
                            GPUcountList = ["3"];
                        } else if (GPUNodeType === Constants.PROLIANT_DL360_GEN10_PLUS) {
                            GPUcountList = ["2"];
                        } else if (GPUNodeType === Constants.PROLIANT_DL380_GEN10_PLUS) {
                            GPUcountList = ["3"];
                            if (GPUType === T4_GPU) {
                                GPUcountList = ["8"];
                            }
                        }
                        else if (GPUNodeType === Constants.PROLIANT_DL365_GEN10_PLUS) {
                            GPUcountList = ["2"];
                        } else if (GPUNodeType === Constants.PROLIANT_DL325_GEN10_PLUS_V2) {
                            GPUcountList = ["2"];
                        }
                        else {
                            GPUcountList = ["1"];
                        }
                        if (GPUcountList.indexOf(GPUCount) === -1) {
                            GPUCount = GPUcountList[0]
                            this.textOnChangeofConfiguration("GPU", "GPUCountPerServer")
                            x["@GPUcount"] = GPUCount
                        }


                        break;
                    case "NonGPU":
                        if (x["@Name"] === "HP Apollo 4200 Gen10 Server") {
                            x["@Name"] = "HPE Apollo 4200 Gen10 Server"
                        }
                        if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                            NonGPURoleName = x["@RoleName"];
                            nonGPUTotalsLabel = NonGPURoleName + Constants.TOTALS_TEXT;
                        }
                        ComptNodeType = x["@Name"];
                        if (x['@Name'].indexOf('m510') === -1 && x['@Name'].indexOf('e910') === -1 && x['@Name'].indexOf(E920) === -1) {
                            x['@ServerName'] = x['@Name']
                        }
                        else { x['@ServerName'] = "HP Moonshot System" }
                        NonGPUProcType = x["@Proc"];
                        NonGPUStrDrivetype = x["@NodeDisk"];
                        NonGPUOSDrive = x["@OSDisk"];
                        NonGPUNodeCount = x["@NodesCount"];
                        NonGPUMemory = x["@Memory"];
                        NonGPUProcFamilyType = x["@ProcFamily"];
                        NonGPUTenantStoragedrive = x["@TStorageDrive"];
                        NonGPUTenantStorageDriveQuantity = x["@TStorageDriveQty"]
                        if (x["@Name"].indexOf('m510') !== -1) {
                            if (x["@TStorageDriveQty"] !== "0") {
                                x["@StorageDiskQty"] = "1";
                            }
                            else {
                                x["@StorageDiskQty"] = "2";
                            }
                        }
                        NonGPUNodeStorageDriveQuantity = x["@StorageDiskQty"]
                        NonGPUApproxCost = x["@ApproxCost"]
                        break;

                    case Constants.STORAGE_:
                        if (x["@Name"] === "HP Apollo 4200 Gen10 Server") {
                            x["@Name"] = HPE_APOLLO_4200_GEN10;
                        }
                        //StorageRoleName = x["@RoleName"];
                        storageNodeType = x["@Name"];
                        storageProcFamilyType = x["@ProcFamily"];
                        storageProcType = x["@Proc"];
                        storageMemory = x["@Memory"];
                        storageNodeDrive = x["@NodeDisk"];
                        storageNodeDriveQty = x["@StorageDiskQty"];
                        storageOSDrive = x["@OSDisk"];
                        storageTenantStorageDrive = x["@TStorageDrive"];
                        storageTenantDriveQuantity = x["@TStorageDriveQty"];
                        if (x.PersistentDisks.length > 0) {
                            storageTenantDriveQuantity = x.PersistentDisks[0].Item['@qty'];
                        }
                        storageNodeCount = x["@NodesCount"];
                        storageApproxCost = x["@ApproxCost"];
                        storageMixedTenantStorage = x["@mixedTenantStorage"];
                        this.state.storageTenantDriveType = x["@TenantDriveType"];
                        break;
                }
            })
            // currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
            // storageTenantDriveQuantity = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"]
            if (updatePersistentStorage) {
                if (parseInt(currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"], 10) < parseInt(this.setPersistentStorageMinValue(), 10)) {
                    currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"] = this.setPersistentStorageMinValue();
                } else {
                    updatePersistentStorage = false;
                }
            }
            HDFSTenatStr = currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"];
            if (parseInt(HDFSTenatStr, 10) > 1200 && currentTabObject["@SolutionType"] === Constants.CAAS_) {
                persistentStorageText = <Box direction="row">
                    <Paragraph style={{ maxWidth: '100%', fontSize: '17px', marginTop: '15px', color: 'red' }}><b>Note : Persistent Storage exceeds maximum capacity configurable with the sizer. Please contact HPE Solution Architect.</b></Paragraph>
                </Box>
            }
            HDFSrepFac = currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]
            if (currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty'] === undefined) {
                currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty'] = '1';
            }
            KubClusters = currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty'];
            // if (currentTabObject.Templates.ServerDetails.Requirements['@ConfigType'] === undefined) {
            //     currentTabObject.Templates.ServerDetails.Requirements['@ConfigType'] = Constants.EPIC_;
            // }
            if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                currentTabObject.Templates.Template.map(template => {
                    if (template["@InputMode"] === "" && template["@Type"] !== Constants.DATA_FABRIC) {
                        template["@InputMode"] = Constants.IMAGE_PROCESSING;
                    }
                })
                if (currentTabObject.Templates.Template.find(template => template["@InputMode"] === Constants.MLOPS)) {
                    this.state.MLOpsTemplatesCheckBox = true;
                }
                if (currentTabObject.Templates.Template.find(template => template["@Type"] !== Constants.NONE_ && template["@InputMode"] === Constants.IMAGE_PROCESSING)) {
                    this.state.MLOpsImageProcessingCheckBox = true;
                }
                if (this.state.MLOpsImageProcessingCheckBox) {
                    currentTabObject.Templates.Template.map(template => {
                        if (!currentTabObject.Templates.Template.find(template => template["@InputMode"] === Constants.IMAGE_PROCESSING && template["@Type"] === Constants.INFERENCE_)) {
                            if (template["@InputMode"] === Constants.IMAGE_PROCESSING && template["@Category"] === Constants.INFERENCE_ && template["@Type"] !== Constants.INFERENCE_) {
                                template["@Type"] = Constants.INFERENCE_;
                            }
                        }
                        if (!currentTabObject.Templates.Template.find(template => template["@InputMode"] === Constants.IMAGE_PROCESSING && template["@Type"] === Constants.TRAINING)) {
                            if (template["@InputMode"] === Constants.IMAGE_PROCESSING && template["@Category"] === Constants.TRAINING && template["@Type"] !== Constants.TRAINING) {
                                template["@Type"] = Constants.TRAINING;
                            }
                        }
                    })
                    inferenceGPUOptions = [T4_GPU];
                    trainingGPUOptions = [A100_PCIE_80GB_GPU, V100_32GB_GPU, T4_GPU, A40_PCIE_48GB_GPU];
                }
            }
            overallConfigType = Constants.EPIC_;
            if (currentTabObject["@SolutionType"] !== Constants.MLOPS || currentTabObject['@SolutionType'] === Constants.MLOPS && this.state.MLOpsTemplatesCheckBox) {
                if (currentTabObject.Templates.Template.filter(template => template["@Type"] !== Constants.NONE_).length === 0) {
                    if (currentTabObject.Templates.Template.length > 0) {
                        overallConfigType = currentTabObject.Templates.Template.find(template => template["@Type"] === Constants.NONE_)["@ConfigType"];
                    }
                } else {
                    let kubernetesTemplates = currentTabObject.Templates.Template.filter(template => template["@ConfigType"] === Constants.KUBERNETES_ && template["@Type"] !== Constants.NONE_ && !(currentTabObject['@SolutionType'] === Constants.MLOPS && template["@InputMode"] === Constants.IMAGE_PROCESSING))
                    if (kubernetesTemplates.length > 0) {
                        overallConfigType = Constants.KUBERNETES_;
                    }
                }
            }
            if (overallConfigType === Constants.EPIC_) {
                currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty'] = Constants.QTY_ONE;
                KubClusters = Constants.QTY_ONE;
            }
            configurationType = currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"];
            if (parseInt(HDFSTenatStr, 10) >= 1 && this.noOfNonStorageTemplates() > 0) {
                if (isValueChanged || updatePersistentStorage) {
                    isValueChanged = false;
                    // if (parseInt(HDFSTenatStr, 10) * parseInt(HDFSrepFac, 10) > 60) {
                    if (parseInt(HDFSTenatStr, 10) > 0) {
                        if (currentTabObject["@SolutionType"] !== Constants.CAAS_) {
                            currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"] = Constants.yES_;
                        }
                    }
                    else {
                        currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"] = "no";
                    }
                }
                // storageHostsCheckBoxDisabled = false;
            }
            else {
                // storageHostsCheckBoxDisabled = true;
                currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"] = "no";
            }
            updatePersistentStorage = false;
            Allocationratio = currentTabObject.Templates.ServerDetails.Requirements["@AllocationRatio"]
            if (currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"] === Constants.yES_) {
                storageHostChecked = true;
            } else {
                storageHostChecked = false;
            }
            if (currentTabObject.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)) {
                GPUType = currentTabObject.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)["@GPUType"];
            }

            if (currentTabObject.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)) {
                if (this.props.NonGPUdetails !== null) {
                    NonGPUList = this.props.NonGPUdetails
                    for (let key in NonGPUList) {
                        if (currentTabObject["@SolutionType"] === Constants.CAAS_) {
                            if (key === Constants.SYN_480_GEN10 || key === Constants.SYN_480_GEN10_PLUS) {
                                ComptNodeList.push(key);
                            }
                        } else if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                            currentTabObject.Templates.Template.forEach(template => {
                                if (template["@Type"].indexOf(Constants.INFERENCE_) > -1) {
                                    inferenceGPUCount += parseInt(template.Nodes["@GPUs"], 10);
                                } else if (template["@Type"].indexOf(Constants.TRAINING) > -1) {
                                    trainingGPUcount += parseInt(template.Nodes["@GPUs"], 10);
                                }
                            })
                            if (NonGPUList[key].GPUList.indexOf(T4_GPU) > -1) {
                                ComptNodeList.push(key);
                            }
                        } else {
                            ComptNodeList.push(key);
                        }
                        if (key === ComptNodeType) {
                            computeGPUTypeOptions = NonGPUList[key].GPUList
                            if (currentTabObject["@SolutionType"] === Constants.MLOPS && inferenceGPUCount === 0) {
                                computeGPUTypeOptions = [Constants.NONE_];
                            }
                            NonGPUStrDrivetypeList = NonGPUList[key].DataDriveList;
                            NonGPUStrDrivetypeList = filterOptions(NonGPUStrDrivetypeList, configurationType, Constants.NONGPU_, Constants.DISK_);

                            NonGPUStrDrivetypeList = filterDriveList(NonGPUStrDrivetypeList, Constants.RI);

                            if (NonGPUStrDrivetypeList.length > 0 && NonGPUStrDrivetypeList.indexOf(NonGPUStrDrivetype) === -1) {
                                NonGPUStrDrivetype = NonGPUStrDrivetypeList[0];
                                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.NONGPU_)[0]["@NodeDisk"] = NonGPUStrDrivetype;
                            }
                            NonGPUTenantStoragedrivelist = NonGPUList[key].TenantDriveList;
                            NonGPUTenantStoragedrivelist = filterOptions(NonGPUTenantStoragedrivelist, configurationType, Constants.NONGPU_, Constants.DISK_);

                            NonGPUTenantStoragedrivelist = filterDriveList(NonGPUTenantStoragedrivelist, Constants.RI);

                            if (NonGPUTenantStoragedrivelist.indexOf(NonGPUTenantStoragedrive) === -1) {
                                NonGPUTenantStoragedrive = NonGPUTenantStoragedrivelist[0];
                                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.NONGPU_)[0]["@TStorageDrive"] = NonGPUTenantStoragedrive;
                            }
                            NonGPUOSDriveList = NonGPUList[key].OSDriveList
                            for (let proctype in NonGPUList[ComptNodeType].ProcessorList) {
                                NonGPUProcFamilyList.push(proctype);
                                if (proctype === NonGPUProcFamilyType) {
                                    for (let proc in NonGPUList[ComptNodeType].ProcessorList[proctype]) {
                                        NonGPUProcList.push(proc)
                                        if (proc === NonGPUProcType) {
                                            NonGPUMemoryList = NonGPUList[ComptNodeType].ProcessorList[proctype][proc]
                                        }
                                    }
                                }
                            }
                            NonGPUProcList = filterOptions(NonGPUProcList, configurationType, Constants.NONGPU_, Constants.PROCESSOR_);
                            if (NonGPUProcList.filter(processor => processor.indexOf(NonGPUProcType) > -1).length == 0) {
                                NonGPUProcType = NonGPUProcList[0];
                                this.textOnChangeofConfiguration(Constants.NONGPU_, "Processor");
                            }
                            else {
                                NonGPUProcType = NonGPUProcList.filter(processor => processor.indexOf(NonGPUProcType) > -1)[0];
                            }
                            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.NONGPU_)[0]["@Proc"] = NonGPUProcType;
                            NonGPUMemoryList = NonGPUList[ComptNodeType].ProcessorList[NonGPUProcFamilyType][NonGPUProcType];
                        }

                    }
                }
            }

            if (currentTabObject.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)) {
                if (this.props.GPUdetails !== null) {
                    GPUNodeList = []
                    GPUList = this.props.GPUdetails
                    for (let key in GPUList) {
                        GPUNodeList.push(key);
                        if (key === GPUNodeType) {
                            EPICGPUlist = GPUList[key].GPUList;
                            if (currentTabObject["@SolutionType"] === Constants.MLOPS && trainingGPUcount === 0) {
                                EPICGPUlist = [Constants.NONE_];
                                GPUType = Constants.NONE_;
                                currentTabObject.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)["@GPUType"] = GPUType;
                            }
                            GPUStrDrivetypeList = GPUList[key].DataDriveList;
                            GPUStrDrivetypeList = filterOptions(GPUStrDrivetypeList, configurationType, Constants.GPU_, Constants.DISK_);

                            GPUStrDrivetypeList = filterDriveList(GPUStrDrivetypeList, Constants.RI);

                            if (GPUStrDrivetypeList.length > 0 && GPUStrDrivetypeList.indexOf(GPUStrDrivetype) === -1) {
                                GPUStrDrivetype = GPUStrDrivetypeList[0];
                                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === GPU)[0]["@NodeDisk"] = GPUStrDrivetype;
                            }
                            GPUTenantStoragedrivelist = GPUList[key].TenantDriveList;
                            GPUTenantStoragedrivelist = filterOptions(GPUTenantStoragedrivelist, configurationType, Constants.GPU_, Constants.DISK_);

                            GPUTenantStoragedrivelist = filterDriveList(GPUTenantStoragedrivelist, Constants.RI);

                            if (GPUTenantStoragedrivelist.indexOf(GPUTenantStoragedrive) === -1) {
                                GPUTenantStoragedrive = GPUTenantStoragedrivelist[0]
                                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === GPU)[0]["@TStorageDrive"] = GPUTenantStoragedrive;
                            }
                            GPUOSDriveList = GPUList[key].OSDriveList
                            for (let proctype in GPUList[GPUNodeType].ProcessorList) {
                                GPUProcFamilyList.push(proctype);
                                if (proctype === GPUProcFamilyType) {
                                    for (let proc in GPUList[GPUNodeType].ProcessorList[proctype]) {
                                        GPUProcList.push(proc);
                                        if (proc === GPUProcType) {
                                            GPUMemoryList = GPUList[GPUNodeType].ProcessorList[proctype][proc]
                                        }
                                    }
                                }
                            }
                            GPUProcList = filterOptions(GPUProcList, configurationType, Constants.GPU_, Constants.PROCESSOR_);
                            if (GPUProcList.filter(processor => processor.indexOf(GPUProcType) > -1).length == 0) {
                                GPUProcType = GPUProcList[0];
                                this.textOnChangeofConfiguration(Constants.GPU_, "Processor");
                            } else {
                                GPUProcType = GPUProcList.filter(processor => processor.indexOf(GPUProcType) > -1)[0];
                            }
                            currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.GPU_)[0]["@Proc"] = GPUProcType;
                            GPUMemoryList = GPUList[GPUNodeType].ProcessorList[GPUProcFamilyType][GPUProcType];


                        }

                    }
                }
            }

            if (currentTabObject.Templates.ServerDetails.Server.find(role => role["@Type"] === "Storage")) {
                if (this.props.Storagedetails !== null) {
                    if (currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_).length > 0) {
                        this.storageHostAllOptions(true);
                    }
                }
            }

            if (EPICGPUlist.indexOf(GPUType) === -1 && EPICGPUlist.length > 0) {
                GPUType = EPICGPUlist[0];
                currentTabObject.Templates.ServerDetails.Server[1]['@GPUType'] = GPUType;
            }
            //Lohith's code
            if (this.state.MLOpsImageProcessingCheckBox === true && isGPUvalueChanged === false && currentTabObject["@SolutionType"] === Constants.MLOPS) {
                GPUType = EPICGPUlist.find((x) => x === trainingGPUvalue) ? trainingGPUvalue : EPICGPUlist[0];
                currentTabObject.Templates.ServerDetails.Server[1]['@GPUType'] = GPUType;
            }
            currentTabObject.Templates.ServerDetails.Server.filter((x) => {
                switch (x["@Type"]) {
                    case "GPU":
                        if (GPUOSDriveList.length > 0 && GPUOSDriveList.indexOf(GPUOSDrive) === -1) {
                            GPUOSDrive = GPUOSDriveList[0]
                            this.textOnChangeofConfiguration("GPU", "OSDrive")
                            x["@OSDisk"] = GPUOSDrive;
                        }
                        if (GPUProcList.length > 0 && GPUProcList.indexOf(GPUProcType) === -1) {
                            GPUProcType = GPUProcList[0]
                            this.textOnChangeofConfiguration("GPU", "Processor")
                            x["@Proc"] = GPUProcType;
                        }
                        break;
                    case "NonGPU":
                        if (NonGPUOSDriveList.length > 0 && NonGPUOSDriveList.indexOf(NonGPUOSDrive) === -1) {
                            NonGPUOSDrive = NonGPUOSDriveList[0]
                            this.textOnChangeofConfiguration("nonGPU", "OSDrive")
                            x["@OSDisk"] = NonGPUOSDrive;
                        }
                        if (NonGPUProcList > 0 && NonGPUProcList.indexOf(NonGPUProcType) === -1) {
                            NonGPUProcType = NonGPUProcList[0]
                            this.textOnChangeofConfiguration("nonGPU", "Processor")
                            x["@Proc"] = NonGPUProcType;
                        }
                        break;
                }
            })

            if (this.props.NonGPUdetails !== null) {
                NonGPUList = this.props.NonGPUdetails
                for (let key in NonGPUList) {
                    if (key === ComptNodeType) {
                        for (let proctype in NonGPUList[ComptNodeType].ProcessorList) {
                            if (proctype === NonGPUProcFamilyType) {
                                for (let proc in NonGPUList[ComptNodeType].ProcessorList[proctype]) {
                                    if (proc === NonGPUProcType) {
                                        NonGPUMemoryList = NonGPUList[ComptNodeType].ProcessorList[proctype][proc];
                                        NonGPUMemoryList = filterOptions(NonGPUMemoryList, configurationType, Constants.NONGPU_, Constants.MEMORY_);
                                        if (NonGPUMemoryList.indexOf(NonGPUMemory) === -1) {
                                            NonGPUMemory = NonGPUMemoryList[0];
                                        }
                                    }
                                }
                            }
                        }

                    }

                }
            }
            if (this.props.GPUdetails !== null) {
                GPUList = this.props.GPUdetails
                GPUNodeList = []
                for (let key in GPUList) {
                    GPUNodeList.push(key);
                    if (key === GPUNodeType) {
                        for (let proctype in GPUList[GPUNodeType].ProcessorList) {
                            if (proctype === GPUProcFamilyType) {

                                for (let proc in GPUList[GPUNodeType].ProcessorList[proctype]) {
                                    if (proc === GPUProcType) {
                                        GPUMemoryList = GPUList[GPUNodeType].ProcessorList[proctype][proc];
                                        GPUMemoryList = filterOptions(GPUMemoryList, configurationType, Constants.GPU_, Constants.MEMORY_);
                                    }
                                }
                            }
                        }

                    }

                }
            }
            if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined) {
                if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR === undefined) {
                    this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR = {
                        '@IsSelected': 'false',
                        License: [
                            {
                                '@Type': "Data Apps",
                                '@IsSelected': "false",
                                '@Description': "None",
                            },
                            {
                                '@Type': "Data Apps Universal",
                                '@IsSelected': "false",
                                '@Description': "None",
                            },
                            {
                                '@Type': "Data Apps w/ML Ops",
                                '@IsSelected': "false",
                                '@Description': "None",
                            },
                            {
                                '@Type': "Data Apps Universal w/ML Ops",
                                '@IsSelected': "false",
                                '@Description': "None",
                            }
                        ]
                    }

                }
            }

            if (this.props.workload.UserInputs.Environments.SSETMode) {
                if (this.props.workload.UserInputs.Environments.SSETMode !== Constants.EZMERAL_) {
                    displayTabs = false;
                }
                HPECPWorkloadRequirementsHeading = commonConstants.HPECPWorkloadRequirements[this.props.workload.UserInputs.Environments.SSETMode];
                HPECPRequirementsHeading = HPECPWorkloadRequirementsHeading.replace(commonConstants.Workload, "")
            }
            this.props.workload.UserInputs.Environments.WorkloadRequirementsHeading = HPECPWorkloadRequirementsHeading;
            this.props.workload.UserInputs.Environments.RequirementsHeading = HPECPRequirementsHeading;
        }
        if (commonConstants.DisplayPrice) {
            if (NonGPUApproxCost !== undefined && NonGPUApproxCost !== null) {
                nonGPUCost = NonGPUApproxCost.indexOf('$') === -1 ? NonGPUApproxCost : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(NonGPUApproxCost.replace('$', ''))
            }
            if (GPUApproxCost !== undefined && GPUApproxCost !== null) {
                GPUCost = GPUApproxCost.indexOf('$') === -1 ? GPUApproxCost : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(GPUApproxCost.replace('$', ''))
            }
            if (storageApproxCost !== undefined && storageApproxCost !== null) {
                storageCost = storageApproxCost.indexOf('$') === -1 ? storageApproxCost : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(storageApproxCost.replace('$', ''));
            }
            if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
                if (parseInt(nonGPUCost.slice(1), 10) === 0) {
                    displayNonGPUCost = Constants.NONE_;
                }
                if (parseInt(GPUCost.slice(1), 10) === 0) {
                    displayGPUCost = Constants.NONE_;
                }
                if (parseInt(storageCost.slice(1), 10) === 0) {
                    displayStorageCost = Constants.NONE_;
                }
            }
        }
        var Loadingdata = ''
        if (this.props.isCal) {
            let Data = "Please wait while Calculating the Host Count."
            Loadingdata = <Layer style={{ zIndex: '500 !important' }}>
                <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
                    <Spinning size='small' style={{ color: "#fff" }} />
                    <Heading tag='h5' margin='none' style={{ color: "#fff" }}>{Data}</Heading>
                </Box>
            </Layer>
        }
        var Loadinginitialdata = ''
        if (this.props.isLoading) {
            let Data = "Please wait while Fetching the data."
            Loadinginitialdata = <Layer style={{ zIndex: '500 !important' }}>
                <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
                    <Spinning size='small' style={{ color: "#fff" }} />
                    <Heading tag='h5' margin='none' style={{ color: "#fff" }}>{Data}</Heading>
                </Box>
            </Layer>
        }

        if (HoustcountExceded || this.state.nvmeMaxedOut) {

            if (this.state.nvmeMaxedOut) {
                Houstcountdata = this.renderErrorPopup(NVMEMAX_POPUP_TEXT, ERROR_TEXT);
            } else Houstcountdata = this.renderErrorPopup("Host count should be greater than or equal to " + Minhostcount + " and less than or equal to " + Maxhostcount, ERROR_TEXT);
        }
        let displynonvalidate = "none"
        NonGPUDisplay = "none"
        GPUDisplay = 'none'
        let totaldisplay = "none"
        let nonGPURecommendationDisplay = NONE;
        let GPURecommendationDisplay = NONE;
        let storageRecommendationDisplay = NONE;
        let persistentDriveNoteDisplay = "";
        storageDisplay = NONE;
        displayStorageTotals = NONE;

        if (currentTabObject.NonGPUValue.isCalculated === 'true' || currentTabObject.GPUValue.isCalculated === 'true' || currentTabObject.StorageValue.isCalculated === 'true') {
            if (!this.props.ConfigButton) {
                this.props.Calcbutton(true);
            }
            if (currentTabObject.displayNoteTextForOldSolutions !== TRUE) {
                totaldisplay = VISIBLE;
            }
            if (currentTabObject.NonGPUValue.isCalculated === 'true') {
                NonGPUDisplay = VISIBLE;
                displynonvalidate = VISIBLE;
                if (currentTabObject.displayNoteTextForOldSolutions !== TRUE) {
                    nonGPURecommendationDisplay = VISIBLE;
                }
            }
            if (currentTabObject.GPUValue.isCalculated === 'true') {
                GPUDisplay = VISIBLE;
                if (currentTabObject.displayNoteTextForOldSolutions !== TRUE) {
                    GPURecommendationDisplay = VISIBLE;
                }
            }
            if (currentTabObject.StorageValue.isCalculated === 'true') {
                storageDisplay = VISIBLE;
                if (currentTabObject.displayNoteTextForOldSolutions !== TRUE) {
                    storageRecommendationDisplay = VISIBLE;
                }
                if (currentTabObject.displayNotePersistentDriveChange === TRUE) {
                    persistentDriveNoteDisplay = <Box>
                        <Paragraph style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px', maxWidth: '100%' }}>Note : Persistent Drive capacity was changed, please review the number of drives configured and adjust if required.</Paragraph>
                    </Box>;
                }
                var storageTemplates = 0;
                var nonStorageTemplates = 0;
                currentTabObject.Templates.Template.map(template => {
                    if (template["@Type"] !== "None") {
                        if (template["@Type"].indexOf(Constants.STORAGE_) !== -1) {
                            storageTemplates++;
                        } else {
                            nonStorageTemplates++;
                        }
                    }
                })
                if (currentTabObject.isWLorSLLoaded === Constants.tRUE_) {
                    if (storageTemplates > 0 && nonStorageTemplates == 0) {
                        displayStorageTotals = VISIBLE;
                    }
                }
                else {
                    displayStorageTotals = VISIBLE;
                }
            }
            // if (!this.props.activeSession.isSizeEnabled) {
            //     this.props.OnToggleSizeButton(true);
            // }
        } else {
            if (currentTabObject.Templates.Template.filter(x => x["@Type"] !== "None").length > 0) {
                if (this.props.ConfigButton) {
                    let NoValues = this.checkValues();
                    if (!NoValues) {
                        this.props.Calcbutton(false);
                        this.makeisCalculatedFalse();
                    }
                }
            } else {
                if (!this.props.ConfigButton) {
                    this.props.Calcbutton(true);
                }
            }
        }
        if (displynonvalidate === "none") {
            currentTabObject.Templates.ServerDetails.Server.filter((x) => {
                if (x["@Type"] === "NonGPU") {
                    x["@NodesCount"] = '0';
                }
            })
        }
        if (GPUDisplay === "none") {
            currentTabObject.Templates.ServerDetails.Server.filter((x) => {
                if (x["@Type"] === "GPU") {
                    x["@NodesCount"] = '0';
                }
            })
        }
        if (storageDisplay === NONE) {
            currentTabObject.Templates.ServerDetails.Server.filter((x) => {
                if (x["@Type"] === Constants.STORAGE_) {
                    x["@NodesCount"] = '0';
                }
            })
        }

        if (GPUTenantStoragedrive === "None") {
            GPUTenantStoragedrivelist = []
        }

        if (NonGPUTenantStoragedrive === "None") {
            NonGPUTenantStoragedrivelist = []
        }
        let ErrorPopup = ''
        if (this.props.ServiceError.isError) {
            HostChanged = false


            ErrorPopup = <Layer style={{ zIndex: '500 !important' }}>
                <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                    <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                        <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Error</Heading>
                    </Box>
                    <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.Errorclose.bind(this)} >
                        <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                    </Box>
                </Box>
                <Box style={{ padding: "10px" }}>
                    <Paragraph>{this.props.ServiceError.Errormsg}.</Paragraph>
                </Box>
            </Layer>
        } else {

        }
        var HDFSDisplay = 'none'
        if (parseInt(HDFSTenatStr, 10) > 0) {
            HDFSDisplay = ""
        }

        let Recomdbutn = ''
        let notedispaly = "none"
        if (!this.props.ConfigButton) {
            notedispaly = " "
            Recomdbutn = <Button accent="true" label="Calculate Sizer Recommendation" onClick={this.onEpicClick.bind(this)} />
            configurationMargin = Constants.CONFIGURATION_MARGIN;
            if (currentTabObject["@isSelected"] === Constants.yES_) {
                if (this.props.activeSession.isSizeEnabled) {
                    this.props.OnToggleSizeButton(false);
                }
            }
        } else {
            Recomdbutn = <Button accent="true" label="Calculate Sizer Recommendation" />
        }
        let HostChangedLayer = ''
        if (HostChanged && !this.props.isCal) {
            HostChanged = false
        }
        if (this.props.ServiceError.isError || this.props.ServiceError.Errormsg !== "") {
            if (currentTabObject.NonGPUValue.isCalculated === 'false' || currentTabObject.GPUValue.isCalculated === 'false' || currentTabObject.StorageValue.isCalculated === 'false') {
                if (currentTabObject.GPUValue.isCalculated === 'false') {
                    GPUDisplay = "none";
                    GPURecommendationDisplay = NONE;
                }
                if (currentTabObject.NonGPUValue.isCalculated === 'false') {
                    NonGPUDisplay = "none";
                    displynonvalidate = "none";
                    nonGPURecommendationDisplay = NONE;
                }
                if (currentTabObject.StorageValue.isCalculated === 'false') {
                    storageDisplay = NONE;
                    displayStorageTotals = NONE;
                    storageRecommendationDisplay = NONE;
                }
                this.props.activeSession.FirstClik.val = true
                if (currentTabObject.NonGPUValue.isCalculated === 'false' && currentTabObject.GPUValue.isCalculated === 'false' && currentTabObject.StorageValue.isCalculated === 'false') {
                    totaldisplay = "none";
                    if (this.props.activeSession.isSizeEnabled) {
                        this.props.OnToggleSizeButton(false);
                    }
                }

            }
        }

        this.updateGrowthObject();

        // if (!this.props.controllerconfigChanged && this.props.controllerdetails !== null && (displynonvalidate !== NONE || GPUDisplay !== NONE || storageDisplay !== NONE)) {
        //     this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter((x) => {
        //         if (x["@Type"] === Constants.CONTROLLER_) {
        //             let serverName = getGatewayandControllerHost(this.props.workload);
        //             updateControllerHostCount(this.props.workload);
        //             if (serverName === HPE_APOLLO_4200_GEN10) {
        //                 x["@Name"] = PROLIANT_XL170R_GEN10;
        //             } else {
        //                 x["@Name"] = serverName; 
        //             }
        //             if(x["@Name"].indexOf('m510') === -1 && x["@Name"].indexOf('e910') === -1) {
        //                 x["@ServerName"] = x["@Name"]
        //             } else {
        //                 x["@ServerName"] = HPE_MOONSHOT_SYSTEM;
        //             }
        //             for( var key in this.props.controllerdetails ) {
        //                 if(key === x["@Name"]) {
        //                     if (Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList).indexOf(x["@ProcFamily"]) === -1) {
        //                         x["@ProcFamily"] = Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList)[0];
        //                     }
        //                     if (Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]]).indexOf(x["@Proc"]) === -1) {
        //                         x["@Proc"] = Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]])[0];
        //                     }
        //                     if (this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]][x["@Proc"]].indexOf(x["@Memory"]) === -1) {
        //                         x["@Memory"] = this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]][x["@Proc"]][0];
        //                     }
        //                     if (this.props.controllerdetails[x["@Name"]].DataDriveList.indexOf(x["@NodeDisk"]) === -1) {
        //                         x["@NodeDisk"] = this.props.controllerdetails[x["@Name"]].DataDriveList[0];
        //                     }
        //                     if (this.props.controllerdetails[x["@Name"]].OSDriveList.indexOf(x["@OSDisk"]) === -1) {
        //                         x["@OSDisk"] = this.props.controllerdetails[x["@Name"]].OSDriveList[0];
        //                     }
        //                     if (this.props.controllerdetails[x["@Name"]].TenantDriveList.indexOf(x["@TStorageDrive"])=== -1) {
        //                         x["@TStorageDrive"] = this.props.controllerdetails[x["@Name"]].TenantDriveList[0];
        //                     }
        //                 }
        //             }
        //             if (parseInt(x["@StorageDiskQty"], 10)+parseInt(x["@OSDiskQty"], 10)+parseInt(x["@TStorageDriveQty"], 10) > this.props.controllerdetails[x["@Name"]].MaxDrives) {
        //                 if(parseInt(x["@TStorageDriveQty"], 10) === 0) {
        //                     x["@StorageDiskQty"] = (this.props.controllerdetails[x["@Name"]].MaxDrives - parseInt(x["@OSDiskQty"], 10)).toString();
        //                 } else {
        //                     if(parseInt(x["@StorageDiskQty"], 10) > 3) {
        //                         x["@StorageDiskQty"] = "3";
        //                     }
        //                     x["@TStorageDriveQty"] = (this.props.controllerdetails[x["@Name"]].MaxDrives - parseInt(x["@OSDiskQty"], 10)- parseInt(x["@StorageDiskQty"], 10)).toString();
        //                 }
        //             }
        //         }
        //     })
        // }

        currentTabObject.Templates.ServerDetails.Server.map((x) => {
            if (x['@Name'] !== undefined) {
                if (x['@Name'].indexOf(Constants.MOONSHOT_510) === -1 && x['@Name'].indexOf(Constants.E910) === -1 && x['@Name'].indexOf(E920) === -1 && x["@Name"].indexOf(Constants.MOONSHOT_750) === -1) {
                    x['@ServerName'] = x['@Name']
                    x['@ProcQty'] = "2"
                }
                else {
                    x['@ServerName'] = "HP Moonshot System"
                    x['@ProcQty'] = "1"
                }
            }
        })
        this.onCalcTempClick();
        if (currentTabObject.Templates.ServerDetails.Server.find(x => x["@Type"] === NON_GPU)) {
            if (currentTabObject.Templates.Template.filter(x => x[Constants.ATTRIBUTE_TYPE].indexOf(Constants.INFERENCE_) > -1).length > 0) {
                GPUTypeinComputeNode = true;
                if (inferenceGPUCount === 0) {
                    computeGPUType = Constants.NONE_;
                } else {
                    computeGPUType = T4_GPU;
                }
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === NON_GPU)[0]["@GPUType"] = computeGPUType;
            } else {
                GPUTypeinComputeNode = false;
                currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === NON_GPU)[0]["@GPUType"] = "";
            }
        }

        maxGPUCount = Math.max(...GPUcountList);
        maxGPUCount = maxGPUCount > 0 ? maxGPUCount : 1;


        updateEzemeralGrowthItems(this.props.workload);

        const loadedOldSolution = this.props.workload && this.props.workload.UserInputs.Environments.isOldWorkload;

        let persistent_storage_replication_factor_tooltip = 'Persistent storage replication. Default: 3';
        if (currentTabObject["@SolutionType"] === Constants.CAAS_) {
            persistent_storage_replication_factor_tooltip = 'Persistent storage replication. Default: 1';
        }

        const isEOLWorkloadLoaded = this.props.workload && this.props.workload.UserInputs.EOLServer && this.props.workload.UserInputs.EOLServer === 'yes';
        return (
            <Box pad='small' margin='none' style={{ position: 'relative', width: '100%' }}>
                {displayTabs ?
                    <Box>
                        <DisplayTabs checkBoxDisplay={Constants.BLOCK_} />
                        <Box>
                            <Box style={{ width: '11%', marginBottom: '5px' }}><CheckBox label="Add Service" checked={isCurrentTabChecked} onChange={() => { this.onCheckBoxChange(currentTabObject["@SolutionType"]) }} style={{}} /></Box>
                        </Box>
                    </Box>
                    :
                    ''}
                <Article id="scroll" full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '95%', display: displayContent }} justify='between' >
                    {loadedOldSolution ?
                        <Box size='xlarge' direction='row' margin='none' pad='small' style={{ backgroundColor: 'yellow' }}>
                            <WarningIcon size='small' margin='small' type='status' />
                            <Label style={{ marginLeft: '10px' }} size='medium' margin='none'>{OLDWL_TEXT}</Label>
                        </Box> : null}
                    {isEOLWorkloadLoaded ?
                        <Box size='xlarge' direction='row' margin='none' pad='small' style={{ backgroundColor: 'yellow' }}>
                            <WarningIcon size='small' margin='small' type='status' />
                            <Label style={{ marginLeft: '10px' }} size='medium' margin='none'>{EOL_WORKLOAD_MESSAGE}</Label>
                        </Box> : ''}
                    <Warning message={Constants.HPECP_WARNING_MESSAGE} isEnabled={this.props.ConfigButton} history={this.props.history} />
                    <ReactTooltip place="right" multiline={true} />
                    <Box margin="none" pad={{ between: 'small' }} style={{ marginRight: '10px' }}>
                        <Box margin="none" pad="small" style={{ padding: '0px' }} >
                            <Box direction="row">
                                <Box><Heading tag='h5' strong={true} margin='small' style={{ marginTop: '0px' }}>{HPECPWorkloadRequirementsHeading}</Heading></Box>
                            </Box>
                            <Box separator="all" margin='none' pad={{ between: 'small' }} style={{ padding: '10px' }}>
                                <Box style={{ width: '15%', marginBottom: '5px', display: MLOpsContent }}>
                                    <CheckBox id={Constants.MLOPS_TEMPLATES} label={<Heading tag="h6" strong={true} style={{ marginBottom: '6px' }}>{Constants.MLOPS_TEMPLATES}</Heading>} checked={this.state.MLOpsTemplatesCheckBox} onChange={this.MLOpsCheckBoxChange} />
                                </Box>
                                {currentTabObject["@SolutionType"] !== Constants.MLOPS || (currentTabObject["@SolutionType"] === Constants.MLOPS && this.state.MLOpsTemplatesCheckBox) ?
                                    <Box pad={{ between: 'small' }}>
                                        <Box direction="row" margin='none' pad={{ between: 'small' }} style={{ width: '100%' }} >
                                            <Box direction="row" style={{ width: Constants.configurationWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}> Configuration Type</Heading>
                                                <CircleInformationIcon data-tip={ConfigTypeToolTip} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.templateWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}> Select Workload Template</Heading>
                                                <CircleInformationIcon data-tip={Constants.SelectWorkloadTemp} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.clustersWidth }}>
                                                <Heading tag='h5' strong={true}>{virtualClustersLabel}</Heading>
                                                <CircleInformationIcon data-tip={virtualClusterstoolTip} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 10px 0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.nodesPerClusterWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}>{virtualNodesLabel}</Heading>
                                                <CircleInformationIcon data-tip={virtualNodestoolTip} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 10px 0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.coresWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}>{cpuCoresLabel}</Heading>
                                                <CircleInformationIcon data-tip={cpuCorestoolTip} colorIndex="accent-3" data-for="cores" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 10px 0px 5px' }} />
                                                <ReactTooltip place="right" type="dark" effect="solid" id='cores'></ReactTooltip>
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.memoryWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}>{memoryLabel}</Heading>
                                                <CircleInformationIcon data-tip={memorytoolTip} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 10px 0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.EphemeralStorageWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}>{nodeStorageLabel}</Heading>
                                                <CircleInformationIcon data-tip={nodeStoragetoolTip} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 10px 0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.persistentStorageWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}>{persistentStorageLabel}</Heading>
                                                <CircleInformationIcon data-tip={persistentStoragetoolTip} colorIndex="accent-3" style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 10px 0px 5px' }} />
                                            </Box>
                                            <Box direction="row" style={{ width: Constants.GPUsWidth }}>
                                                <Heading tag='h5' strong={true} style={{ width: "maxContent" }}>{gpusLabel}</Heading>
                                                <CircleInformationIcon data-tip={gpustoolTip} colorIndex="accent-3" data-for={gpusLabel} style={{ width: "17px", height: "20px", position: 'relative', margin: '0px 0px 0px 5px' }} />
                                                <ReactTooltip place="left" multiline={true} type="dark" effect="solid" id={gpusLabel} />
                                            </Box>
                                        </Box>
                                        {this.renderTemplates()}
                                        {deleteTemplateConfirmation}
                                    </Box>
                                    : ''}
                            </Box>
                            {currentTabObject["@SolutionType"] !== Constants.MLOPS || (currentTabObject["@SolutionType"] === Constants.MLOPS && this.state.MLOpsTemplatesCheckBox) ?
                                <Box>
                                    <Heading tag='h5' strong={true} margin='small' style={{ marginTop: '10px', display: totaldisplay }}>Total Virtual Configurations</Heading>
                                    <Box separator="all" margin='5px' pad={{ between: 'small' }} style={{ padding: '15px', paddingBottom: "0px", display: totaldisplay }}>
                                        <Box direction="row" pad={{ between: 'small' }} style={{ display: displynonvalidate }}>
                                            <Heading tag='h5' style={{ width: '26%', fontWeight: '600', marginRight: '0px' }} >{nonGPUTotalsLabel}</Heading>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px' }}> Cores :</Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.NonGPUValue.TotalCore}  </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |  Memory : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.NonGPUValue.TotalVMemory} GB  </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |  Storage : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.NonGPUValue.TotalStorage} TB  </Paragraph>
                                        </Box>
                                        <Box direction="row" pad={{ between: 'small' }} style={{ display: GPUDisplay }}>
                                            <Heading tag='h5' style={{ width: '26%', fontWeight: '600', marginRight: '0px' }}>{GPUTotalsLabel}</Heading>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px' }}> Cores :</Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.GPUValue.TotalCore}  </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |  Memory : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.GPUValue.TotalVMemory} GB  </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |   Storage : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.GPUValue.TotalStorage} TB </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |   GPUs : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{totalgpus}  </Paragraph>
                                        </Box>
                                        <Box direction="row" pad={{ between: 'small' }} style={{ display: displayStorageTotals }}>
                                            <Heading tag='h5' style={{ width: '26%', fontWeight: '600', marginRight: '0px' }} >Storage Hosts Totals :</Heading>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px' }}> Cores :</Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.StorageValue.TotalCore}  </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |  Memory : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.StorageValue.TotalVMemory} GB  </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '450', paddingTop: '0px', paddingLeft: '5px' }}> |  Node Storage : </Paragraph>
                                            <Paragraph className='DesignrequirementsPara' style={{ color: 'black', margin: "0px", fontWeight: '600', paddingTop: '0px', paddingLeft: '5px' }}>{this.props.StorageValue.TotalStorage} TB  </Paragraph>
                                        </Box>
                                    </Box>
                                </Box>
                                : ''}
                            {currentTabObject["@SolutionType"] === Constants.MLOPS ?
                                <Box separator="all" pad={{ between: 'small' }} style={{ marginTop: '5px', padding: '10px' }}>
                                    <Box style={{ width: '20%', marginBottom: '5px', marginTop: '10px', display: MLOpsContent }}>
                                        <CheckBox id={Constants.MLOPS_IMAGE_PROCESSING} label={<Heading tag="h6" strong={true} style={{ marginBottom: '6px' }}>{Constants.MLOPS_IMAGE_PROCESSING}</Heading>} checked={this.state.MLOpsImageProcessingCheckBox} onChange={this.MLOpsCheckBoxChange} />
                                    </Box>
                                    {this.state.MLOpsImageProcessingCheckBox ?
                                        <Box pad={{ between: 'small' }}>
                                            <ReactTooltip place="right" multiline={true} />
                                            <Box direction="row" pad={{ between: 'small' }} style={{ width: '100%' }}>
                                                {this.renderImageProcessingUI(Constants.INFERENCE_, inferenceGPUOptions)}
                                            </Box>
                                            <Box direction="row" pad={{ between: 'small' }}>
                                                {this.renderImageProcessingUI(Constants.TRAINING, trainingGPUOptions)}
                                            </Box>
                                        </Box>
                                        : ''}
                                </Box>
                                : ''}
                            <Box margin='none' pad={{ between: 'small' }} style={{ paddingTop: '30px' }}  >
                                <Heading tag='h5' strong={true} margin='small' style={{ marginTop: '0px' }}>{HPECPRequirementsHeading}</Heading>
                                <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px' }} >
                                    <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                        <FormField className="DiskCapacityDetails" style={{ width: "33%" }} label={<Box direction='row' style={{ height: '25px' }}>
                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px" }}>Persistent Storage TB</Paragraph>
                                            <CircleInformationIcon data-tip="Enter the total persistent storage required in TB on the HPE Ezmeral Runtime Enterprise (Calculating 1TB = 1024GB, value rounded up)" e colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                        </Box>}>
                                            <TextInput id='DiskCapacity'
                                                value={HDFSTenatStr} onDOMChange={(e) => this.Requirementstextchange(e, "HDFSTenatStr", "Change")} onBlur={(e) => this.Requirementstextchange(e, "HDFSTenatStr", "Blur")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" style={{ width: "33%", display: HDFSDisplay }} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Persistent Storage Replication Factor</Paragraph>
                                            <CircleInformationIcon data-tip={persistent_storage_replication_factor_tooltip} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Box direction="row " >
                                                <TextInput id='Compression' disabled={true}
                                                    value={HDFSrepFac} onDOMChange={(e) => this.Requirementstextchange(e, "HDFSrepFac", "Change")} onBlur={(e) => this.Requirementstextchange(e, "HDFSrepFac", "Blur")} />
                                            </Box>
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" style={{ width: "33%" }} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>vCPU to Physical Core ratio</Paragraph>
                                            <CircleInformationIcon data-tip='Enter the virtual CPU to physical core ratio. The CPU allocation ratio defines how many node vCPUs map to a physical CPU. By default, HPE Ezmeral Runtime Enterprise assumes a vCPU allocation ratio of 1 to 1.' data-for='vCPUtoPhyCore' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                            <ReactTooltip place="right" type="dark" effect="solid" id='vCPUtoPhyCore'></ReactTooltip>

                                        </Box>}>
                                            <Box direction="row " >
                                                <TextInput id='Compression'
                                                    value={Allocationratio} onDOMChange={(e) => this.Requirementstextchange(e, "Allocationratio", "Change")} onBlur={(e) => this.Requirementstextchange(e, "Allocationratio", "Blur")} />
                                            </Box>
                                        </FormField>{overallConfigType === Constants.KUBERNETES_ ?
                                            <FormField className="DiskCapacityDetails" style={{ width: "33%" }} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Number of Kubernetes Cluster(s)</Paragraph>
                                                <CircleInformationIcon data-tip='Enter the number of Kubernetes Clusters within the range 1-20 in the solution. The core/memory/storage calculated from the workload template is calculated as one unit. The value in this field is multiplied with that unit. The default is 1.' data-for="NoofKubClusters" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                <ReactTooltip place="top" type="dark" effect="solid" id='NoofKubClusters' />
                                            </Box>}>
                                                <TextInput id='KubClusters'
                                                    value={KubClusters} onDOMChange={(e) => this.Requirementstextchange(e, "KubClusters", "Change")} onBlur={(e) => this.Requirementstextchange(e, "KubClusters", "Blur")} />
                                            </FormField> : ''
                                        }
                                    </Box>
                                    {persistentStorageText}
                                    <Box direction='row' margin='none' pad={{ between: 'small' }}  >
                                        <ReactTooltip place="right" multiline={true} />
                                        <CheckBox label={<Box direction='row' style={{ height: '25px' }}><Paragraph className={Constants.HARDWARELICENSE_PARAGRAPH_CLASSNAME} style={{ margin: "0px", }}>Include High Availability</Paragraph>
                                            <CircleInformationIcon data-tip={Constants.INCLUDE_HA_TOOLTIP} colorIndex={Constants.INFOICON_COLORINDEX} style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ padding: '10px' }} checked={HAIncluded} onChange={() => { this.ChkboxChange(true, true) }} />
                                        {currentTabObject["@SolutionType"] !== Constants.CAAS_ ?
                                            <CheckBox label={<Box direction="row"><Paragraph className={Constants.HARDWARELICENSE_PARAGRAPH_CLASSNAME} style={{ margin: "0px" }}>Separate Storage Hosts</Paragraph>
                                                <CircleInformationIcon data-tip={Constants.SEPARATE_STORAGE_HOSTS_TOOLTIP} style={{ height: "20px" }} colorIndex={Constants.INFOICON_COLORINDEX} /></Box>} disabled={storageHostsCheckBoxDisabled} checked={storageHostChecked} onChange={() => { this.storageHostCheckBoxchange() }} />
                                            : ''
                                            // <CheckBox label={<Box direction="row"><Paragraph className={Constants.HARDWARELICENSE_PARAGRAPH_CLASSNAME} style={{ margin: "0px" }}>Hide Gateway Hosts</Paragraph>
                                            //     <CircleInformationIcon data-tip={Constants.SEPARATE_STORAGE_HOSTS_TOOLTIP} style={{ height: "20px" }} colorIndex={Constants.INFOICON_COLORINDEX} /></Box>} checked={hideGatewayHostChecked} onChange={() => { this.hideGatewayHostCheckBoxchange() }} />
                                        }
                                    </Box>
                                    <Box direction="row" style={{ justifyContent: "space-between" }}>
                                        <FormField className="DiskCapacityDetails" style={{ width: '25%', height: '75px', marginBottom: configurationMargin }} label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px" }}>Configure Based on</Paragraph></Box>}>
                                            <Select value={configurationType} options={Constants.CONFIGURATION_OPTIONS} onChange={(e) => { this.onConfigurationChange(e) }} />
                                        </FormField>
                                        <Box margin="none" pad={{ between: "small" }} style={{ width: '40%' }}>
                                            <Box direction='row' margin="none" pad="none" style={{ width: '100%' }}>
                                                {Recomdbutn}
                                                <CircleInformationIcon data-tip={CalcButtonToolTip} colorIndex="accent-3" style={{ marginTop: '10px', marginLeft: '5px' }} />
                                            </Box>
                                            <Paragraph style={{ display: notedispaly, margin: '0px 0px 0px 40px' }}>Note: Click on 'Calculate Sizer Recommendation' button for sizer recommendations.</Paragraph>
                                        </Box>
                                    </Box>

                                </Box>
                            </Box>
                            {Loadinginitialdata}
                            {Loadingdata}
                            {Houstcountdata}
                            {ErrorPopup}
                            {HostChangedLayer}
                            {/* {noteTextforLoadingOldSolutions} */}
                            <Box margin='none' pad={{ between: 'small' }} style={{ paddingTop: '30px', display: displynonvalidate }} >
                                <Heading tag='h5' strong={true} margin='small' style={{ marginTop: '0px', display: NonGPUDisplay }}>{NonGPURoleName}</Heading>
                                <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px' }} >
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the server model desired' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select value={ComptNodeType} options={ComptNodeList} onChange={(e) => this.GPUChange(e, "ComptNodeType", "nonGPU")} />
                                        </FormField>
                                        {
                                            NonGPUProcFamilyType != 'NA' ?
                                                <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor family</Paragraph>
                                                    <CircleInformationIcon data-tip='Select the processor family desired.' colorIndex="accent-3" data-for="procfamily" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                    <ReactTooltip place="right" type="dark" effect="solid" id='procfamily'></ReactTooltip>
                                                </Box>} >
                                                    <Select id='DiskCapacity'
                                                        value={NonGPUProcFamilyType} options={NonGPUProcFamilyList} onChange={(e) => this.GPUChange(e, "NonGPUProcFamilyType", "nonGPU")} />
                                                </FormField> : ''
                                        }
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the processor type based on the processor family requested.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                            <Select id='DiskCapacity'
                                                value={NonGPUProcType} options={NonGPUProcList} onChange={(e) => this.GPUChange(e, "NonGPUProcType", "nonGPU")} />
                                        </FormField>
                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Memory</Paragraph>
                                            <CircleInformationIcon data-tip='Select the amount of memory desired per server.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}  >
                                            <Select id='DiskCapacity'
                                                value={NonGPUMemory} options={NonGPUMemoryList} onChange={(e) => this.GPUChange(e, "NonGPUMemory", "nonGPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}>
                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.EPHEMERAL_STORAGE_DRIVE}</Paragraph>
                                            <CircleInformationIcon data-tip='Select the ephemeral storage drive size desired..' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                        </Box>}  >
                                            <Select id='DiskCapacity'
                                                value={NonGPUStrDrivetype} options={NonGPUStrDrivetypeList} onChange={(e) => this.GPUChange(e, "NonGPUStrDrivetype", "nonGPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={Constants.EPHEMERAL_STORAGE_DTIVE_QUANTITY}>
                                            <TextInput value={NonGPUNodeStorageDriveQuantity} disabled={false} onDOMChange={(e) => this.GPUtextchange(e, "NonGPUNodeStorageDriveQuantity", "Change")} onBlur={(e) => this.GPUtextchange(e, "NonGPUNodeStorageDriveQuantity", "Blur")} />
                                        </FormField>
                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>OS Drive</Paragraph>
                                            <CircleInformationIcon data-tip='Select the operating system drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} >
                                            <Select id='DiskCapacity'
                                                value={NonGPUOSDrive} options={NonGPUOSDriveList} onChange={(e) => this.GPUChange(e, "NonGPUOSDrive", "nonGPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}>
                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Persistent Drive</Paragraph>
                                            <CircleInformationIcon data-tip='Select the persistent drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                        </Box>}>
                                            <Select value={NonGPUTenantStoragedrive} options={NonGPUTenantStoragedrivelist} onChange={(e) => this.GPUChange(e, "NonGPUTenantStoragedrive", "nonGPU", "Change")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label="Persistent Drive Quantity">
                                            <TextInput value={NonGPUTenantStorageDriveQuantity} disabled={true} onDOMChange={(e) => this.GPUtextchange(e, "NonGPUTenantStorageDriveQuantity", "Change")} onBlur={(e) => this.GPUtextchange(e, "NonGPUTenantStorageDriveQuantity", "Blur")} />
                                        </FormField>
                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        {GPUTypeinComputeNode ?
                                            <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>GPU Type</Paragraph>
                                                <CircleInformationIcon data-tip='Select the GPU type desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33%' }}>
                                                <Select id='DiskCapacity'
                                                    value={computeGPUType} options={computeGPUTypeOptions} /*onChange={(e) => {this.computeGPUTypeChange(e)}}*/ />
                                            </FormField> : ''}
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host Count</Paragraph>
                                            <CircleInformationIcon data-tip='The number of servers required to meet the workload requirements, based on the CPU, Memory, and drives selected.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: "33%" }}>
                                            <TextInput value={NonGPUNodeCount} disabled={false} onDOMChange={(e) => this.GPUtextchange(e, "NonGPUNodeCount", "Change")} onBlur={(e) => this.GPUtextchange(e, "NonGPUNodeCount", "Blur")} />
                                        </FormField>
                                    </Box>
                                    {nonGPUNoteText}
                                    <Box>
                                        {commonConstants.DisplayPrice &&
                                            <Paragraph style={{ display: displayNonGPUCost, margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}><Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", marginRight: '5px' }}>Approx. Configuration            Cost</Paragraph>
                                                <CircleInformationIcon data-tip='This is an approximate configuration cost. Please refer BOM Details for the actual Bill of Materials and Cost.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginRight: '3px' }} />: {nonGPUCost}</Box></Paragraph>}
                                        <Box style={{ display: nonGPURecommendationDisplay }}>
                                            <Paragraph style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Sizer Recommendation:</Paragraph>
                                            <Paragraph style={{ margin: "0px", paddingLeft: "20px", fontWeight: '600', paddingTop: '0px', maxWidth: '100%' }}>{this.props.NonGPUValue.Server} / {this.props.NonGPUValue.Proc} / {this.props.NonGPUValue.Memory} / {this.props.NonGPUValue.Drive} / {this.props.NonGPUValue.ServerQty} - Hosts </Paragraph>
                                        </Box>
                                    </Box>
                                </Box>

                            </Box>
                            <Box margin='none' pad={{ between: 'small' }} style={{ paddingTop: '30px', display: GPUDisplay }} >
                                <Heading tag='h5' strong={true} margin='small' style={{ marginTop: '0px' }}>{GPURoleName}</Heading>
                                <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px' }} >
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}   >
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the server model desired. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select value={GPUNodeType} options={GPUNodeList} onChange={(e) => this.GPUChange(e, "GPUNodeType", "GPU")} />
                                        </FormField>
                                        {
                                            GPUProcFamilyType != 'NA' ?
                                                <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor family</Paragraph>
                                                    <CircleInformationIcon data-tip='Select the processor family desired.' data-for="procfamilygpu" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                    <ReactTooltip place="right" type="dark" effect="solid" id='procfamilygpu'></ReactTooltip>
                                                </Box>}>
                                                    <Select id='DiskCapacity'
                                                        value={GPUProcFamilyType} options={GPUProcFamilyList} onChange={(e) => this.GPUChange(e, "GPUProcFamilyType", "GPU")} />
                                                </FormField> : ''
                                        }
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the processor type based on the processor family requested.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity'
                                                value={GPUProcType} options={GPUProcList} onChange={(e) => this.GPUChange(e, "GPUProcType", "GPU")} />
                                        </FormField>
                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Memory</Paragraph>
                                            <CircleInformationIcon data-tip='Select the amount of memory desired per server.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity'
                                                value={GPUMemory} options={GPUMemoryList} onChange={(e) => this.GPUChange(e, "GPUMemory", "GPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}>
                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.EPHEMERAL_STORAGE_DRIVE}</Paragraph>
                                            <CircleInformationIcon data-tip='Select the ephemeral storage drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                        </Box>}>
                                            <Select id='DiskCapacity'
                                                value={GPUStrDrivetype} options={GPUStrDrivetypeList} onChange={(e) => this.GPUChange(e, "GPUStrDrivetype", "GPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={Constants.EPHEMERAL_STORAGE_DTIVE_QUANTITY}>
                                            <TextInput value={GPUNodeStorageDriveQuantity} disabled={false} onDOMChange={(e) => this.GPUtextchange(e, "GPUNodeStorageDriveQuantity", "Change")} onBlur={(e) => this.GPUtextchange(e, "GPUNodeStorageDriveQuantity", "Blur")} />
                                        </FormField>


                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>OS Drive</Paragraph>
                                            <CircleInformationIcon data-tip='Select the operating system drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity'
                                                value={GPUOSDrive} options={GPUOSDriveList} onChange={(e) => this.GPUChange(e, "GPUOSDrive", "GPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}>
                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Persistent Drive</Paragraph>
                                            <CircleInformationIcon data-tip='Select the persistent drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                        </Box>}>
                                            <Select id='DiskCapacity'
                                                value={GPUTenantStoragedrive} options={GPUTenantStoragedrivelist} onChange={(e) => this.GPUChange(e, "GPUTenantStoragedrive", "GPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label="Persistent Drive Quantity">
                                            <TextInput value={GPUTenantStorageDriveQuantity} disabled={true} onDOMChange={(e) => this.GPUtextchange(e, "GPUTenantStorageDriveQuantity", "Change")} onBlur={(e) => this.GPUtextchange(e, "GPUTenantStorageDriveQuantity", "Blur")} />
                                        </FormField>
                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>GPU Type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the GPU type desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33.33%' }}>
                                            <Select id='DiskCapacity'
                                                value={GPUType} options={EPICGPUlist} onChange={(e) => this.GPUChange(e, "GPUType", "GPU")} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host  Count</Paragraph>
                                            <CircleInformationIcon data-tip='The number of servers required to meet the workload requirements, based on the CPU, Memory, and drives selected.  ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '22%' }}>
                                            <TextInput value={GPUNodeCoount} disabled={false} onDOMChange={(e) => this.GPUtextchange(e, "GPUNodeCoount", "Change")} onBlur={(e) => this.GPUtextchange(e, "GPUNodeCoount", "Blur")} />
                                        </FormField>
                                        {
                                            trainingGPUcount != '0' ?
                                                <FormField className="DiskCapacityDetails" label={'Max ' + maxGPUCount + ' GPU(s) per server'} style={{ width: '22%' }}>
                                                    <Select id='DiskCapacity'
                                                        value={GPUCount} options={GPUcountList} onChange={(e) => this.GPUChange(e, "GPUCount", "GPU")} />
                                                </FormField> : ''
                                        }
                                        <FormField className="DiskCapacityDetails" label='No. of GPUs' style={{ width: '22%' }}>
                                            <TextInput value={totalgpus} disabled={true} />
                                        </FormField>

                                    </Box>
                                    {GPUNoteText}
                                    <Box>
                                        {commonConstants.DisplayPrice &&
                                            <Paragraph style={{ display: displayGPUCost, margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}><Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", marginRight: '5px' }}>Approx. Configuration            Cost</Paragraph>
                                                <CircleInformationIcon data-tip='This is an approximate configuration cost. Please refer BOM Details for the actual Bill of Materials and Cost.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginRight: '3px' }} />: {GPUCost}</Box></Paragraph>}
                                        <Box style={{ display: GPURecommendationDisplay }}>
                                            <Paragraph style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Sizer Recommendation:</Paragraph>
                                            <Paragraph style={{ margin: "0px", paddingLeft: "20px", fontWeight: '600', paddingTop: '0px', maxWidth: '100%' }}>{this.props.GPUValue.Server} / {this.props.GPUValue.Proc} / {this.props.GPUValue.Memory} / {this.props.GPUValue.Drive} / {this.props.GPUValue.ServerQty} - Hosts</Paragraph>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box margin='none' pad={{ between: 'small' }} style={{ paddingTop: '30px', display: storageDisplay }}>
                                <Heading tag='h5' strong={true} margin='small' style={{ marginTop: '0px' }}>Storage Hosts</Heading>
                                <Box margin='none' pad={{ between: 'small' }} separator="all" style={{ padding: '15px' }} >
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}   >
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the server model desired. ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select value={storageNodeType} options={STORAGE_HOST_OPTIONS} onChange={(e) => this.GPUChange(e, Constants.STORAGE_NODE_TYPE, Constants.STORAGE_)} />
                                        </FormField>
                                        {
                                            storageProcFamilyType != 'NA' ?
                                                <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor family</Paragraph>
                                                    <CircleInformationIcon data-tip='Select the processor family desired.' data-for="procfamilygpu" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                                    <ReactTooltip place="right" type="dark" effect="solid" id='procfamilygpu'></ReactTooltip>
                                                </Box>}>
                                                    <Select id='DiskCapacity'
                                                        value={storageProcFamilyType} options={STORAGE_PROCESSORFAMILY_OPTIONS} onChange={(e) => this.GPUChange(e, Constants.STORAGE_PROCESSOR_FAMILY, Constants.STORAGE_)} />
                                                </FormField> : ''
                                        }
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Processor type</Paragraph>
                                            <CircleInformationIcon data-tip='Select the processor type based on the processor family requested.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity'
                                                value={storageProcType} options={STORAGE_PROCESSOR_OPTIONS} onChange={(e) => this.GPUChange(e, Constants.STORAGE_PROCESSOR_TYPE, Constants.STORAGE_)} />
                                        </FormField>
                                    </Box>
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Memory</Paragraph>
                                            <CircleInformationIcon data-tip='Select the amount of memory desired per server.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                                            <Select id='DiskCapacity'
                                                value={storageMemory} options={STORAGE_MEMORY_OPTIONS} onChange={(e) => this.GPUChange(e, Constants.STORAGE_MEMORY, Constants.STORAGE_)} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}>
                                            <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>{Constants.EPHEMERAL_STORAGE_DRIVE}</Paragraph>
                                            <CircleInformationIcon data-tip='Select the ephemeral storage drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                        </Box>}>
                                            <Select id='DiskCapacity'
                                                value={storageNodeDrive} options={STORAGE_NODE_DRIVE_OPTIONS} onChange={(e) => this.GPUChange(e, Constants.STORAGE_NODE_DRIVE, Constants.STORAGE_)} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={Constants.EPHEMERAL_STORAGE_DTIVE_QUANTITY}>
                                            <TextInput value={storageNodeDriveQty} disabled={false} onDOMChange={(e) => this.storageTextChange(e, Constants.STORAGE_NODE_DRIVE_QTY, Constants.CHANGE)} onBlur={(e) => this.storageTextChange(e, Constants.STORAGE_NODE_DRIVE_QTY, Constants.BLUR)} />
                                        </FormField>
                                    </Box>
                                    <DataDrive isMixedStorage={storageMixedTenantStorage} dataDriveType={this.state.storageTenantDriveType} dataDriveConsolidatedOptions={this.state.storageTenantDriveConsolidatedOptions} onDatadriveTypeChange={this.onStorageTenantDriveTypeChange} Drives={STORAGE_TENANT_DRIVE_OPTIONS} dataDiskValue={storageTenantStorageDrive} onDataDiskChange={this.GPUChange} noOfDisksValue={storageTenantDriveQuantity} onNoOfDisksChange={this.storageTextChange} onAddingDataDisk={this.addStorageTenanatDrive} renderTable={this.renderStorageTenantDriveTable} driveChangeMethodParam1={Constants.STORAGE_TENANT_DRIVE} driveQtyChangeMethodParam1={Constants.STORAGE_TENANT_DRIVE_QUANTITY} roleName={Constants.STORAGE_} enableADDButton={this.state.enableADDButton} workloadType={Constants.HPE_CP} isEPIC={this.state.EPICRadioBtn} />
                                    <Box direction="row" margin='none' pad={{ between: 'small' }}>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>OS Drive</Paragraph>
                                            <CircleInformationIcon data-tip='Select the operating system drive size desired.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '33%' }}>
                                            <Select id='DiskCapacity'
                                                value={storageOSDrive} options={STORAGE_OSDRIVE_OPTIONS} onChange={(e) => this.GPUChange(e, Constants.STORAGE_OSDRIVE, Constants.STORAGE_)} />
                                        </FormField>
                                        <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Host  Count</Paragraph>
                                            <CircleInformationIcon data-tip='The number of servers required to meet the workload requirements, based on the CPU, Memory, and drives selected.  ' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ width: '22%' }}>
                                            <TextInput value={storageNodeCount} disabled={false} onDOMChange={(e) => this.GPUtextchange(e, Constants.STORAGE_NODE_COUNT, Constants.CHANGE)} onBlur={(e) => this.GPUtextchange(e, Constants.STORAGE_NODE_COUNT, Constants.BLUR)} />
                                        </FormField>
                                    </Box>
                                    {StorageNoteText}
                                    <Box>
                                        {commonConstants.DisplayPrice &&
                                            <Paragraph style={{ display: displayStorageCost, margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}><Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", marginRight: '5px' }}>Approx. Configuration Cost</Paragraph>
                                                <CircleInformationIcon data-tip='This is an approximate configuration cost. Please refer BOM Details for the actual Bill of Materials and Cost.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginRight: '3px' }} />: {storageCost}</Box></Paragraph>}
                                        <Box style={{ display: storageRecommendationDisplay }}>
                                            <Paragraph style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Sizer Recommendation:</Paragraph>
                                            <Paragraph style={{ margin: "0px", paddingLeft: "20px", fontWeight: '600', paddingTop: '0px', maxWidth: '100%' }}>{this.props.StorageValue.Server} / {this.props.StorageValue.Proc} / {this.props.StorageValue.Memory} / {this.props.StorageValue.Drive} / {this.props.StorageValue.ServerQty} - Hosts</Paragraph>
                                        </Box>
                                    </Box>
                                    {persistentDriveNoteDisplay}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Article>
            </Box>

        );

    }
}
const mapStateToProps = (state) => {
    let tabObject = state.sizerWorkload.workload.UserInputs.Environments;
    if (Array.isArray(state.sizerWorkload.workload.UserInputs.Environments.Environment)) {
        tabObject = state.sizerWorkload.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === "yes");
    }
    let CountryTemp = state.sessions.Country;
    try{
        if(state.sizerWorkload.workload.UserInputs.Country!==CountryTemp)
          CountryTemp = state.sizerWorkload.workload.UserInputs.Country;
    }catch(e){}
    return {
        workload: state.sizerWorkload.workload,
        activeSession: state.sessions.activeSession,
        Templates: state.sizerWorkload.Templates,
        Epicreq: state.sizerWorkload.EPICRequirements,
        isLoading: state.sizerWorkload.isLoading,
        sessionsDefaults: state.sessions.sessionDefaults,
        GlobalErr: state.sessions.activeSession.globalError,
        GPUdetails: state.sizerWorkload.GPUdetails,
        NonGPUdetails: state.sizerWorkload.NonGPUdetails,
        isCal: state.sizerWorkload.isCal,
        calculateWithUpdatedTenantDrive: state.sizerWorkload.calculateWithUpdatedTenantDrive,
        currentRoleName: state.sizerWorkload.currentRoleName,
        country: CountryTemp,
        ServiceError: state.sizerWorkload,
        GPUValue: tabObject.GPUValue || state.sizerWorkload.GPUValue,
        NonGPUValue: tabObject.NonGPUValue || state.sizerWorkload.NonGPUValue,
        StorageValue: tabObject.StorageValue || state.sizerWorkload.StorageValue,
        GPUdetailsforcore: tabObject || state.sizerWorkload,
        controllerconfigChanged: state.sizerWorkload.ControllerConfigChanged,
        scroll: state.sizerWorkload.scrollsetting,
        ConfigButton: state.sizerWorkload.calbtn,
        OpenedSaveWorkload: state.sessions.Saveworkloadopened,
        calculateBlueDataAPIcount: state.sizerWorkload.calculateBlueDataAPIcount,
        sizerWorkloadforCalculation: state.sizerWorkload.sizerWorkloadforCalculation,
        gatewaydetails: state.sizerWorkload.Gatewaydetails,
        controllerdetails: state.sizerWorkload.Controllerdetails,
        masterdetails: state.sizerWorkload.Masterdetails,
        Storagedetails: state.sizerWorkload.Storagedetails,
        currentTab: state.sizerWorkload.currentTab,
        SSETid: state.sessions.SSETid,
        GPUHostCount: tabObject.HostCount || state.sizerWorkload.HostCount,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) },
        OnFetchTemplateList: () => {
            dispatch(fetchTemplateList());
        },
        EPICRequirements: (value) => {
            dispatch(onepicequirements(value));
        },
        CalculateBlueDataConfigurationtrue: (value) => {
            dispatch(oncalbluedataconfigtrue(value));
        },
        CalculateBlueDataConfigurationfalse: (value) => {
            dispatch(oncalbluedataconfigfalse(value));
        },
        OnGatewaydltsfetch: (value) => {
            dispatch(fetchgatewaydlts(value));
        },
        ErrorValidation: (value) => {
            dispatch(errorValidataion(value));
        },
        GetOSDiskList: (value) => {
            dispatch(getosdisklistBlueData(value));
        },
        ContrlChanged: (value) => {
            dispatch(controllerchnaged(value));
        },
        Errorclose: () => {
            dispatch(errorclose());
        },
        Calcbutton: (value) => {
            dispatch(Calbutn(value))
        },
        onUpdateDefaultSession: (inputs) => {
            dispatch({ type: 'UPDATE_SESSION_DEFAULTS', payload: inputs })
        },
        changeCalculateBlueDataAPIcount: (value) => { dispatch({ type: 'UPDATE_CALCULATEBLUEDATAAPICOUNT', payload: value }) },
        getTenantStorageDriveList: (value) => { dispatch(getTenantStorageDiskList(value)) },
        calculateWithUpdatedTenantDriveAction: (value) => { dispatch({ type: 'CALCULATE_WITHUPDATEDTENANTDRIVEACTION', payload: value }) },
        currentRoleNameAction: (value) => { dispatch({ type: 'CURRENT_ROLENAMEACTION', payload: value }) },
        changeCurrentTab: (value) => { dispatch({ type: 'UPDATE_SCREEN', payload: value }) },
        GatewayRecommendations: (value) => { dispatch(GetGatewayRecommendations(value)) },
        ControllerRecommendations: (value) => { dispatch(GetControllerRecommendations(value)) },
        MasterRecommendations: (value) => { dispatch(GetMasterRecommendations(value)) }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DesignRequirements);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/BlueData.js